
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j2xvW", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return browserPerformanceTimeOrigin; });

var $eJSQB = parcelRequire("eJSQB");

var $01qnz = parcelRequire("01qnz");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $01qnz.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $eJSQB.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $eJSQB.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();

});
parcelRegister("eJSQB", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });

var $fitJ8 = parcelRequire("fitJ8");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $fitJ8.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("fitJ8", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $b22f9898ca3e1a5a$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $b22f9898ca3e1a5a$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $b22f9898ca3e1a5a$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $b22f9898ca3e1a5a$export$8ad33f488b1ab046() {
    // @ts-ignore "npm" is injected by rollup during build process
    return "npm";
}

});


parcelRegister("01qnz", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $00448e7acd387ba7$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $00448e7acd387ba7$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $00448e7acd387ba7$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $00448e7acd387ba7$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $00448e7acd387ba7$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $00448e7acd387ba7$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $00448e7acd387ba7$var$isGlobalObj(window) || typeof self == 'object' && $00448e7acd387ba7$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $00448e7acd387ba7$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $00448e7acd387ba7$export$256479dc0cea61c4() {
    return $00448e7acd387ba7$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $00448e7acd387ba7$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $00448e7acd387ba7$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("7Ff5S", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $5948120e3df03b52$export$f5282963edea4a68; });
$parcel$export(module.exports, "setContext", function () { return $5948120e3df03b52$export$2f04de43fe27971a; });
$parcel$export(module.exports, "withScope", function () { return $5948120e3df03b52$export$ec58d9285c204497; });

var $qyIZA = parcelRequire("qyIZA");
var $kRbV8 = parcelRequire("kRbV8");

var $dCCRF = parcelRequire("dCCRF");
// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $5948120e3df03b52$export$f5282963edea4a68(exception, captureContext) {
    return (0, $dCCRF.getCurrentHub)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $5948120e3df03b52$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $dCCRF.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $5948120e3df03b52$export$1462b974fdcf6ba2(event, hint) {
    return (0, $dCCRF.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $5948120e3df03b52$export$99d44f04437e9cb8(callback) {
    (0, $dCCRF.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $5948120e3df03b52$export$efda9a273d7a036d(breadcrumb) {
    (0, $dCCRF.getCurrentHub)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5948120e3df03b52$export$2f04de43fe27971a(name, context) {
    (0, $dCCRF.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $5948120e3df03b52$export$bb4922da0dd51b92(extras) {
    (0, $dCCRF.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $5948120e3df03b52$export$8e8e7789d42ed61d(key, extra) {
    (0, $dCCRF.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $5948120e3df03b52$export$74a8fb34822092e6(tags) {
    (0, $dCCRF.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $5948120e3df03b52$export$a37d07ee78eb4569(key, value) {
    (0, $dCCRF.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $5948120e3df03b52$export$8b6bb3dd62a01be2(user) {
    (0, $dCCRF.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $5948120e3df03b52$export$ec58d9285c204497(callback) {
    (0, $dCCRF.getCurrentHub)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $5948120e3df03b52$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $dCCRF.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $5948120e3df03b52$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const hub = (0, $dCCRF.getCurrentHub)();
    const scope = hub.getScope();
    const client = hub.getClient();
    if (!client) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $kRbV8.uuid4)();
}

});
parcelRegister("qyIZA", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $04fd5d6bcf565b6d$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "consoleSandbox", function () { return $04fd5d6bcf565b6d$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $04fd5d6bcf565b6d$export$af88d00dbe7f521; });

var $01qnz = parcelRequire("01qnz");
/** Prefix for logging strings */ const $04fd5d6bcf565b6d$var$PREFIX = 'Sentry Logger ';
const $04fd5d6bcf565b6d$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $04fd5d6bcf565b6d$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $01qnz.GLOBAL_OBJ))) return callback();
    const originalConsole = (0, $01qnz.GLOBAL_OBJ).console;
    const wrappedLevels = {};
    // Restore all wrapped console methods
    $04fd5d6bcf565b6d$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $04fd5d6bcf565b6d$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $04fd5d6bcf565b6d$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $04fd5d6bcf565b6d$export$cda52e2a8927a2ca(()=>{
                (0, $01qnz.GLOBAL_OBJ).console[name](`${$04fd5d6bcf565b6d$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $04fd5d6bcf565b6d$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $04fd5d6bcf565b6d$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $04fd5d6bcf565b6d$export$af88d00dbe7f521 = (0, $01qnz.getGlobalSingleton)('logger', $04fd5d6bcf565b6d$var$makeLogger);
else $04fd5d6bcf565b6d$export$af88d00dbe7f521 = $04fd5d6bcf565b6d$var$makeLogger();

});

parcelRegister("kRbV8", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $f2f20111ec1ce83d$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $f2f20111ec1ce83d$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $f2f20111ec1ce83d$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $f2f20111ec1ce83d$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $f2f20111ec1ce83d$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $f2f20111ec1ce83d$export$3131421a7d01b4fb; });

var $9rzL4 = parcelRequire("9rzL4");

var $hnodz = parcelRequire("hnodz");

var $01qnz = parcelRequire("01qnz");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $f2f20111ec1ce83d$export$19f53698e68b2496() {
    const gbl = (0, $01qnz.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    const getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $f2f20111ec1ce83d$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $f2f20111ec1ce83d$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $f2f20111ec1ce83d$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $f2f20111ec1ce83d$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $f2f20111ec1ce83d$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $f2f20111ec1ce83d$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $f2f20111ec1ce83d$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $f2f20111ec1ce83d$export$d364f2020ab30578(input) {
    const match = input.match($f2f20111ec1ce83d$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $f2f20111ec1ce83d$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $hnodz.snipLine)(line, 0));
    frame.context_line = (0, $hnodz.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $hnodz.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $f2f20111ec1ce83d$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $9rzL4.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $f2f20111ec1ce83d$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("9rzL4", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $6e025f86a7515bac$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $6e025f86a7515bac$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $6e025f86a7515bac$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $6e025f86a7515bac$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $6e025f86a7515bac$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $6e025f86a7515bac$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $6e025f86a7515bac$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $6e025f86a7515bac$export$d25f2688db1bb433; });

var $iR5Fj = parcelRequire("iR5Fj");

var $iLldo = parcelRequire("iLldo");

var $hnodz = parcelRequire("hnodz");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $6e025f86a7515bac$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $6e025f86a7515bac$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $6e025f86a7515bac$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $6e025f86a7515bac$export$5c1499e2e5d010ae(wrapped, original) {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $6e025f86a7515bac$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $6e025f86a7515bac$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $6e025f86a7515bac$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $6e025f86a7515bac$export$62ff257738bf57f5(value) {
    if ((0, $iLldo.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$6e025f86a7515bac$var$getOwnProperties(value)
    };
    else if ((0, $iLldo.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $6e025f86a7515bac$var$serializeEventTarget(value.target),
            currentTarget: $6e025f86a7515bac$var$serializeEventTarget(value.currentTarget),
            ...$6e025f86a7515bac$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $iLldo.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $6e025f86a7515bac$var$serializeEventTarget(target) {
    try {
        return (0, $iLldo.isElement)(target) ? (0, $iR5Fj.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $6e025f86a7515bac$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $6e025f86a7515bac$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($6e025f86a7515bac$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $hnodz.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hnodz.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $6e025f86a7515bac$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $6e025f86a7515bac$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $6e025f86a7515bac$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $iLldo.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $6e025f86a7515bac$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($6e025f86a7515bac$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $6e025f86a7515bac$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $iLldo.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("iR5Fj", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $dba192447439e5f0$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $dba192447439e5f0$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $dba192447439e5f0$export$c660c1f3ab49225c; });

var $iLldo = parcelRequire("iLldo");

var $01qnz = parcelRequire("01qnz");
// eslint-disable-next-line deprecation/deprecation
const $dba192447439e5f0$var$WINDOW = (0, $01qnz.getGlobalObject)();
const $dba192447439e5f0$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $dba192447439e5f0$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $dba192447439e5f0$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $dba192447439e5f0$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $dba192447439e5f0$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $iLldo.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $dba192447439e5f0$export$1cfafeee2987818b() {
    try {
        return $dba192447439e5f0$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dba192447439e5f0$export$c660c1f3ab49225c(selector) {
    if ($dba192447439e5f0$var$WINDOW.document && $dba192447439e5f0$var$WINDOW.document.querySelector) return $dba192447439e5f0$var$WINDOW.document.querySelector(selector);
    return null;
}

});
parcelRegister("iLldo", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $da8d12a9b13b9375$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $da8d12a9b13b9375$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $da8d12a9b13b9375$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $da8d12a9b13b9375$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $da8d12a9b13b9375$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $da8d12a9b13b9375$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $da8d12a9b13b9375$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $da8d12a9b13b9375$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $da8d12a9b13b9375$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $da8d12a9b13b9375$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $da8d12a9b13b9375$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $da8d12a9b13b9375$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $da8d12a9b13b9375$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $da8d12a9b13b9375$export$c9f5652083b8129d; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $da8d12a9b13b9375$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$e6127cc7fe7395c3(wat) {
    switch($da8d12a9b13b9375$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $da8d12a9b13b9375$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$var$isBuiltin(wat, className) {
    return $da8d12a9b13b9375$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$9f9636d330b71954(wat) {
    return $da8d12a9b13b9375$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$ef9e2056653f0c8e(wat) {
    return $da8d12a9b13b9375$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$12e869b2a583f783(wat) {
    return $da8d12a9b13b9375$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$844ec244b1367d54(wat) {
    return $da8d12a9b13b9375$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$53b83ca8eaab0383(wat) {
    return $da8d12a9b13b9375$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $da8d12a9b13b9375$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $da8d12a9b13b9375$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$49841c62b9eff15(wat) {
    return $da8d12a9b13b9375$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $da8d12a9b13b9375$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$bc2894c7158efbac(wat) {
    return $da8d12a9b13b9375$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $da8d12a9b13b9375$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("hnodz", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $ca675ed651eee154$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $ca675ed651eee154$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $ca675ed651eee154$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $ca675ed651eee154$export$a7a5ec66062ea5d; });

var $iLldo = parcelRequire("iLldo");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $ca675ed651eee154$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $ca675ed651eee154$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca675ed651eee154$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $ca675ed651eee154$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $iLldo.isString)(value)) return false;
    if ((0, $iLldo.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $iLldo.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $ca675ed651eee154$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$ca675ed651eee154$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("dCCRF", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $9eacf8a60661f880$export$19eade501500c6c1; });
$parcel$export(module.exports, "getCurrentHub", function () { return $9eacf8a60661f880$export$a07cdf6544bbd7c; });

var $qyIZA = parcelRequire("qyIZA");
var $j2xvW = parcelRequire("j2xvW");
var $01qnz = parcelRequire("01qnz");
var $kRbV8 = parcelRequire("kRbV8");

var $gqkOp = parcelRequire("gqkOp");

var $7bmu9 = parcelRequire("7bmu9");

var $fU49Z = parcelRequire("fU49Z");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9eacf8a60661f880$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9eacf8a60661f880$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $9eacf8a60661f880$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $7bmu9.Scope)(), _version = $9eacf8a60661f880$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $7bmu9.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $kRbV8.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $kRbV8.uuid4)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kRbV8.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9eacf8a60661f880$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $j2xvW.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $qyIZA.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $9eacf8a60661f880$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $9eacf8a60661f880$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) // eslint-disable-next-line no-console
        console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        return result;
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $fU49Z.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $gqkOp.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $01qnz.GLOBAL_OBJ).navigator || {};
        const session = (0, $fU49Z.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $fU49Z.updateSession)(currentSession, {
            status: 'exited'
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9eacf8a60661f880$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9eacf8a60661f880$export$19eade501500c6c1() {
    (0, $01qnz.GLOBAL_OBJ).__SENTRY__ = (0, $01qnz.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $01qnz.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $9eacf8a60661f880$export$4188a14ad302d1bc(hub) {
    const registry = $9eacf8a60661f880$export$19eade501500c6c1();
    const oldHub = $9eacf8a60661f880$export$bfa8a924a84a76b7(registry);
    $9eacf8a60661f880$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $9eacf8a60661f880$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9eacf8a60661f880$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9eacf8a60661f880$var$getGlobalHub(registry);
}
function $9eacf8a60661f880$var$getGlobalHub(registry = $9eacf8a60661f880$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9eacf8a60661f880$var$hasHubOnCarrier(registry) || $9eacf8a60661f880$export$bfa8a924a84a76b7(registry).isOlderThan($9eacf8a60661f880$export$24a86ef7798177e4)) $9eacf8a60661f880$export$849f05434e95d2f2(registry, new $9eacf8a60661f880$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9eacf8a60661f880$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $9eacf8a60661f880$export$236689a79f5aa020(carrier, parent = $9eacf8a60661f880$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9eacf8a60661f880$var$hasHubOnCarrier(carrier) || $9eacf8a60661f880$export$bfa8a924a84a76b7(carrier).isOlderThan($9eacf8a60661f880$export$24a86ef7798177e4)) {
        const globalHubTopStack = parent.getStackTop();
        $9eacf8a60661f880$export$849f05434e95d2f2(carrier, new $9eacf8a60661f880$export$8c41bb232f1008b1(globalHubTopStack.client, (0, $7bmu9.Scope).clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9eacf8a60661f880$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9eacf8a60661f880$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9eacf8a60661f880$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9eacf8a60661f880$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9eacf8a60661f880$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $9eacf8a60661f880$export$bfa8a924a84a76b7(carrier) {
    return (0, $01qnz.getGlobalSingleton)('hub', ()=>new $9eacf8a60661f880$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $9eacf8a60661f880$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("gqkOp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $bf4f37e64d78f8b7$export$849dbeeeda01ae98; });
const $bf4f37e64d78f8b7$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("7bmu9", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $53ab0096f23c9994$export$775b6bb06e53a214; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $53ab0096f23c9994$export$8e4e25f54d456511; });

var $kRbV8 = parcelRequire("kRbV8");
var $j2xvW = parcelRequire("j2xvW");
var $01qnz = parcelRequire("01qnz");
var $iLldo = parcelRequire("iLldo");
var $qyIZA = parcelRequire("qyIZA");
var $gG0fI = parcelRequire("gG0fI");

var $fU49Z = parcelRequire("fU49Z");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $53ab0096f23c9994$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $53ab0096f23c9994$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $53ab0096f23c9994$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $53ab0096f23c9994$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
            newScope._propagationContext = {
                ...scope._propagationContext
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $fU49Z.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $53ab0096f23c9994$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $53ab0096f23c9994$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
            if (captureContext._propagationContext) this._propagationContext = captureContext._propagationContext;
        } else if ((0, $iLldo.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
            if (captureContext.propagationContext) this._propagationContext = captureContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $53ab0096f23c9994$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $53ab0096f23c9994$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $j2xvW.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transaction = this._span.transaction;
            if (transaction) {
                event.sdkProcessingMetadata = {
                    dynamicSamplingContext: transaction.getDynamicSamplingContext(),
                    ...event.sdkProcessingMetadata
                };
                const transactionName = transaction.name;
                if (transactionName) event.tags = {
                    transaction: transactionName,
                    ...event.tags
                };
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata,
            propagationContext: this._propagationContext
        };
        return this._notifyEventProcessors([
            ...$53ab0096f23c9994$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $gG0fI.SyncPromise)((resolve, reject)=>{
            const processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                const result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && processor.id && result === null && (0, $qyIZA.logger).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $iLldo.isThenable)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $kRbV8.arrayify)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $53ab0096f23c9994$var$getGlobalEventProcessors() {
    return (0, $01qnz.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $53ab0096f23c9994$export$8e4e25f54d456511(callback) {
    $53ab0096f23c9994$var$getGlobalEventProcessors().push(callback);
}
function $53ab0096f23c9994$var$generatePropagationContext() {
    return {
        traceId: (0, $kRbV8.uuid4)(),
        spanId: (0, $kRbV8.uuid4)().substring(16),
        sampled: false
    };
}

});
parcelRegister("gG0fI", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $c240c3b3535e8dbb$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $c240c3b3535e8dbb$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $c240c3b3535e8dbb$export$78e43115b553f358; });

var $iLldo = parcelRequire("iLldo");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $c240c3b3535e8dbb$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($c240c3b3535e8dbb$var$States || ($c240c3b3535e8dbb$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $c240c3b3535e8dbb$export$1fda8aa4d135f8aa(value) {
    return new $c240c3b3535e8dbb$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $c240c3b3535e8dbb$export$78e43115b553f358(reason) {
    return new $c240c3b3535e8dbb$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $c240c3b3535e8dbb$export$6f292d4960313241 {
    constructor(executor){
        $c240c3b3535e8dbb$export$6f292d4960313241.prototype.__init.call(this);
        $c240c3b3535e8dbb$export$6f292d4960313241.prototype.__init2.call(this);
        $c240c3b3535e8dbb$export$6f292d4960313241.prototype.__init3.call(this);
        $c240c3b3535e8dbb$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $c240c3b3535e8dbb$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $c240c3b3535e8dbb$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $c240c3b3535e8dbb$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($c240c3b3535e8dbb$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($c240c3b3535e8dbb$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $c240c3b3535e8dbb$var$States.PENDING) return;
            if ((0, $iLldo.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $c240c3b3535e8dbb$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $c240c3b3535e8dbb$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $c240c3b3535e8dbb$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});

parcelRegister("fU49Z", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $b93f501715ea5cbd$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $b93f501715ea5cbd$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $b93f501715ea5cbd$export$56521d9ba90f62ee; });

var $9rzL4 = parcelRequire("9rzL4");
var $j2xvW = parcelRequire("j2xvW");
var $kRbV8 = parcelRequire("kRbV8");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $b93f501715ea5cbd$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $j2xvW.timestampInSeconds)();
    const session = {
        sid: (0, $kRbV8.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$b93f501715ea5cbd$var$sessionToJSON(session)
    };
    if (context) $b93f501715ea5cbd$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $b93f501715ea5cbd$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $j2xvW.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $kRbV8.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $b93f501715ea5cbd$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $b93f501715ea5cbd$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $b93f501715ea5cbd$var$sessionToJSON(session) {
    return (0, $9rzL4.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});




// eslint-disable-next-line import/no-extraneous-dependencies

var $iLldo = parcelRequire("iLldo");
var $qyIZA = parcelRequire("qyIZA");

var $dCCRF = parcelRequire("dCCRF");

var $dCCRF = parcelRequire("dCCRF");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $f8973b5c64ce74f1$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}



var $iLldo = parcelRequire("iLldo");

var $qyIZA = parcelRequire("qyIZA");

var $9rzL4 = parcelRequire("9rzL4");
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $af29002e197d8809$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
            !filename.startsWith('/') && // It's not internal if it's an absolute windows path
            !filename.includes(':\\') && // It's not internal if the path is starting with a dot
            !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
            !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
            // in_app is all that's not an internal Node function or a module within node_modules
            // note that isNative appears to return true even for node core libraries
            // see https://github.com/getsentry/raven-node/issues/176
            const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: in_app
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $4cf53a7b1072c092$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $4cf53a7b1072c092$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4cf53a7b1072c092$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4cf53a7b1072c092$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4cf53a7b1072c092$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4cf53a7b1072c092$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4cf53a7b1072c092$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $4cf53a7b1072c092$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4cf53a7b1072c092$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4cf53a7b1072c092$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4cf53a7b1072c092$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4cf53a7b1072c092$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4cf53a7b1072c092$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $4cf53a7b1072c092$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $4cf53a7b1072c092$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4cf53a7b1072c092$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4cf53a7b1072c092$var$defaultFunctionName;
        return fn.name || $4cf53a7b1072c092$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4cf53a7b1072c092$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $4cf53a7b1072c092$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $af29002e197d8809$export$35059013cd4a06db)(getModule)
    ];
}



var $qyIZA = parcelRequire("qyIZA");

var $01qnz = parcelRequire("01qnz");
// eslint-disable-next-line deprecation/deprecation
const $af39801725607093$var$WINDOW = (0, $01qnz.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $af39801725607093$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $af39801725607093$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $af39801725607093$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $af39801725607093$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $af39801725607093$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $af39801725607093$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $af39801725607093$export$c82d238e23c40b21() {
    if (!$af39801725607093$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($af39801725607093$export$18cf36ed71d733e7($af39801725607093$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $af39801725607093$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $af39801725607093$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $af39801725607093$export$531055a6c684a70a() {
    return 'ReportingObserver' in $af39801725607093$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $af39801725607093$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$af39801725607093$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $01qnz = parcelRequire("01qnz");

var $01qnz = parcelRequire("01qnz");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $13320b696160ced5$var$WINDOW = (0, $01qnz.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $13320b696160ced5$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $13320b696160ced5$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $13320b696160ced5$var$WINDOW && !!$13320b696160ced5$var$WINDOW.history.pushState && !!$13320b696160ced5$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}


// eslint-disable-next-line deprecation/deprecation
const $43c97ac4136e5a2d$var$WINDOW = (0, $01qnz.getGlobalObject)();
const $43c97ac4136e5a2d$export$55b6bb1e45c6cf59 = '__sentry_xhr_v2__';
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $43c97ac4136e5a2d$var$handlers = {};
const $43c97ac4136e5a2d$var$instrumented = {};
/** Instruments given API */ function $43c97ac4136e5a2d$var$instrument(type) {
    if ($43c97ac4136e5a2d$var$instrumented[type]) return;
    $43c97ac4136e5a2d$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $43c97ac4136e5a2d$var$instrumentConsole();
            break;
        case 'dom':
            $43c97ac4136e5a2d$var$instrumentDOM();
            break;
        case 'xhr':
            $43c97ac4136e5a2d$var$instrumentXHR();
            break;
        case 'fetch':
            $43c97ac4136e5a2d$var$instrumentFetch();
            break;
        case 'history':
            $43c97ac4136e5a2d$var$instrumentHistory();
            break;
        case 'error':
            $43c97ac4136e5a2d$var$instrumentError();
            break;
        case 'unhandledrejection':
            $43c97ac4136e5a2d$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $43c97ac4136e5a2d$export$285b9172a3741fb7(type, callback) {
    $43c97ac4136e5a2d$var$handlers[type] = $43c97ac4136e5a2d$var$handlers[type] || [];
    $43c97ac4136e5a2d$var$handlers[type].push(callback);
    $43c97ac4136e5a2d$var$instrument(type);
}
/** JSDoc */ function $43c97ac4136e5a2d$var$triggerHandlers(type, data) {
    if (!type || !$43c97ac4136e5a2d$var$handlers[type]) return;
    for (const handler of $43c97ac4136e5a2d$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4cf53a7b1072c092$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $43c97ac4136e5a2d$var$instrumentConsole() {
    if (!('console' in $43c97ac4136e5a2d$var$WINDOW)) return;
    (0, $qyIZA.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $43c97ac4136e5a2d$var$WINDOW.console)) return;
        (0, $9rzL4.fill)($43c97ac4136e5a2d$var$WINDOW.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $43c97ac4136e5a2d$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($43c97ac4136e5a2d$var$WINDOW.console, args);
            };
        });
    });
}
/** JSDoc */ function $43c97ac4136e5a2d$var$instrumentFetch() {
    if (!(0, $af39801725607093$export$c82d238e23c40b21)()) return;
    (0, $9rzL4.fill)($43c97ac4136e5a2d$var$WINDOW, 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $43c97ac4136e5a2d$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $43c97ac4136e5a2d$var$triggerHandlers('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($43c97ac4136e5a2d$var$WINDOW, args).then((response)=>{
                $43c97ac4136e5a2d$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $43c97ac4136e5a2d$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $43c97ac4136e5a2d$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $43c97ac4136e5a2d$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($43c97ac4136e5a2d$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $43c97ac4136e5a2d$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $43c97ac4136e5a2d$var$getUrlFromResource(url),
            method: $43c97ac4136e5a2d$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $43c97ac4136e5a2d$var$getUrlFromResource(arg),
        method: $43c97ac4136e5a2d$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
/** JSDoc */ function $43c97ac4136e5a2d$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $43c97ac4136e5a2d$var$WINDOW)) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $9rzL4.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const url = args[1];
            const xhrInfo = this[$43c97ac4136e5a2d$export$55b6bb1e45c6cf59] = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $iLldo.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $iLldo.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$43c97ac4136e5a2d$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $43c97ac4136e5a2d$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: this
                    });
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $9rzL4.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $9rzL4.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$43c97ac4136e5a2d$export$55b6bb1e45c6cf59];
                    if (xhrInfo) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $9rzL4.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$43c97ac4136e5a2d$export$55b6bb1e45c6cf59];
            if (sentryXhrData && args[0] !== undefined) sentryXhrData.body = args[0];
            $43c97ac4136e5a2d$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $43c97ac4136e5a2d$var$lastHref;
/** JSDoc */ function $43c97ac4136e5a2d$var$instrumentHistory() {
    if (!(0, $13320b696160ced5$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $43c97ac4136e5a2d$var$WINDOW.onpopstate;
    $43c97ac4136e5a2d$var$WINDOW.onpopstate = function(...args) {
        const to = $43c97ac4136e5a2d$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $43c97ac4136e5a2d$var$lastHref;
        $43c97ac4136e5a2d$var$lastHref = to;
        $43c97ac4136e5a2d$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $43c97ac4136e5a2d$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $43c97ac4136e5a2d$var$lastHref = to;
                $43c97ac4136e5a2d$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $9rzL4.fill)($43c97ac4136e5a2d$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $9rzL4.fill)($43c97ac4136e5a2d$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}
const $43c97ac4136e5a2d$var$debounceDuration = 1000;
let $43c97ac4136e5a2d$var$debounceTimerID;
let $43c97ac4136e5a2d$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $43c97ac4136e5a2d$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $43c97ac4136e5a2d$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $43c97ac4136e5a2d$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $43c97ac4136e5a2d$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($43c97ac4136e5a2d$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($43c97ac4136e5a2d$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $43c97ac4136e5a2d$var$lastCapturedEvent = event;
        } else if ($43c97ac4136e5a2d$var$shouldShortcircuitPreviousDebounce($43c97ac4136e5a2d$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $43c97ac4136e5a2d$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($43c97ac4136e5a2d$var$debounceTimerID);
        $43c97ac4136e5a2d$var$debounceTimerID = $43c97ac4136e5a2d$var$WINDOW.setTimeout(()=>{
            $43c97ac4136e5a2d$var$debounceTimerID = undefined;
        }, $43c97ac4136e5a2d$var$debounceDuration);
    };
}
/** JSDoc */ function $43c97ac4136e5a2d$var$instrumentDOM() {
    if (!('document' in $43c97ac4136e5a2d$var$WINDOW)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $43c97ac4136e5a2d$var$triggerHandlers.bind(null, 'dom');
    const globalDOMEventHandler = $43c97ac4136e5a2d$var$makeDOMEventHandler(triggerDOMHandler, true);
    $43c97ac4136e5a2d$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $43c97ac4136e5a2d$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $43c97ac4136e5a2d$var$WINDOW[target] && $43c97ac4136e5a2d$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $9rzL4.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $43c97ac4136e5a2d$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $9rzL4.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $43c97ac4136e5a2d$var$_oldOnErrorHandler = null;
/** JSDoc */ function $43c97ac4136e5a2d$var$instrumentError() {
    $43c97ac4136e5a2d$var$_oldOnErrorHandler = $43c97ac4136e5a2d$var$WINDOW.onerror;
    $43c97ac4136e5a2d$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $43c97ac4136e5a2d$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($43c97ac4136e5a2d$var$_oldOnErrorHandler && !$43c97ac4136e5a2d$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $43c97ac4136e5a2d$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $43c97ac4136e5a2d$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let $43c97ac4136e5a2d$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $43c97ac4136e5a2d$var$instrumentUnhandledRejection() {
    $43c97ac4136e5a2d$var$_oldOnUnhandledRejectionHandler = $43c97ac4136e5a2d$var$WINDOW.onunhandledrejection;
    $43c97ac4136e5a2d$var$WINDOW.onunhandledrejection = function(e) {
        $43c97ac4136e5a2d$var$triggerHandlers('unhandledrejection', e);
        if ($43c97ac4136e5a2d$var$_oldOnUnhandledRejectionHandler && !$43c97ac4136e5a2d$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $43c97ac4136e5a2d$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $43c97ac4136e5a2d$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


var $qyIZA = parcelRequire("qyIZA");

var $dCCRF = parcelRequire("dCCRF");

/** Grabs active transaction off scope, if any */ function $ac5759207be0f50e$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $dCCRF.getCurrentHub)();
    const scope = hub.getScope();
    return scope.getTransaction();
}


let $1cd7336ab5be86ca$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $1cd7336ab5be86ca$export$637857c1d87b640c() {
    if ($1cd7336ab5be86ca$var$errorsInstrumented) return;
    $1cd7336ab5be86ca$var$errorsInstrumented = true;
    (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('error', $1cd7336ab5be86ca$var$errorCallback);
    (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('unhandledrejection', $1cd7336ab5be86ca$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $1cd7336ab5be86ca$var$errorCallback() {
    const activeTransaction = (0, $ac5759207be0f50e$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = 'internal_error';
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$1cd7336ab5be86ca$var$errorCallback.tag = 'sentry_tracingErrorCallback';



var $qyIZA = parcelRequire("qyIZA");
var $j2xvW = parcelRequire("j2xvW");

var $9rzL4 = parcelRequire("9rzL4");
var $iLldo = parcelRequire("iLldo");

var $qyIZA = parcelRequire("qyIZA");
const $e1a5b6d195c78320$export$9ca9946bd449ac06 = 'baggage';
const $e1a5b6d195c78320$export$6e69537d67fa20f = 'sentry-';
const $e1a5b6d195c78320$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $e1a5b6d195c78320$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $e1a5b6d195c78320$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $iLldo.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $e1a5b6d195c78320$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $e1a5b6d195c78320$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($e1a5b6d195c78320$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($e1a5b6d195c78320$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $e1a5b6d195c78320$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$e1a5b6d195c78320$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $e1a5b6d195c78320$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $e1a5b6d195c78320$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $e1a5b6d195c78320$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $e1a5b6d195c78320$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



var $kRbV8 = parcelRequire("kRbV8");
const $392d2a9f4f30057d$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $392d2a9f4f30057d$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($392d2a9f4f30057d$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 */ function $392d2a9f4f30057d$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $392d2a9f4f30057d$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $e1a5b6d195c78320$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    const propagationContext = {
        traceId: traceId || (0, $kRbV8.uuid4)(),
        spanId: (0, $kRbV8.uuid4)().substring(16),
        sampled: parentSampled === undefined ? false : parentSampled
    };
    if (parentSpanId) propagationContext.parentSpanId = parentSpanId;
    if (dynamicSamplingContext) propagationContext.dsc = dynamicSamplingContext;
    return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext,
        propagationContext: propagationContext
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $392d2a9f4f30057d$export$f35d907436da45cf(traceId = (0, $kRbV8.uuid4)(), spanId = (0, $kRbV8.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}


var $qyIZA = parcelRequire("qyIZA");
var $j2xvW = parcelRequire("j2xvW");
var $kRbV8 = parcelRequire("kRbV8");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $e2460c3ef6fcf376$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $e2460c3ef6fcf376$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext){
        this.traceId = (0, $kRbV8.uuid4)();
        this.spanId = (0, $kRbV8.uuid4)().substring(16);
        this.startTimestamp = (0, $j2xvW.timestampInSeconds)();
        this.tags = {};
        this.data = {};
        this.instrumenter = 'sentry';
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
        if (spanContext.instrumenter) this.instrumenter = spanContext.instrumenter;
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $e2460c3ef6fcf376$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = childSpan.transaction.name || '< unknown name >';
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $qyIZA.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        this.setData('http.response.status_code', httpStatus);
        const spanStatus = $e2460c3ef6fcf376$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== 'unknown_error') this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === 'ok';
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $qyIZA.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $j2xvW.timestampInSeconds)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        return (0, $392d2a9f4f30057d$export$f35d907436da45cf)(this.traceId, this.spanId, this.sampled);
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $9rzL4.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $9rzL4.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $9rzL4.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $e2460c3ef6fcf376$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}



var $9rzL4 = parcelRequire("9rzL4");
var $qyIZA = parcelRequire("qyIZA");

var $dCCRF = parcelRequire("dCCRF");

var $9rzL4 = parcelRequire("9rzL4");

var $gqkOp = parcelRequire("gqkOp");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */ function $0ff809a6aae469b3$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $9rzL4.dropUndefinedKeys)({
        environment: options.environment || (0, $gqkOp.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}



/** JSDoc */ class $51f55b55a154b11c$export$febc5573c75cefb0 extends (0, $e2460c3ef6fcf376$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        this._measurements = {};
        this._contexts = {};
        this._hub = hub || (0, $dCCRF.getCurrentHub)();
        this._name = transactionContext.name || '';
        this.metadata = {
            source: 'custom',
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = 'custom') {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $e2460c3ef6fcf376$export$10c95c129cd0d4fe)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $9rzL4.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $dCCRF.getCurrentHub)();
        const client = hub.getClient();
        if (!client) return {};
        const scope = hub.getScope();
        const dsc = (0, $0ff809a6aae469b3$export$366bad00d6815eed)(this.traceId, client, scope);
        const maybeSampleRate = this.metadata.sampleRate;
        if (maybeSampleRate !== undefined) dsc.sample_rate = `${maybeSampleRate}`;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const source = this.metadata.source;
        if (source && source !== 'url') dsc.transaction = this.name;
        if (this.sampled !== undefined) dsc.sampled = String(this.sampled);
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
}


const $f4972bbdefdfb829$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $f4972bbdefdfb829$var$FINISH_REASON_TAG = 'finishReason';
const $f4972bbdefdfb829$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $f4972bbdefdfb829$export$370d6113c18ba86c extends (0, $e2460c3ef6fcf376$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $j2xvW.timestampInSeconds)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $f4972bbdefdfb829$export$b279e6bd7040371f extends (0, $51f55b55a154b11c$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $f4972bbdefdfb829$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $f4972bbdefdfb829$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $f4972bbdefdfb829$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $f4972bbdefdfb829$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $f4972bbdefdfb829$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $j2xvW.timestampInSeconds)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === 'ui.action.click') this.setTag($f4972bbdefdfb829$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const spanStartedBeforeTransactionFinish = span.startTimestamp < endTimestamp;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = span.endTimestamp - this.startTimestamp < timeoutWithMarginOfError;
                if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $qyIZA.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $qyIZA.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] flushing IdleTransaction');
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $f4972bbdefdfb829$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $f4972bbdefdfb829$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $f4972bbdefdfb829$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $j2xvW.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $f4972bbdefdfb829$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this._finishReason = $f4972bbdefdfb829$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}



/** Returns all trace headers that are currently on the top scope. */ function $ba7ca1adf8da0904$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': span.toTraceparent()
    } : {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function $ba7ca1adf8da0904$var$sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $f8973b5c64ce74f1$export$5008da00b1b6dee6)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$ba7ca1adf8da0904$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $ba7ca1adf8da0904$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $iLldo.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $ba7ca1adf8da0904$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $51f55b55a154b11c$export$febc5573c75cefb0)(transactionContext, this);
    transaction = $ba7ca1adf8da0904$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $ba7ca1adf8da0904$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $f4972bbdefdfb829$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = $ba7ca1adf8da0904$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $ba7ca1adf8da0904$export$653d0ef2bad9cdf9() {
    const carrier = (0, $dCCRF.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $ba7ca1adf8da0904$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $ba7ca1adf8da0904$var$traceHeaders;
    (0, $1cd7336ab5be86ca$export$637857c1d87b640c)();
}



var $iR5Fj = parcelRequire("iR5Fj");
var $qyIZA = parcelRequire("qyIZA");


var $qyIZA = parcelRequire("qyIZA");

var $01qnz = parcelRequire("01qnz");
const $6351662efa1bcc77$export$56d8a8a25bd48b81 = (0, $01qnz.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $b251bfe49464d2a5$export$6f18f55521af71a1() {
    if ((0, $6351662efa1bcc77$export$56d8a8a25bd48b81) && (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).document) (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeTransaction = (0, $ac5759207be0f50e$export$a7feb32fdd923295)();
        if ((0, $6351662efa1bcc77$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




var $j2xvW = parcelRequire("j2xvW");
var $iR5Fj = parcelRequire("iR5Fj");
var $qyIZA = parcelRequire("qyIZA");

const $716e7491dc34d08d$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $54745ec6bac51e7b$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $292bb2af8ad1c16a$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $292bb2af8ad1c16a$export$6431553786c94949 = ()=>{
    if ((0, $6351662efa1bcc77$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $292bb2af8ad1c16a$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c1e12ff1d19b037b$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $292bb2af8ad1c16a$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5fcdd03204bd5abb$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $292bb2af8ad1c16a$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $6351662efa1bcc77$export$56d8a8a25bd48b81).document.prerendering || (0, $c1e12ff1d19b037b$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $54745ec6bac51e7b$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $8b6a6a544fec83ec$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0de6f56b1641dfe$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $f2439799a3718104$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $5fcdd03204bd5abb$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $8b6a6a544fec83ec$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $716e7491dc34d08d$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $a0de6f56b1641dfe$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $976a1582aa942fc7$var$firstHiddenTime = -1;
const $976a1582aa942fc7$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $6351662efa1bcc77$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $976a1582aa942fc7$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $a0de6f56b1641dfe$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $976a1582aa942fc7$var$firstHiddenTime = timeStamp;
    }, true);
};
const $976a1582aa942fc7$export$443f86b2c77012c4 = ()=>{
    if ($976a1582aa942fc7$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $976a1582aa942fc7$var$firstHiddenTime = $976a1582aa942fc7$var$initHiddenTime();
        $976a1582aa942fc7$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $976a1582aa942fc7$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $c685cc86a9b52629$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $976a1582aa942fc7$export$443f86b2c77012c4)();
    const metric = (0, $5fcdd03204bd5abb$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $8b6a6a544fec83ec$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $716e7491dc34d08d$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $a0de6f56b1641dfe$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c26e703140f34a6a$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $c26e703140f34a6a$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $976a1582aa942fc7$export$443f86b2c77012c4)();
    const metric = (0, $5fcdd03204bd5abb$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $c1e12ff1d19b037b$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $8b6a6a544fec83ec$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $716e7491dc34d08d$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$c26e703140f34a6a$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $c26e703140f34a6a$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $a0de6f56b1641dfe$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};




/**
 * Checks if a given value is a valid measurement value.
 */ function $acf86199c5c357f2$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $acf86199c5c357f2$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $75f3f4b986e0b977$var$msToSec(time) {
    return time / 1000;
}
function $75f3f4b986e0b977$var$getBrowserPerformanceAPI() {
    // @ts-ignore we want to make sure all of these are available, even if TS is sure they are
    return (0, $6351662efa1bcc77$export$56d8a8a25bd48b81) && (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).addEventListener && (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).performance;
}
let $75f3f4b986e0b977$var$_performanceCursor = 0;
let $75f3f4b986e0b977$var$_measurements = {};
let $75f3f4b986e0b977$var$_lcpEntry;
let $75f3f4b986e0b977$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $75f3f4b986e0b977$export$7c69f0412d101b88() {
    const performance = $75f3f4b986e0b977$var$getBrowserPerformanceAPI();
    if (performance && (0, $j2xvW.browserPerformanceTimeOrigin)) {
        // @ts-ignore we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        $75f3f4b986e0b977$var$_trackFID();
        const clsCallback = $75f3f4b986e0b977$var$_trackCLS();
        const lcpCallback = $75f3f4b986e0b977$var$_trackLCP();
        return ()=>{
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $75f3f4b986e0b977$export$f396d19077034ad2() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $ac5759207be0f50e$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $75f3f4b986e0b977$var$msToSec((0, $j2xvW.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $75f3f4b986e0b977$var$msToSec(entry.duration);
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    };
    (0, $8b6a6a544fec83ec$export$d1203567a167490e)('longtask', entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $75f3f4b986e0b977$export$e27543e0976315e4() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $ac5759207be0f50e$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $75f3f4b986e0b977$var$msToSec((0, $j2xvW.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $75f3f4b986e0b977$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $iR5Fj.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    };
    (0, $8b6a6a544fec83ec$export$d1203567a167490e)('event', entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $75f3f4b986e0b977$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $f2439799a3718104$export$a7873055838e5ad8)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding CLS');
        $75f3f4b986e0b977$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $75f3f4b986e0b977$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $75f3f4b986e0b977$var$_trackLCP() {
    return (0, $c26e703140f34a6a$export$947b1626ab8d5632)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding LCP');
        $75f3f4b986e0b977$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $75f3f4b986e0b977$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $75f3f4b986e0b977$var$_trackFID() {
    (0, $c685cc86a9b52629$export$39705a25c49af873)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $75f3f4b986e0b977$var$msToSec((0, $j2xvW.browserPerformanceTimeOrigin));
        const startTime = $75f3f4b986e0b977$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding FID');
        $75f3f4b986e0b977$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $75f3f4b986e0b977$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
/** Add performance related spans to a transaction */ function $75f3f4b986e0b977$export$5f8fa6b3467a7443(transaction) {
    const performance = $75f3f4b986e0b977$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $6351662efa1bcc77$export$56d8a8a25bd48b81).performance.getEntries || !(0, $j2xvW.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $75f3f4b986e0b977$var$msToSec((0, $j2xvW.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($75f3f4b986e0b977$var$_performanceCursor).forEach((entry)=>{
        const startTime = $75f3f4b986e0b977$var$msToSec(entry.startTime);
        const duration = $75f3f4b986e0b977$var$msToSec(entry.duration);
        if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case 'navigation':
                $75f3f4b986e0b977$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $75f3f4b986e0b977$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $75f3f4b986e0b977$var$msToSec(entry.requestStart);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $75f3f4b986e0b977$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $976a1582aa942fc7$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding FP');
                        $75f3f4b986e0b977$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding FCP');
                        $75f3f4b986e0b977$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                {
                    const resourceName = entry.name.replace((0, $6351662efa1bcc77$export$56d8a8a25bd48b81).location.origin, '');
                    $75f3f4b986e0b977$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $75f3f4b986e0b977$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $75f3f4b986e0b977$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === 'pageload') {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === 'number') {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding TTFB');
            $75f3f4b986e0b977$var$_measurements['ttfb'] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: 'millisecond'
            };
            if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $75f3f4b986e0b977$var$_measurements['ttfb.requestTime'] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: 'millisecond'
            };
        }
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$75f3f4b986e0b977$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $75f3f4b986e0b977$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $75f3f4b986e0b977$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $75f3f4b986e0b977$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $75f3f4b986e0b977$var$_measurements['mark.fid'];
        if (fidMark && $75f3f4b986e0b977$var$_measurements['fid']) {
            // create span for FID
            (0, $acf86199c5c357f2$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $75f3f4b986e0b977$var$msToSec($75f3f4b986e0b977$var$_measurements['fid'].value),
                op: 'ui.action',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $75f3f4b986e0b977$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $75f3f4b986e0b977$var$_measurements)) delete $75f3f4b986e0b977$var$_measurements.cls;
        Object.keys($75f3f4b986e0b977$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $75f3f4b986e0b977$var$_measurements[measurementName].value, $75f3f4b986e0b977$var$_measurements[measurementName].unit);
        });
        $75f3f4b986e0b977$var$_tagMetricInfo(transaction);
    }
    $75f3f4b986e0b977$var$_lcpEntry = undefined;
    $75f3f4b986e0b977$var$_clsEntry = undefined;
    $75f3f4b986e0b977$var$_measurements = {};
}
/** Create measure related spans */ function $75f3f4b986e0b977$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $acf86199c5c357f2$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75f3f4b986e0b977$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $75f3f4b986e0b977$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $75f3f4b986e0b977$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $75f3f4b986e0b977$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $75f3f4b986e0b977$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $75f3f4b986e0b977$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $75f3f4b986e0b977$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $acf86199c5c357f2$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        description: description || event,
        startTimestamp: timeOrigin + $75f3f4b986e0b977$var$msToSec(start),
        endTimestamp: timeOrigin + $75f3f4b986e0b977$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75f3f4b986e0b977$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $acf86199c5c357f2$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + $75f3f4b986e0b977$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $75f3f4b986e0b977$var$msToSec(entry.responseEnd)
    });
    (0, $acf86199c5c357f2$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + $75f3f4b986e0b977$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $75f3f4b986e0b977$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $75f3f4b986e0b977$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    if ('transferSize' in entry) data['http.response_transfer_size'] = entry.transferSize;
    if ('encodedBodySize' in entry) data['http.response_content_length'] = entry.encodedBodySize;
    if ('decodedBodySize' in entry) data['http.decoded_response_content_length'] = entry.decodedBodySize;
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $acf86199c5c357f2$export$8bd469e1f37aa721)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $75f3f4b986e0b977$var$_trackNavigator(transaction) {
    const navigator = (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) transaction.setTag('connectionType', connection.type);
        if ((0, $acf86199c5c357f2$export$27169ccae1b439e3)(connection.rtt)) $75f3f4b986e0b977$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $acf86199c5c357f2$export$27169ccae1b439e3)(navigator.deviceMemory)) transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $acf86199c5c357f2$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $75f3f4b986e0b977$var$_tagMetricInfo(transaction) {
    if ($75f3f4b986e0b977$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($75f3f4b986e0b977$var$_lcpEntry.element) transaction.setTag('lcp.element', (0, $iR5Fj.htmlTreeAsString)($75f3f4b986e0b977$var$_lcpEntry.element));
        if ($75f3f4b986e0b977$var$_lcpEntry.id) transaction.setTag('lcp.id', $75f3f4b986e0b977$var$_lcpEntry.id);
        if ($75f3f4b986e0b977$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag('lcp.url', $75f3f4b986e0b977$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag('lcp.size', $75f3f4b986e0b977$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($75f3f4b986e0b977$var$_clsEntry && $75f3f4b986e0b977$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Measurements] Adding CLS Data');
        $75f3f4b986e0b977$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $iR5Fj.htmlTreeAsString)(source.node)));
    }
}



var $dCCRF = parcelRequire("dCCRF");

var $j2xvW = parcelRequire("j2xvW");
var $iLldo = parcelRequire("iLldo");
var $hnodz = parcelRequire("hnodz");
/* eslint-disable max-lines */ const $f4c55c8656a81886$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $f4c55c8656a81886$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $f4c55c8656a81886$export$15bd0305d05ad07b,
    tracePropagationTargets: $f4c55c8656a81886$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $f4c55c8656a81886$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $f4c55c8656a81886$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $f4c55c8656a81886$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$f4c55c8656a81886$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('fetch', (handlerData)=>{
        const createdSpan = $f4c55c8656a81886$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $f4c55c8656a81886$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('xhr', (handlerData)=>{
        const createdSpan = $f4c55c8656a81886$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $f4c55c8656a81886$var$addHTTPTimings(createdSpan);
    });
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $f4c55c8656a81886$var$addHTTPTimings(span) {
    const url = span.data.url;
    const observer = new PerformanceObserver((list)=>{
        const entries = list.getEntries();
        entries.forEach((entry)=>{
            if ((entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest') && entry.name.endsWith(url)) {
                const spanData = $f4c55c8656a81886$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setData(...data));
                observer.disconnect();
            }
        });
    });
    observer.observe({
        entryTypes: [
            'resource'
        ]
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $f4c55c8656a81886$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $f4c55c8656a81886$var$getAbsoluteTime(time) {
    return (((0, $j2xvW.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $f4c55c8656a81886$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $f4c55c8656a81886$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $j2xvW.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $f4c55c8656a81886$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $f4c55c8656a81886$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $hnodz.stringMatchesSomePattern)(url, tracePropagationTargets || $f4c55c8656a81886$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $f4c55c8656a81886$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $f8973b5c64ce74f1$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
                const contentLength = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
                const contentLengthNum = parseInt(contentLength);
                if (contentLengthNum > 0) span.setData('http.response_content_length', contentLengthNum);
            } else if (handlerData.error) span.setStatus('internal_error');
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $dCCRF.getCurrentHub)();
    const scope = hub.getScope();
    const client = hub.getClient();
    const parentSpan = scope.getSpan();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            url: url,
            type: 'fetch',
            'http.method': method
        },
        description: `${method} ${url}`,
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $f4c55c8656a81886$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $f4c55c8656a81886$export$6717acf674206871(request, client, scope, options, requestSpan) {
    const span = requestSpan || scope.getSpan();
    const transaction = span && span.transaction;
    const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
    const sentryTraceHeader = span ? span.toTraceparent() : (0, $392d2a9f4f30057d$export$f35d907436da45cf)(traceId, undefined, sampled);
    const dynamicSamplingContext = transaction ? transaction.getDynamicSamplingContext() : dsc ? dsc : (0, $0ff809a6aae469b3$export$366bad00d6815eed)(traceId, client, scope);
    const sentryBaggageHeader = (0, $e1a5b6d195c78320$export$56766feef403f365)(dynamicSamplingContext);
    const headers = typeof Request !== 'undefined' && (0, $iLldo.isInstanceOf)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $iLldo.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $e1a5b6d195c78320$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $e1a5b6d195c78320$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $f4c55c8656a81886$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $43c97ac4136e5a2d$export$55b6bb1e45c6cf59];
    if (!(0, $f8973b5c64ce74f1$export$5008da00b1b6dee6)() || xhr && xhr.__sentry_own_request__ || !xhr || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $dCCRF.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            ...sentryXhrData.data,
            type: 'xhr',
            'http.method': sentryXhrData.method,
            url: sentryXhrData.url
        },
        description: `${sentryXhrData.method} ${sentryXhrData.url}`,
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
        if (span) {
            const transaction = span && span.transaction;
            const dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $e1a5b6d195c78320$export$56766feef403f365)(dynamicSamplingContext);
            $f4c55c8656a81886$var$setHeaderOnXhr(xhr, span.toTraceparent(), sentryBaggageHeader);
        } else {
            const client = hub.getClient();
            const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
            const sentryTraceHeader = (0, $392d2a9f4f30057d$export$f35d907436da45cf)(traceId, undefined, sampled);
            const dynamicSamplingContext = dsc || (client ? (0, $0ff809a6aae469b3$export$366bad00d6815eed)(traceId, client, scope) : undefined);
            const sentryBaggageHeader = (0, $e1a5b6d195c78320$export$56766feef403f365)(dynamicSamplingContext);
            $f4c55c8656a81886$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
        }
    }
    return span;
}
function $f4c55c8656a81886$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $e1a5b6d195c78320$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}



var $j2xvW = parcelRequire("j2xvW");
var $qyIZA = parcelRequire("qyIZA");

/**
 * Default function implementing pageload and navigation transactions
 */ function $130527dda1fe9f49$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $6351662efa1bcc77$export$56d8a8a25bd48b81) || !(0, $6351662efa1bcc77$export$56d8a8a25bd48b81).location) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $j2xvW.browserPerformanceTimeOrigin) ? (0, $j2xvW.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('history', ({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $6351662efa1bcc77$export$56d8a8a25bd48b81).location.pathname,
                op: 'navigation',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}



const $e83cae840e4c5fa0$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $e83cae840e4c5fa0$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $f4972bbdefdfb829$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $130527dda1fe9f49$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $f4c55c8656a81886$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $e83cae840e4c5fa0$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ constructor(_options){
        this.name = $e83cae840e4c5fa0$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $ba7ca1adf8da0904$export$653d0ef2bad9cdf9)();
        if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$e83cae840e4c5fa0$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $75f3f4b986e0b977$export$7c69f0412d101b88)();
        if (this.options.enableLongTask) (0, $75f3f4b986e0b977$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $75f3f4b986e0b977$export$e27543e0976315e4)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $qyIZA.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $b251bfe49464d2a5$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $f4c55c8656a81886$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        const sentryTrace = isPageloadTransaction ? $e83cae840e4c5fa0$export$f147b32b03c9cf11('sentry-trace') : '';
        const baggage = isPageloadTransaction ? $e83cae840e4c5fa0$export$f147b32b03c9cf11('baggage') : '';
        const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $392d2a9f4f30057d$export$ca5c066532785b6e)(sentryTrace, baggage);
        const expandedContext = {
            ...context,
            ...traceparentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $6351662efa1bcc77$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $ba7ca1adf8da0904$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        const scope = hub.getScope();
        // If it's a pageload and there is a meta tag set
        // use the traceparentData as the propagation context
        if (isPageloadTransaction && traceparentData) scope.setPropagationContext(propagationContext);
        else // Navigation transactions should set a new propagation context based on the
        // created idle transaction.
        scope.setPropagationContext({
            traceId: idleTransaction.traceId,
            spanId: idleTransaction.spanId,
            parentSpanId: idleTransaction.parentSpanId,
            sampled: !!idleTransaction.sampled
        });
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $75f3f4b986e0b977$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            const currentTransaction = (0, $ac5759207be0f50e$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $6351662efa1bcc77$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || 'url'
                }
            };
            inflightInteractionTransaction = (0, $ba7ca1adf8da0904$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $e83cae840e4c5fa0$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $iR5Fj.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}


var $dCCRF = parcelRequire("dCCRF");
var $kRbV8 = parcelRequire("kRbV8");
var $qyIZA = parcelRequire("qyIZA");

var $dCCRF = parcelRequire("dCCRF");

var $7bmu9 = parcelRequire("7bmu9");
const $88ab5232633ad82a$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $88ab5232633ad82a$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $88ab5232633ad82a$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $kRbV8.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $88ab5232633ad82a$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $88ab5232633ad82a$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $88ab5232633ad82a$export$51abed9797baa598(integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $88ab5232633ad82a$export$e7390a03b70a6f2f(integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $88ab5232633ad82a$export$e7390a03b70a6f2f(integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    if ($88ab5232633ad82a$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        integration.setupOnce((0, $7bmu9.addGlobalEventProcessor), (0, $dCCRF.getCurrentHub));
        $88ab5232633ad82a$export$b14a8888f80a0b3e.push(integration.name);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`Integration installed: ${integration.name}`);
    }
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $88ab5232633ad82a$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}


var $qyIZA = parcelRequire("qyIZA");
/** Regular expression used to parse a Dsn. */ const $f5a49d8b5410bfb8$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f5a49d8b5410bfb8$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f5a49d8b5410bfb8$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f5a49d8b5410bfb8$export$b892860177f70a30(str) {
    const match = $f5a49d8b5410bfb8$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        // eslint-disable-next-line no-console
        console.error(`Invalid Sentry Dsn: ${str}`);
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f5a49d8b5410bfb8$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f5a49d8b5410bfb8$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $f5a49d8b5410bfb8$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $qyIZA.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $qyIZA.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f5a49d8b5410bfb8$var$isValidProtocol(protocol)) {
        (0, $qyIZA.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $qyIZA.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f5a49d8b5410bfb8$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $f5a49d8b5410bfb8$export$b892860177f70a30(from) : $f5a49d8b5410bfb8$var$dsnFromComponents(from);
    if (!components || !$f5a49d8b5410bfb8$var$validateDsn(components)) return undefined;
    return components;
}


var $9rzL4 = parcelRequire("9rzL4");
const $ed718128583bba82$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $ed718128583bba82$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $ed718128583bba82$var$_getIngestEndpoint(dsn) {
    return `${$ed718128583bba82$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $ed718128583bba82$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $9rzL4.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $ed718128583bba82$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $ed718128583bba82$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$ed718128583bba82$var$_getIngestEndpoint(dsn)}?${$ed718128583bba82$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $ed718128583bba82$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $f5a49d8b5410bfb8$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$ed718128583bba82$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f5a49d8b5410bfb8$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $qyIZA = parcelRequire("qyIZA");

var $dCCRF = parcelRequire("dCCRF");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $8d8796f30a0303c2$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) (0, $qyIZA.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    const hub = (0, $dCCRF.getCurrentHub)();
    const scope = hub.getScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    hub.bindClient(client);
}

var $d7ef265a91c9aea6$exports = {};

$parcel$export($d7ef265a91c9aea6$exports, "FunctionToString", function () { return $63ca1f6b8c658504$export$da4704525c20ae79; });
$parcel$export($d7ef265a91c9aea6$exports, "InboundFilters", function () { return $37135869f5b86cfc$export$2ffbb5359dcc6be4; });

var $9rzL4 = parcelRequire("9rzL4");
let $63ca1f6b8c658504$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $63ca1f6b8c658504$export$da4704525c20ae79 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'FunctionToString';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $63ca1f6b8c658504$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $63ca1f6b8c658504$var$originalFunctionToString = Function.prototype.toString;
        // intrinsics (like Function.prototype) might be immutable in some environments
        // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Function.prototype.toString = function(...args) {
                const context = (0, $9rzL4.getOriginalFunction)(this) || this;
                return $63ca1f6b8c658504$var$originalFunctionToString.apply(context, args);
            };
        } catch (e) {
        // ignore errors here, just don't patch this
        }
    }
}
$63ca1f6b8c658504$export$da4704525c20ae79.__initStatic();



var $kRbV8 = parcelRequire("kRbV8");
var $qyIZA = parcelRequire("qyIZA");
var $hnodz = parcelRequire("hnodz");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $37135869f5b86cfc$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $37135869f5b86cfc$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*healthcheck.*$/,
    /^.*healthy.*$/,
    /^.*live.*$/,
    /^.*ready.*$/,
    /^.*heartbeat.*$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $37135869f5b86cfc$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'InboundFilters';
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $37135869f5b86cfc$export$2ffbb5359dcc6be4.id;
        this._options = options;
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcess = (event)=>{
            const hub = getCurrentHub();
            if (hub) {
                const self = hub.getIntegration($37135869f5b86cfc$export$2ffbb5359dcc6be4);
                if (self) {
                    const client = hub.getClient();
                    const clientOptions = client ? client.getOptions() : {};
                    const options = $37135869f5b86cfc$export$6620a151868b99aa(self._options, clientOptions);
                    return $37135869f5b86cfc$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        };
        eventProcess.id = this.name;
        addGlobalEventProcessor(eventProcess);
    }
}
$37135869f5b86cfc$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $37135869f5b86cfc$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $37135869f5b86cfc$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $37135869f5b86cfc$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $37135869f5b86cfc$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $37135869f5b86cfc$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $kRbV8.getEventDescription)(event)}`);
        return true;
    }
    if ($37135869f5b86cfc$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $kRbV8.getEventDescription)(event)}`);
        return true;
    }
    if ($37135869f5b86cfc$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $kRbV8.getEventDescription)(event)}`);
        return true;
    }
    if ($37135869f5b86cfc$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $kRbV8.getEventDescription)(event)}.\nUrl: ${$37135869f5b86cfc$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$37135869f5b86cfc$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $kRbV8.getEventDescription)(event)}.\nUrl: ${$37135869f5b86cfc$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $37135869f5b86cfc$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $37135869f5b86cfc$var$_getPossibleEventMessages(event).some((message)=>(0, $hnodz.stringMatchesSomePattern)(message, ignoreErrors));
}
function $37135869f5b86cfc$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $hnodz.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $37135869f5b86cfc$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $37135869f5b86cfc$var$_getEventFilterUrl(event);
    return !url ? false : (0, $hnodz.stringMatchesSomePattern)(url, denyUrls);
}
function $37135869f5b86cfc$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $37135869f5b86cfc$var$_getEventFilterUrl(event);
    return !url ? true : (0, $hnodz.stringMatchesSomePattern)(url, allowUrls);
}
function $37135869f5b86cfc$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) {
        const { values: values } = event.exception;
        try {
            const { type: type = '', value: value = '' } = values && values[values.length - 1] || {};
            return [
                `${value}`,
                `${type}: ${value}`
            ];
        } catch (oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error(`Cannot extract message for event ${(0, $kRbV8.getEventDescription)(event)}`);
            return [];
        }
    }
    return [];
}
function $37135869f5b86cfc$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $37135869f5b86cfc$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $37135869f5b86cfc$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $37135869f5b86cfc$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error(`Cannot extract url for event ${(0, $kRbV8.getEventDescription)(event)}`);
        return null;
    }
}





var $qyIZA = parcelRequire("qyIZA");
var $gG0fI = parcelRequire("gG0fI");


var $iLldo = parcelRequire("iLldo");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $8a15f0a2a50469f2$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



var $9rzL4 = parcelRequire("9rzL4");

/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e98b9d0181527907$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $e98b9d0181527907$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $e98b9d0181527907$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $e98b9d0181527907$export$a3295358bff77e(object, depth);
    if ($e98b9d0181527907$var$jsonSize(normalized) > maxSize) return $e98b9d0181527907$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $e98b9d0181527907$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $8a15f0a2a50469f2$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $iLldo.isNaN)(value)) return value;
    const stringified = $e98b9d0181527907$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $e98b9d0181527907$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $9rzL4.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $e98b9d0181527907$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $e98b9d0181527907$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $iLldo.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $4cf53a7b1072c092$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $e98b9d0181527907$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $e98b9d0181527907$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $e98b9d0181527907$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e98b9d0181527907$var$jsonSize(value) {
    return $e98b9d0181527907$var$utf8Length(JSON.stringify(value));
}



var $9rzL4 = parcelRequire("9rzL4");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $18e31cfb89f28a11$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $18e31cfb89f28a11$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $18e31cfb89f28a11$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $18e31cfb89f28a11$export$604a45d95a155e2b(envelope, types) {
    return $18e31cfb89f28a11$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $18e31cfb89f28a11$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $18e31cfb89f28a11$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $18e31cfb89f28a11$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $18e31cfb89f28a11$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $e98b9d0181527907$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $18e31cfb89f28a11$var$concatBuffers(parts);
}
function $18e31cfb89f28a11$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $18e31cfb89f28a11$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $18e31cfb89f28a11$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $18e31cfb89f28a11$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $9rzL4.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $18e31cfb89f28a11$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $18e31cfb89f28a11$export$b11169581eeaf237(type) {
    return $18e31cfb89f28a11$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $18e31cfb89f28a11$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $18e31cfb89f28a11$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $f5a49d8b5410bfb8$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $9rzL4.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}


var $kRbV8 = parcelRequire("kRbV8");
var $iLldo = parcelRequire("iLldo");
var $qyIZA = parcelRequire("qyIZA");
var $gG0fI = parcelRequire("gG0fI");/** An error emitted by Sentry SDKs and related utilities. */ class $5a389e988d2c6fce$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $42202dc19ef2cc54$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $42202dc19ef2cc54$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $18e31cfb89f28a11$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $f5a49d8b5410bfb8$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $18e31cfb89f28a11$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $42202dc19ef2cc54$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $18e31cfb89f28a11$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $42202dc19ef2cc54$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $18e31cfb89f28a11$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $18e31cfb89f28a11$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}




var $fU49Z = parcelRequire("fU49Z");


var $j2xvW = parcelRequire("j2xvW");
var $01qnz = parcelRequire("01qnz");
var $gG0fI = parcelRequire("gG0fI");
var $hnodz = parcelRequire("hnodz");
var $kRbV8 = parcelRequire("kRbV8");

var $gqkOp = parcelRequire("gqkOp");

var $7bmu9 = parcelRequire("7bmu9");
/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $29e2395a75236266$export$2d67fb380bd11267(options, event, hint, scope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $kRbV8.uuid4)(),
        timestamp: event.timestamp || (0, $j2xvW.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $29e2395a75236266$var$applyClientOptions(prepared, options);
    $29e2395a75236266$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $29e2395a75236266$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) finalScope = (0, $7bmu9.Scope).clone(finalScope).update(hint.captureContext);
    // We prepare the result here with a resolved Event.
    let result = (0, $gG0fI.resolvedSyncPromise)(prepared);
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            const attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
    }
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $29e2395a75236266$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $29e2395a75236266$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $29e2395a75236266$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $gqkOp.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $hnodz.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $hnodz.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $hnodz.truncate)(request.url, maxValueLength);
}
const $29e2395a75236266$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $29e2395a75236266$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $01qnz.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $29e2395a75236266$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $29e2395a75236266$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $29e2395a75236266$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $29e2395a75236266$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $29e2395a75236266$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $e98b9d0181527907$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $e98b9d0181527907$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $e98b9d0181527907$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $e98b9d0181527907$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $e98b9d0181527907$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $e98b9d0181527907$export$a3295358bff77e)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}


const $5fcd3c6d07970ab2$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5fcd3c6d07970ab2$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        if (options.dsn) this._dsn = (0, $f5a49d8b5410bfb8$export$128827c3562ec0cb)(options.dsn);
        else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('No DSN provided, client will not do anything.');
        if (this._dsn) {
            const url = (0, $ed718128583bba82$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $kRbV8.checkOrSetAlreadyCaught)(exception)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log($5fcd3c6d07970ab2$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = (0, $iLldo.isPrimitive)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $kRbV8.checkOrSetAlreadyCaught)(hint.originalException)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log($5fcd3c6d07970ab2$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $fU49Z.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $gG0fI.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /**
   * Sets up the integrations
   */ setupIntegrations() {
        if (this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $88ab5232633ad82a$export$51abed9797baa598)(this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $88ab5232633ad82a$export$e7390a03b70a6f2f)(integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        if (this._dsn) {
            let env = (0, $42202dc19ef2cc54$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
            for (const attachment of hint.attachments || [])env = (0, $18e31cfb89f28a11$export$d650323442802f6f)(env, (0, $18e31cfb89f28a11$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
            const promise = this._sendEnvelope(env);
            if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
        }
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        if (this._dsn) {
            const env = (0, $42202dc19ef2cc54$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-ignore We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) // @ts-ignore we cannot enforce the callback to match the hook
        this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $fU49Z.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $gG0fI.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        return (0, $29e2395a75236266$export$2d67fb380bd11267)(options, event, hint, scope).then((evt)=>{
            if (evt === null) return evt;
            // If a trace context is not set on the event, we use the propagationContext set on the event to
            // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
            // also generate one for it.
            const { propagationContext: propagationContext } = evt.sdkProcessingMetadata || {};
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $0ff809a6aae469b3$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $qyIZA.logger).log(sentryError.message);
                else (0, $qyIZA.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        if (!this._isEnabled()) return (0, $gG0fI.rejectedSyncPromise)(new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)('SDK not enabled, will not capture event.', 'log'));
        const isTransaction = $5fcd3c6d07970ab2$var$isTransactionEvent(event);
        const isError = $5fcd3c6d07970ab2$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $gG0fI.rejectedSyncPromise)(new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5fcd3c6d07970ab2$var$processBeforeSend(options, prepared, hint);
            return $5fcd3c6d07970ab2$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                throw new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        if (this._transport && this._dsn) {
            this.emit('beforeEnvelope', envelope);
            return this._transport.send(envelope).then(null, (reason)=>{
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('Error while sending event:', reason);
            });
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5fcd3c6d07970ab2$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $iLldo.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $iLldo.isPlainObject)(event) && event !== null) throw new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $iLldo.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5fcd3c6d07970ab2$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($5fcd3c6d07970ab2$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5fcd3c6d07970ab2$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $5fcd3c6d07970ab2$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5fcd3c6d07970ab2$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}

const $9c6d092eae50e453$export$31499a9cd224b78c = '7.61.1';




var $j2xvW = parcelRequire("j2xvW");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $4b49715c2d889e1e$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $j2xvW.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $18e31cfb89f28a11$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $fitJ8 = parcelRequire("fitJ8");
var $qyIZA = parcelRequire("qyIZA");

var $dCCRF = parcelRequire("dCCRF");

var $kRbV8 = parcelRequire("kRbV8");
var $9rzL4 = parcelRequire("9rzL4");
var $iLldo = parcelRequire("iLldo");
var $gG0fI = parcelRequire("gG0fI");
/**
 * This function creates an exception from a JavaScript Error
 */ function $249c4dea8e2f6c94$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $249c4dea8e2f6c94$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $249c4dea8e2f6c94$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $249c4dea8e2f6c94$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const hub = (0, $dCCRF.getCurrentHub)();
    const client = hub.getClient();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $iLldo.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $249c4dea8e2f6c94$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $e98b9d0181527907$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $249c4dea8e2f6c94$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $249c4dea8e2f6c94$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $249c4dea8e2f6c94$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $249c4dea8e2f6c94$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $249c4dea8e2f6c94$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $249c4dea8e2f6c94$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $249c4dea8e2f6c94$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($249c4dea8e2f6c94$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $249c4dea8e2f6c94$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $249c4dea8e2f6c94$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $249c4dea8e2f6c94$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $kRbV8.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gG0fI.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $249c4dea8e2f6c94$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $249c4dea8e2f6c94$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gG0fI.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $249c4dea8e2f6c94$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $iLldo.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $249c4dea8e2f6c94$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $iLldo.isDOMError)(exception) || (0, $iLldo.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $249c4dea8e2f6c94$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $iLldo.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $249c4dea8e2f6c94$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $kRbV8.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $iLldo.isError)(exception)) // we have a real Error object, do nothing
    return $249c4dea8e2f6c94$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $iLldo.isPlainObject)(exception) || (0, $iLldo.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $249c4dea8e2f6c94$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $kRbV8.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $249c4dea8e2f6c94$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $kRbV8.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $kRbV8.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $249c4dea8e2f6c94$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    const event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        const frames = $249c4dea8e2f6c94$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}
function $249c4dea8e2f6c94$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $9rzL4.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $iLldo.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $iLldo.isEvent)(exception)) {
        const className = $249c4dea8e2f6c94$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $249c4dea8e2f6c94$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}



var $7Ff5S = parcelRequire("7Ff5S");

var $kRbV8 = parcelRequire("kRbV8");
var $9rzL4 = parcelRequire("9rzL4");
var $01qnz = parcelRequire("01qnz");
const $90fcfb6bcbc0de91$export$56d8a8a25bd48b81 = (0, $01qnz.GLOBAL_OBJ);
let $90fcfb6bcbc0de91$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $90fcfb6bcbc0de91$export$b79738ab10c590b2() {
    return $90fcfb6bcbc0de91$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $90fcfb6bcbc0de91$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $90fcfb6bcbc0de91$var$ignoreOnError++;
    setTimeout(()=>{
        $90fcfb6bcbc0de91$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $90fcfb6bcbc0de91$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $9rzL4.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$90fcfb6bcbc0de91$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $90fcfb6bcbc0de91$export$1265a142ff5ba165();
            (0, $7Ff5S.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $kRbV8.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $kRbV8.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $7Ff5S.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $9rzL4.markFunctionWrapped)(sentryWrapped, fn);
    (0, $9rzL4.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



var $dCCRF = parcelRequire("dCCRF");

var $kRbV8 = parcelRequire("kRbV8");
var $iR5Fj = parcelRequire("iR5Fj");
var $qyIZA = parcelRequire("qyIZA");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $373d3ced1b588e38$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $373d3ced1b588e38$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $373d3ced1b588e38$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $373d3ced1b588e38$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(':80', '').replace(':443', '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


var $hnodz = parcelRequire("hnodz");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $24410caeaebde947$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $24410caeaebde947$export$e01cef29b4327697(level) {
    return $24410caeaebde947$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $24410caeaebde947$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $24410caeaebde947$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $48a59889cc5a51b9$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $48a59889cc5a51b9$export$6d0f6df16bece7bf = 'Breadcrumbs';
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $48a59889cc5a51b9$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = $48a59889cc5a51b9$export$6d0f6df16bece7bf;
    }
    /**
   * @inheritDoc
   */ /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        this.name = $48a59889cc5a51b9$export$2dc68d50d56fbbd.id;
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('console', $48a59889cc5a51b9$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('dom', $48a59889cc5a51b9$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('xhr', $48a59889cc5a51b9$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('fetch', $48a59889cc5a51b9$var$_fetchBreadcrumb);
        if (this.options.history) (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('history', $48a59889cc5a51b9$var$_historyBreadcrumb);
    }
    /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */ addSentryBreadcrumb(event) {
        if (this.options.sentry) (0, $dCCRF.getCurrentHub)().addBreadcrumb({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $kRbV8.getEventDescription)(event)
        }, {
            event: event
        });
    }
}
$48a59889cc5a51b9$export$2dc68d50d56fbbd.__initStatic();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $48a59889cc5a51b9$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $48a59889cc5a51b9$var$MAX_ALLOWED_STRING_LENGTH) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$48a59889cc5a51b9$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$48a59889cc5a51b9$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $48a59889cc5a51b9$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            target = $48a59889cc5a51b9$var$_isEvent(event) ? (0, $iR5Fj.htmlTreeAsString)(event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $iR5Fj.htmlTreeAsString)(event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $dCCRF.getCurrentHub)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $48a59889cc5a51b9$var$_consoleBreadcrumb(handlerData) {
    // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
    // console warnings. This happens when a Vue template is rendered with
    // an undeclared variable, which we try to stringify, ultimately causing
    // Vue to issue another warning which repeats indefinitely.
    // see: https://github.com/getsentry/sentry-javascript/pull/6010
    // see: https://github.com/getsentry/sentry-javascript/issues/5916
    for(let i = 0; i < handlerData.args.length; i++)if (handlerData.args[i] === 'ref=Ref<') {
        handlerData.args[i + 1] = 'viewRef';
        break;
    }
    const breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $24410caeaebde947$export$d771ef054122c30a)(handlerData.level),
        message: (0, $hnodz.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $hnodz.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $dCCRF.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $48a59889cc5a51b9$var$_xhrBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[0, $43c97ac4136e5a2d$export$55b6bb1e45c6cf59];
    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
    const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
    const data = {
        method: method,
        url: url,
        status_code: status_code
    };
    const hint = {
        xhr: handlerData.xhr,
        input: body,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
    };
    (0, $dCCRF.getCurrentHub)().addBreadcrumb({
        category: 'xhr',
        data: data,
        type: 'http'
    }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $48a59889cc5a51b9$var$_fetchBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    // We only capture complete fetch requests
    if (!endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) {
        const data = handlerData.fetchData;
        const hint = {
            data: handlerData.error,
            input: handlerData.args,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $dCCRF.getCurrentHub)().addBreadcrumb({
            category: 'fetch',
            data: data,
            level: 'error',
            type: 'http'
        }, hint);
    } else {
        const data = {
            ...handlerData.fetchData,
            status_code: handlerData.response && handlerData.response.status
        };
        const hint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $dCCRF.getCurrentHub)().addBreadcrumb({
            category: 'fetch',
            data: data,
            type: 'http'
        }, hint);
    }
}
/**
 * Creates breadcrumbs from history API calls
 */ function $48a59889cc5a51b9$var$_historyBreadcrumb(handlerData) {
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0, $373d3ced1b588e38$export$7a5253c0f62e0150)((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).location.href);
    let parsedFrom = (0, $373d3ced1b588e38$export$7a5253c0f62e0150)(from);
    const parsedTo = (0, $373d3ced1b588e38$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $dCCRF.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}
function $48a59889cc5a51b9$var$_isEvent(event) {
    return !!event && !!event.target;
}



/**
 * Creates an envelope from a user feedback.
 */ function $e44bcc426ac1972c$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $f5a49d8b5410bfb8$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $e44bcc426ac1972c$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $18e31cfb89f28a11$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $e44bcc426ac1972c$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $db5de8ada053a025$export$1df9218a526d318d extends (0, $5fcd3c6d07970ab2$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $fitJ8.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $9c6d092eae50e453$export$31499a9cd224b78c)
                }
            ],
            version: (0, $9c6d092eae50e453$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document) (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $249c4dea8e2f6c94$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $249c4dea8e2f6c94$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint) {
        // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
        // activated its `sentry` option.
        // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
        // bundles, if it is not used by the SDK.
        // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
        // way for now.
        const breadcrumbIntegration = this.getIntegrationById((0, $48a59889cc5a51b9$export$6d0f6df16bece7bf));
        // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
        // "Breadcrumbs" that does not have this function.
        if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) breadcrumbIntegration.addSentryBreadcrumb(event);
        super.sendEvent(event, hint);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $e44bcc426ac1972c$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('No outcomes to send');
            return;
        }
        if (!this._dsn) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $4b49715c2d889e1e$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f5a49d8b5410bfb8$export$44d472fbb931a776)(this._dsn));
        this._sendEnvelope(envelope);
    }
}




var $dCCRF = parcelRequire("dCCRF");

var $kRbV8 = parcelRequire("kRbV8");
var $iR5Fj = parcelRequire("iR5Fj");
var $iLldo = parcelRequire("iLldo");
var $qyIZA = parcelRequire("qyIZA");


/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ class $ade595f4b6aed312$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GlobalHandlers';
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ /** JSDoc */ constructor(options){
        this.name = $ade595f4b6aed312$export$204155decbc90e5a.id;
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
        this._installFunc = {
            onerror: $ade595f4b6aed312$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $ade595f4b6aed312$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        const options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(const key in options){
            const installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $ade595f4b6aed312$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$ade595f4b6aed312$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $ade595f4b6aed312$var$_installGlobalOnErrorHandler() {
    (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data)=>{
        const [hub, stackParser, attachStacktrace] = $ade595f4b6aed312$var$getHubAndOptions();
        if (!hub.getIntegration($ade595f4b6aed312$export$204155decbc90e5a)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        if ((0, $90fcfb6bcbc0de91$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        const event = error === undefined && (0, $iLldo.isString)(msg) ? $ade595f4b6aed312$var$_eventFromIncompleteOnError(msg, url, line, column) : $ade595f4b6aed312$var$_enhanceEventWithInitialFrame((0, $249c4dea8e2f6c94$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        $ade595f4b6aed312$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $ade595f4b6aed312$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        const [hub, stackParser, attachStacktrace] = $ade595f4b6aed312$var$getHubAndOptions();
        if (!hub.getIntegration($ade595f4b6aed312$export$204155decbc90e5a)) return;
        let error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $90fcfb6bcbc0de91$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        const event = (0, $iLldo.isPrimitive)(error) ? $ade595f4b6aed312$var$_eventFromRejectionWithPrimitive(error) : (0, $249c4dea8e2f6c94$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        $ade595f4b6aed312$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ade595f4b6aed312$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ade595f4b6aed312$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $iLldo.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $ade595f4b6aed312$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ade595f4b6aed312$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $iLldo.isString)(url) && url.length > 0 ? url : (0, $iR5Fj.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ade595f4b6aed312$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log(`Global Handler attached: ${type}`);
}
function $ade595f4b6aed312$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $kRbV8.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $ade595f4b6aed312$var$getHubAndOptions() {
    const hub = (0, $dCCRF.getCurrentHub)();
    const client = hub.getClient();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}



var $9rzL4 = parcelRequire("9rzL4");

const $6897a8a5440a24b4$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $6897a8a5440a24b4$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'TryCatch';
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        this.name = $6897a8a5440a24b4$export$f1a018517668e6d3.id;
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        if (this._options.setTimeout) (0, $9rzL4.fill)((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81), 'setTimeout', $6897a8a5440a24b4$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $9rzL4.fill)((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81), 'setInterval', $6897a8a5440a24b4$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $9rzL4.fill)((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81), 'requestAnimationFrame', $6897a8a5440a24b4$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81)) (0, $9rzL4.fill)(XMLHttpRequest.prototype, 'send', $6897a8a5440a24b4$var$_wrapXHR);
        const eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $6897a8a5440a24b4$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($6897a8a5440a24b4$var$_wrapEventTarget);
        }
    }
}
$6897a8a5440a24b4$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $6897a8a5440a24b4$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $90fcfb6bcbc0de91$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4cf53a7b1072c092$export$aad197c7121a6651)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6897a8a5440a24b4$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $90fcfb6bcbc0de91$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4cf53a7b1072c092$export$aad197c7121a6651)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $6897a8a5440a24b4$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9rzL4.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4cf53a7b1072c092$export$aad197c7121a6651)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $9rzL4.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4cf53a7b1072c092$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $90fcfb6bcbc0de91$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $6897a8a5440a24b4$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $9rzL4.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $90fcfb6bcbc0de91$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4cf53a7b1072c092$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $90fcfb6bcbc0de91$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4cf53a7b1072c092$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $9rzL4.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}




var $iLldo = parcelRequire("iLldo");

var $hnodz = parcelRequire("hnodz");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $07f203a0ea27373d$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $iLldo.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $07f203a0ea27373d$var$truncateAggregateExceptions($07f203a0ea27373d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $07f203a0ea27373d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $iLldo.isInstanceOf)(error[key], Error)) {
        $07f203a0ea27373d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $07f203a0ea27373d$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $07f203a0ea27373d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $iLldo.isInstanceOf)(childError, Error)) {
            $07f203a0ea27373d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $07f203a0ea27373d$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $07f203a0ea27373d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $07f203a0ea27373d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        is_exception_group: true,
        exception_id: exceptionId
    };
}
function $07f203a0ea27373d$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $07f203a0ea27373d$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $hnodz.truncate)(exception.value, maxValueLength);
        return exception;
    });
}



const $a2ea0a93a0d21f6e$var$DEFAULT_KEY = 'cause';
const $a2ea0a93a0d21f6e$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $a2ea0a93a0d21f6e$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'LinkedErrors';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $a2ea0a93a0d21f6e$export$8d1e60aaf616fb4f.id;
        this._key = options.key || $a2ea0a93a0d21f6e$var$DEFAULT_KEY;
        this._limit = options.limit || $a2ea0a93a0d21f6e$var$DEFAULT_LIMIT;
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor((event, hint)=>{
            const hub = getCurrentHub();
            const client = hub.getClient();
            const self = hub.getIntegration($a2ea0a93a0d21f6e$export$8d1e60aaf616fb4f);
            if (!client || !self) return event;
            const options = client.getOptions();
            (0, $07f203a0ea27373d$export$b91c38ed7d8ae9b2)((0, $249c4dea8e2f6c94$export$a6c2d27607295951), options.stackParser, options.maxValueLength, self._key, self._limit, event, hint);
            return event;
        });
    }
}
$a2ea0a93a0d21f6e$export$8d1e60aaf616fb4f.__initStatic();



var $7bmu9 = parcelRequire("7bmu9");
var $dCCRF = parcelRequire("dCCRF");

/** HttpContext integration collects information about HTTP request headers */ class $e7aa4bcce90e635f$export$5d2ee9a544b09a94 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'HttpContext';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $e7aa4bcce90e635f$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        (0, $7bmu9.addGlobalEventProcessor)((event)=>{
            if ((0, $dCCRF.getCurrentHub)().getIntegration($e7aa4bcce90e635f$export$5d2ee9a544b09a94)) {
                // if none of the information we want exists, don't bother
                if (!(0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).navigator && !(0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).location && !(0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document) return event;
                // grab as much info as exists and add it to the event
                const url = event.request && event.request.url || (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).location && (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).location.href;
                const { referrer: referrer } = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document || {};
                const { userAgent: userAgent } = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).navigator || {};
                const headers = {
                    ...event.request && event.request.headers,
                    ...referrer && {
                        Referer: referrer
                    },
                    ...userAgent && {
                        'User-Agent': userAgent
                    }
                };
                const request = {
                    ...event.request,
                    ...url && {
                        url: url
                    },
                    headers: headers
                };
                return {
                    ...event,
                    request: request
                };
            }
            return event;
        });
    }
}
$e7aa4bcce90e635f$export$5d2ee9a544b09a94.__initStatic();



var $qyIZA = parcelRequire("qyIZA");
/** Deduplication filter */ class $0608374abec413d4$export$688d98c249d31ad3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Dedupe';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(){
        this.name = $0608374abec413d4$export$688d98c249d31ad3.id;
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcessor = (currentEvent)=>{
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            const self = getCurrentHub().getIntegration($0608374abec413d4$export$688d98c249d31ad3);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($0608374abec413d4$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        };
        eventProcessor.id = this.name;
        addGlobalEventProcessor(eventProcessor);
    }
}
$0608374abec413d4$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $0608374abec413d4$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($0608374abec413d4$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($0608374abec413d4$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $0608374abec413d4$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$0608374abec413d4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0608374abec413d4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $0608374abec413d4$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $0608374abec413d4$var$_getExceptionFromEvent(previousEvent);
    const currentException = $0608374abec413d4$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$0608374abec413d4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0608374abec413d4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $0608374abec413d4$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $0608374abec413d4$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $0608374abec413d4$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $0608374abec413d4$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $0608374abec413d4$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $0608374abec413d4$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



// global reference to slice
const $e8250f40ffea6a8c$var$UNKNOWN_FUNCTION = '?';
const $e8250f40ffea6a8c$var$OPERA10_PRIORITY = 10;
const $e8250f40ffea6a8c$var$OPERA11_PRIORITY = 20;
const $e8250f40ffea6a8c$var$CHROME_PRIORITY = 30;
const $e8250f40ffea6a8c$var$WINJS_PRIORITY = 40;
const $e8250f40ffea6a8c$var$GECKO_PRIORITY = 50;
function $e8250f40ffea6a8c$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $e8250f40ffea6a8c$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e8250f40ffea6a8c$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $e8250f40ffea6a8c$var$chrome = (line)=>{
    const parts = $e8250f40ffea6a8c$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e8250f40ffea6a8c$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e8250f40ffea6a8c$var$extractSafariExtensionDetails(parts[1] || $e8250f40ffea6a8c$var$UNKNOWN_FUNCTION, parts[2]);
        return $e8250f40ffea6a8c$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e8250f40ffea6a8c$export$263a749fff749872 = [
    $e8250f40ffea6a8c$var$CHROME_PRIORITY,
    $e8250f40ffea6a8c$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e8250f40ffea6a8c$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e8250f40ffea6a8c$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e8250f40ffea6a8c$var$gecko = (line)=>{
    const parts = $e8250f40ffea6a8c$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e8250f40ffea6a8c$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $e8250f40ffea6a8c$var$UNKNOWN_FUNCTION;
        [func, filename] = $e8250f40ffea6a8c$var$extractSafariExtensionDetails(func, filename);
        return $e8250f40ffea6a8c$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e8250f40ffea6a8c$export$cdba47a5dd2804d = [
    $e8250f40ffea6a8c$var$GECKO_PRIORITY,
    $e8250f40ffea6a8c$var$gecko
];
const $e8250f40ffea6a8c$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e8250f40ffea6a8c$var$winjs = (line)=>{
    const parts = $e8250f40ffea6a8c$var$winjsRegex.exec(line);
    return parts ? $e8250f40ffea6a8c$var$createFrame(parts[2], parts[1] || $e8250f40ffea6a8c$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e8250f40ffea6a8c$export$179460296da408e8 = [
    $e8250f40ffea6a8c$var$WINJS_PRIORITY,
    $e8250f40ffea6a8c$var$winjs
];
const $e8250f40ffea6a8c$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e8250f40ffea6a8c$var$opera10 = (line)=>{
    const parts = $e8250f40ffea6a8c$var$opera10Regex.exec(line);
    return parts ? $e8250f40ffea6a8c$var$createFrame(parts[2], parts[3] || $e8250f40ffea6a8c$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $e8250f40ffea6a8c$export$f892b52c880ffc7a = [
    $e8250f40ffea6a8c$var$OPERA10_PRIORITY,
    $e8250f40ffea6a8c$var$opera10
];
const $e8250f40ffea6a8c$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e8250f40ffea6a8c$var$opera11 = (line)=>{
    const parts = $e8250f40ffea6a8c$var$opera11Regex.exec(line);
    return parts ? $e8250f40ffea6a8c$var$createFrame(parts[5], parts[3] || parts[4] || $e8250f40ffea6a8c$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $e8250f40ffea6a8c$export$af11af13f09fb0dc = [
    $e8250f40ffea6a8c$var$OPERA11_PRIORITY,
    $e8250f40ffea6a8c$var$opera11
];
const $e8250f40ffea6a8c$export$7197c0fe6554c079 = [
    $e8250f40ffea6a8c$export$263a749fff749872,
    $e8250f40ffea6a8c$export$cdba47a5dd2804d,
    $e8250f40ffea6a8c$export$179460296da408e8
];
const $e8250f40ffea6a8c$export$2b2b997d81bf3907 = (0, $4cf53a7b1072c092$export$a5739666fb2d03d4)(...$e8250f40ffea6a8c$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e8250f40ffea6a8c$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $e8250f40ffea6a8c$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $879af007d9e99513$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $879af007d9e99513$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $879af007d9e99513$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $879af007d9e99513$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $879af007d9e99513$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $879af007d9e99513$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $879af007d9e99513$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories] = limit.split(':', 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';'))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $879af007d9e99513$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $qyIZA = parcelRequire("qyIZA");

var $gG0fI = parcelRequire("gG0fI");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $0fb5e6257532894b$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $gG0fI.rejectedSyncPromise)(new (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $gG0fI.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $gG0fI.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


var $gG0fI = parcelRequire("gG0fI");
const $885c9b6b5189d05d$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $885c9b6b5189d05d$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $0fb5e6257532894b$export$85a4f67f852183e6)(options.bufferSize || $885c9b6b5189d05d$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $18e31cfb89f28a11$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $18e31cfb89f28a11$export$b11169581eeaf237)(type);
            if ((0, $879af007d9e99513$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $885c9b6b5189d05d$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $gG0fI.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $18e31cfb89f28a11$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $18e31cfb89f28a11$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $885c9b6b5189d05d$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $18e31cfb89f28a11$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $18e31cfb89f28a11$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $879af007d9e99513$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $5a389e988d2c6fce$export$5949942ba2a7c0e2)) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $gG0fI.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $885c9b6b5189d05d$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



var $gG0fI = parcelRequire("gG0fI");

var $qyIZA = parcelRequire("qyIZA");

let $59f88855e357cbec$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $59f88855e357cbec$export$8be2119ce08e3379() {
    if ($59f88855e357cbec$var$cachedFetchImpl) return $59f88855e357cbec$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $af39801725607093$export$18cf36ed71d733e7)((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).fetch)) return $59f88855e357cbec$var$cachedFetchImpl = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).fetch.bind((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81));
    const document = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $59f88855e357cbec$var$cachedFetchImpl = fetchImpl.bind((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $59f88855e357cbec$export$d499686d2dd738c6() {
    $59f88855e357cbec$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $42147cad264ec852$export$b2311068c46d7cc8(options, nativeFetch = (0, $59f88855e357cbec$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $59f88855e357cbec$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $gG0fI.rejectedSyncPromise)(e);
        }
    }
    return (0, $885c9b6b5189d05d$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $gG0fI = parcelRequire("gG0fI");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $1bdfa05b9db8299a$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $1bdfa05b9db8299a$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $gG0fI.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $1bdfa05b9db8299a$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $885c9b6b5189d05d$export$d09f50d9ab7f7b69)(options, makeRequest);
}


const $bcf1d3eaaf7e3f77$export$5ef831fccfce35e5 = [
    new (0, $d7ef265a91c9aea6$exports).InboundFilters(),
    new (0, $d7ef265a91c9aea6$exports).FunctionToString(),
    new (0, $6897a8a5440a24b4$export$f1a018517668e6d3)(),
    new (0, $48a59889cc5a51b9$export$2dc68d50d56fbbd)(),
    new (0, $ade595f4b6aed312$export$204155decbc90e5a)(),
    new (0, $a2ea0a93a0d21f6e$export$8d1e60aaf616fb4f)(),
    new (0, $0608374abec413d4$export$688d98c249d31ad3)(),
    new (0, $e7aa4bcce90e635f$export$5d2ee9a544b09a94)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $bcf1d3eaaf7e3f77$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $bcf1d3eaaf7e3f77$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $4cf53a7b1072c092$export$1d5cf88b347146d4)(options.stackParser || (0, $e8250f40ffea6a8c$export$2b2b997d81bf3907)),
        integrations: (0, $88ab5232633ad82a$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $af39801725607093$export$edf3cb81fd7d2a3e)() ? (0, $42147cad264ec852$export$b2311068c46d7cc8) : (0, $1bdfa05b9db8299a$export$5e1441cee30d5a39))
    };
    (0, $8d8796f30a0303c2$export$5333c3f1c58d9bc1)((0, $db5de8ada053a025$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $bcf1d3eaaf7e3f77$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $bcf1d3eaaf7e3f77$export$3a8fd680da42627b(options = {}, hub = (0, $dCCRF.getCurrentHub)()) {
    // doesn't work without a document (React Native)
    if (!(0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    const script = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $ed718128583bba82$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const injectionPoint = (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document.head || (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $bcf1d3eaaf7e3f77$export$5d4e9fd7fac8e617() {
    return (0, $dCCRF.getCurrentHub)().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $bcf1d3eaaf7e3f77$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $bcf1d3eaaf7e3f77$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $bcf1d3eaaf7e3f77$export$4909b86c8034bf73(timeout) {
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Cannot flush events. No client defined.');
    return (0, $gG0fI.resolvedSyncPromise)(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $bcf1d3eaaf7e3f77$export$8360e631d277ea4d(timeout) {
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $gG0fI.resolvedSyncPromise)(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bcf1d3eaaf7e3f77$export$4997ffc0176396a6(fn) {
    return (0, $90fcfb6bcbc0de91$export$4997ffc0176396a6)(fn)();
}
function $bcf1d3eaaf7e3f77$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $bcf1d3eaaf7e3f77$var$startSessionTracking() {
    if (typeof (0, $90fcfb6bcbc0de91$export$56d8a8a25bd48b81).document === 'undefined') {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    const hub = (0, $dCCRF.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $bcf1d3eaaf7e3f77$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('history', ({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $bcf1d3eaaf7e3f77$var$startSessionOnHub((0, $dCCRF.getCurrentHub)());
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $bcf1d3eaaf7e3f77$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    if (client) client.captureUserFeedback(feedback);
}


var $7bmu9 = parcelRequire("7bmu9");
var $7Ff5S = parcelRequire("7Ff5S");
var $dCCRF = parcelRequire("dCCRF");

var $j2xvW = parcelRequire("j2xvW");
var $9rzL4 = parcelRequire("9rzL4");
var $01qnz = parcelRequire("01qnz");
var $iR5Fj = parcelRequire("iR5Fj");
var $eJSQB = parcelRequire("eJSQB");
var $qyIZA = parcelRequire("qyIZA");
var $hnodz = parcelRequire("hnodz");
var $kRbV8 = parcelRequire("kRbV8");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $65bd167596a7c256$var$WINDOW = (0, $01qnz.GLOBAL_OBJ);
const $65bd167596a7c256$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $65bd167596a7c256$var$REPLAY_EVENT_NAME = 'replay_event';
const $65bd167596a7c256$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $65bd167596a7c256$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $65bd167596a7c256$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
// The maximum length of a session
const $65bd167596a7c256$var$MAX_SESSION_LIFE = 3600000; // 60 minutes in ms
/** Default flush delays */ const $65bd167596a7c256$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $65bd167596a7c256$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $65bd167596a7c256$var$BUFFER_CHECKOUT_TIME = 60000;
const $65bd167596a7c256$var$RETRY_BASE_INTERVAL = 5000;
const $65bd167596a7c256$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $65bd167596a7c256$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $65bd167596a7c256$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $65bd167596a7c256$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $65bd167596a7c256$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $65bd167596a7c256$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $65bd167596a7c256$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $65bd167596a7c256$var$MIN_REPLAY_DURATION_LIMIT = 15000;
var $65bd167596a7c256$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($65bd167596a7c256$var$NodeType$1 || ($65bd167596a7c256$var$NodeType$1 = {}));
function $65bd167596a7c256$var$isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $65bd167596a7c256$var$isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function $65bd167596a7c256$var$isInputTypeMasked({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName.toLowerCase() === 'option') tagName = 'select';
    const actualType = typeof type === 'string' ? type.toLowerCase() : undefined;
    return maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType] || actualType === 'password' || tagName === 'input' && !type && maskInputOptions['text'];
}
function $65bd167596a7c256$var$hasInputMaskOptions({ tagName: tagName, type: type, maskInputOptions: maskInputOptions, maskInputSelector: maskInputSelector }) {
    return maskInputSelector || $65bd167596a7c256$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    });
}
function $65bd167596a7c256$var$maskInputValue({ input: input, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskInputOptions: maskInputOptions, tagName: tagName, type: type, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (unmaskInputSelector && input.matches(unmaskInputSelector)) return text;
    if (input.hasAttribute('data-rr-is-password')) type = 'password';
    if ($65bd167596a7c256$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    }) || maskInputSelector && input.matches(maskInputSelector)) {
        if (maskInputFn) text = maskInputFn(text);
        else text = '*'.repeat(text.length);
    }
    return text;
}
const $65bd167596a7c256$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $65bd167596a7c256$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $65bd167596a7c256$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$65bd167596a7c256$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $65bd167596a7c256$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? type.toLowerCase() : null;
}
function $65bd167596a7c256$var$getInputValue(el, tagName, type) {
    typeof type === 'string' && type.toLowerCase();
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
let $65bd167596a7c256$var$_id = 1;
const $65bd167596a7c256$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $65bd167596a7c256$var$IGNORED_NODE = -2;
function $65bd167596a7c256$var$defaultMaskFn(str) {
    return str ? str.replace(/[\S]/g, '*') : '';
}
function $65bd167596a7c256$var$genId() {
    return $65bd167596a7c256$var$_id++;
}
function $65bd167596a7c256$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = element.tagName.toLowerCase().trim();
    if ($65bd167596a7c256$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $65bd167596a7c256$var$getCssRulesString(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map($65bd167596a7c256$var$getCssRuleString).join('') : null;
    } catch (error) {
        return null;
    }
}
function $65bd167596a7c256$var$getCssRuleString(rule) {
    let cssStringified = rule.cssText;
    if ($65bd167596a7c256$var$isCSSImportRule(rule)) try {
        cssStringified = $65bd167596a7c256$var$getCssRulesString(rule.styleSheet) || cssStringified;
    } catch (_a) {}
    return $65bd167596a7c256$var$validateStringifiedCssRule(cssStringified);
}
function $65bd167596a7c256$var$validateStringifiedCssRule(cssStringified) {
    if (cssStringified.indexOf(':') > -1) {
        const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
        return cssStringified.replace(regex, '$1\\$2');
    }
    return cssStringified;
}
function $65bd167596a7c256$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $65bd167596a7c256$var$stringifyStyleSheet(sheet) {
    return sheet.cssRules ? Array.from(sheet.cssRules).map((rule)=>rule.cssText ? $65bd167596a7c256$var$validateStringifiedCssRule(rule.cssText) : '').join('') : '';
}
function $65bd167596a7c256$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $65bd167596a7c256$var$canvasService;
let $65bd167596a7c256$var$canvasCtx;
const $65bd167596a7c256$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $65bd167596a7c256$var$RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
const $65bd167596a7c256$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $65bd167596a7c256$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($65bd167596a7c256$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if (!$65bd167596a7c256$var$RELATIVE_PATH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($65bd167596a7c256$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$65bd167596a7c256$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $65bd167596a7c256$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $65bd167596a7c256$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $65bd167596a7c256$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        let match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    let output = [];
    while(true){
        collectCharacters($65bd167596a7c256$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($65bd167596a7c256$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $65bd167596a7c256$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $65bd167596a7c256$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                let c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $65bd167596a7c256$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $65bd167596a7c256$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $65bd167596a7c256$var$getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $65bd167596a7c256$var$transformAttribute(doc, element, _tagName, _name, value, maskAllText, unmaskTextSelector, maskTextFn) {
    if (!value) return value;
    const name = _name.toLowerCase();
    const tagName = _tagName.toLowerCase();
    if (name === 'src' || name === 'href') return $65bd167596a7c256$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $65bd167596a7c256$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $65bd167596a7c256$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $65bd167596a7c256$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $65bd167596a7c256$var$absoluteToStylesheet(value, $65bd167596a7c256$var$getHref());
    else if (tagName === 'object' && name === 'data') return $65bd167596a7c256$var$absoluteToDoc(doc, value);
    else if (maskAllText && $65bd167596a7c256$var$_shouldMaskAttribute(element, name, tagName, unmaskTextSelector)) return maskTextFn ? maskTextFn(value) : $65bd167596a7c256$var$defaultMaskFn(value);
    return value;
}
function $65bd167596a7c256$var$_shouldMaskAttribute(element, attribute, tagName, unmaskTextSelector) {
    if (unmaskTextSelector && element.matches(unmaskTextSelector)) return false;
    return [
        'placeholder',
        'title',
        'aria-label'
    ].indexOf(attribute) > -1 || tagName === 'input' && attribute === 'value' && element.hasAttribute('type') && [
        'submit',
        'button'
    ].indexOf(element.getAttribute('type').toLowerCase()) > -1;
}
function $65bd167596a7c256$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    if (unblockSelector && element.matches(unblockSelector)) return false;
    if (typeof blockClass === 'string') {
        if (element.classList.contains(blockClass)) return true;
    } else for(let eIndex = 0; eIndex < element.classList.length; eIndex++){
        const className = element.classList[eIndex];
        if (blockClass.test(className)) return true;
    }
    if (blockSelector) return element.matches(blockSelector);
    return false;
}
function $65bd167596a7c256$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) {
    if (!node) return false;
    if (node.nodeType !== node.ELEMENT_NODE) return $65bd167596a7c256$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
    if (unmaskTextSelector) {
        if (node.matches(unmaskTextSelector) || node.closest(unmaskTextSelector)) return false;
    }
    if (maskAllText) return true;
    if (typeof maskTextClass === 'string') {
        if (node.classList.contains(maskTextClass)) return true;
    } else for(let eIndex = 0; eIndex < node.classList.length; eIndex++){
        const className = node.classList[eIndex];
        if (maskTextClass.test(className)) return true;
    }
    if (maskTextSelector) {
        if (node.matches(maskTextSelector)) return true;
    }
    return $65bd167596a7c256$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
}
function $65bd167596a7c256$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener('load', listener);
}
function $65bd167596a7c256$var$serializeNode(n, options) {
    var _a;
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskAllText: maskAllText, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn } = options;
    let rootId;
    if (doc.__sn) {
        const docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $65bd167596a7c256$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode,
                rootId: rootId
            };
            else return {
                type: $65bd167596a7c256$var$NodeType$1.Document,
                childNodes: [],
                rootId: rootId
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $65bd167596a7c256$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            const needBlock = $65bd167596a7c256$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
            const tagName = $65bd167596a7c256$var$getValidTagName(n);
            let attributes = {};
            for (const { name: name, value: value } of Array.from(n.attributes))if (!$65bd167596a7c256$var$skipAttribute(tagName, name)) attributes[name] = $65bd167596a7c256$var$transformAttribute(doc, n, tagName, name, value, maskAllText, unmaskTextSelector, maskTextFn);
            if (tagName === 'link' && inlineStylesheet) {
                const stylesheet = Array.from(doc.styleSheets).find((s)=>{
                    return s.href === n.href;
                });
                let cssText = null;
                if (stylesheet) cssText = $65bd167596a7c256$var$getCssRulesString(stylesheet);
                if (cssText) {
                    delete attributes.rel;
                    delete attributes.href;
                    attributes._cssText = $65bd167596a7c256$var$absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
                const cssText = $65bd167596a7c256$var$getCssRulesString(n.sheet);
                if (cssText) attributes._cssText = $65bd167596a7c256$var$absoluteToStylesheet(cssText, $65bd167596a7c256$var$getHref());
            }
            if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
                const el = n;
                const type = $65bd167596a7c256$var$getInputType(el);
                const value = $65bd167596a7c256$var$getInputValue(el, tagName.toUpperCase(), type);
                const checked = n.checked;
                if (type !== 'submit' && type !== 'button' && value) attributes.value = $65bd167596a7c256$var$maskInputValue({
                    input: el,
                    type: type,
                    tagName: tagName,
                    value: value,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
                if (checked) attributes.checked = checked;
            }
            if (tagName === 'option') {
                if (n.selected && !maskInputOptions['select']) attributes.selected = true;
                else delete attributes.selected;
            }
            if (tagName === 'canvas' && recordCanvas) {
                if (n.__context === '2d') {
                    if (!$65bd167596a7c256$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                } else if (!('__context' in n)) {
                    const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    const blankCanvas = document.createElement('canvas');
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
                }
            }
            if (tagName === 'img' && inlineImages) {
                if (!$65bd167596a7c256$var$canvasService) {
                    $65bd167596a7c256$var$canvasService = doc.createElement('canvas');
                    $65bd167596a7c256$var$canvasCtx = $65bd167596a7c256$var$canvasService.getContext('2d');
                }
                const image = n;
                const oldValue = image.crossOrigin;
                image.crossOrigin = 'anonymous';
                const recordInlineImage = ()=>{
                    try {
                        $65bd167596a7c256$var$canvasService.width = image.naturalWidth;
                        $65bd167596a7c256$var$canvasService.height = image.naturalHeight;
                        $65bd167596a7c256$var$canvasCtx.drawImage(image, 0, 0);
                        attributes.rr_dataURL = $65bd167596a7c256$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    } catch (err) {
                        console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
                    }
                    oldValue ? attributes.crossOrigin = oldValue : delete attributes.crossOrigin;
                };
                if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                else image.onload = recordInlineImage;
            }
            if (tagName === 'audio' || tagName === 'video') {
                attributes.rr_mediaState = n.paused ? 'paused' : 'played';
                attributes.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
            if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
            if (needBlock) {
                const { width: width, height: height } = n.getBoundingClientRect();
                attributes = {
                    class: attributes.class,
                    rr_width: `${width}px`,
                    rr_height: `${height}px`
                };
            }
            if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
                if (!n.contentDocument) attributes.rr_src = attributes.src;
                delete attributes.src;
            }
            return {
                type: $65bd167596a7c256$var$NodeType$1.Element,
                tagName: tagName,
                attributes: attributes,
                childNodes: [],
                isSVG: $65bd167596a7c256$var$isSVGElement(n) || undefined,
                needBlock: needBlock,
                rootId: rootId
            };
        case n.TEXT_NODE:
            const parentTagName = n.parentNode && n.parentNode.tagName;
            let textContent = n.textContent;
            const isStyle = parentTagName === 'STYLE' ? true : undefined;
            const isScript = parentTagName === 'SCRIPT' ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) ;
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $65bd167596a7c256$var$stringifyStyleSheet(n.parentNode.sheet);
                } catch (err) {
                    console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
                }
                textContent = $65bd167596a7c256$var$absoluteToStylesheet(textContent, $65bd167596a7c256$var$getHref());
            }
            if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
            if (parentTagName === 'TEXTAREA' && textContent) textContent = '';
            else if (parentTagName === 'OPTION' && textContent) {
                const option = n.parentNode;
                textContent = $65bd167596a7c256$var$maskInputValue({
                    input: option,
                    type: null,
                    tagName: parentTagName,
                    value: textContent,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
            } else if (!isStyle && !isScript && $65bd167596a7c256$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) && textContent) textContent = maskTextFn ? maskTextFn(textContent) : $65bd167596a7c256$var$defaultMaskFn(textContent);
            return {
                type: $65bd167596a7c256$var$NodeType$1.Text,
                textContent: textContent || '',
                isStyle: isStyle,
                rootId: rootId
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: $65bd167596a7c256$var$NodeType$1.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $65bd167596a7c256$var$NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $65bd167596a7c256$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $65bd167596a7c256$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $65bd167596a7c256$var$NodeType$1.Comment) return true;
    else if (sn.type === $65bd167596a7c256$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($65bd167596a7c256$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'application-name' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.rel) === 'icon' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $65bd167596a7c256$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($65bd167596a7c256$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'robots' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'author' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'generator' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'framework' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'publisher' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'progid' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $65bd167596a7c256$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'verification' || $65bd167596a7c256$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $65bd167596a7c256$var$serializeNodeWithId(n, options) {
    const { doc: doc, map: map, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskAllText: maskAllText, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $65bd167596a7c256$var$serializeNode(n, {
        doc: doc,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputSelector: maskInputSelector,
        unmaskInputSelector: unmaskInputSelector,
        maskAllText: maskAllText,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if ('__sn' in n) id = n.__sn.id;
    else if ($65bd167596a7c256$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $65bd167596a7c256$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $65bd167596a7c256$var$IGNORED_NODE;
    else id = $65bd167596a7c256$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    n.__sn = serializedNode;
    if (id === $65bd167596a7c256$var$IGNORED_NODE) return null;
    map[id] = n;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $65bd167596a7c256$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $65bd167596a7c256$var$NodeType$1.Document || serializedNode.type === $65bd167596a7c256$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && _serializedNode.type === $65bd167596a7c256$var$NodeType$1.Element && _serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            map: map,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $65bd167596a7c256$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($65bd167596a7c256$var$isElement(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $65bd167596a7c256$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedChildNode.isShadow = true;
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $65bd167596a7c256$var$isShadowRoot(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $65bd167596a7c256$var$NodeType$1.Element && serializedNode.tagName === 'iframe') $65bd167596a7c256$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $65bd167596a7c256$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                map: map,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskAllText: maskAllText,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    return serializedNode;
}
function $65bd167596a7c256$var$snapshot(n, options) {
    const { blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskTextClass: maskTextClass = 'rr-mask', maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskInputSelector: maskInputSelector = null, unmaskInputSelector: unmaskInputSelector = null, maskAllText: maskAllText = false, maskAllInputs: maskAllInputs = false, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const idNodeMap = {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return [
        $65bd167596a7c256$var$serializeNodeWithId(n, {
            doc: n,
            map: idNodeMap,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: false,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        }),
        idNodeMap
    ];
}
function $65bd167596a7c256$var$skipAttribute(tagName, attributeName, value) {
    return (tagName === 'video' || tagName === 'audio') && attributeName === 'autoplay';
}
var $65bd167596a7c256$var$EventType;
(function(EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})($65bd167596a7c256$var$EventType || ($65bd167596a7c256$var$EventType = {}));
var $65bd167596a7c256$var$IncrementalSource;
(function(IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})($65bd167596a7c256$var$IncrementalSource || ($65bd167596a7c256$var$IncrementalSource = {}));
var $65bd167596a7c256$var$MouseInteractions;
(function(MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})($65bd167596a7c256$var$MouseInteractions || ($65bd167596a7c256$var$MouseInteractions = {}));
var $65bd167596a7c256$var$CanvasContext;
(function(CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})($65bd167596a7c256$var$CanvasContext || ($65bd167596a7c256$var$CanvasContext = {}));
var $65bd167596a7c256$var$MediaInteractions;
(function(MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})($65bd167596a7c256$var$MediaInteractions || ($65bd167596a7c256$var$MediaInteractions = {}));
var $65bd167596a7c256$var$ReplayerEvents;
(function(ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})($65bd167596a7c256$var$ReplayerEvents || ($65bd167596a7c256$var$ReplayerEvents = {}));
function $65bd167596a7c256$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
function $65bd167596a7c256$var$createMirror() {
    return {
        map: {},
        getId (n) {
            if (!n || !n.__sn) return -1;
            return n.__sn.id;
        },
        getNode (id) {
            return this.map[id] || null;
        },
        removeNodeFromMap (n) {
            const id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) n.childNodes.forEach((child)=>this.removeNodeFromMap(child));
        },
        has (id) {
            return this.map.hasOwnProperty(id);
        },
        reset () {
            this.map = {};
        }
    };
}
const $65bd167596a7c256$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $65bd167596a7c256$var$_mirror = {
    map: {},
    getId () {
        console.error($65bd167596a7c256$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($65bd167596a7c256$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($65bd167596a7c256$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($65bd167596a7c256$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($65bd167596a7c256$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $65bd167596a7c256$var$_mirror = new Proxy($65bd167596a7c256$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($65bd167596a7c256$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $65bd167596a7c256$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(arg) {
        let now = Date.now();
        if (!previous && options.leading === false) previous = now;
        let remaining = wait - (now - previous);
        let context = this;
        let args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $65bd167596a7c256$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$65bd167596a7c256$var$hookSetter(target, key, original || {}, true);
}
function $65bd167596a7c256$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (_a) {
        return ()=>{};
    }
}
function $65bd167596a7c256$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $65bd167596a7c256$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $65bd167596a7c256$var$isBlocked(node, blockClass, blockSelector, unblockSelector) {
    if (!node) return false;
    if (node.nodeType === node.ELEMENT_NODE) {
        let needBlock = false;
        const needUnblock = unblockSelector && node.matches(unblockSelector);
        if (typeof blockClass === 'string') {
            if (node.closest !== undefined) needBlock = !needUnblock && node.closest('.' + blockClass) !== null;
            else needBlock = !needUnblock && node.classList.contains(blockClass);
        } else !needUnblock && node.classList.forEach((className)=>{
            if (blockClass.test(className)) needBlock = true;
        });
        if (!needBlock && blockSelector) needBlock = node.matches(blockSelector);
        return !needUnblock && needBlock || $65bd167596a7c256$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    }
    if (node.nodeType === node.TEXT_NODE) return $65bd167596a7c256$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    return $65bd167596a7c256$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
}
function $65bd167596a7c256$var$isIgnored(n) {
    if ('__sn' in n) return n.__sn.id === $65bd167596a7c256$var$IGNORED_NODE;
    return false;
}
function $65bd167596a7c256$var$isAncestorRemoved(target, mirror) {
    if ($65bd167596a7c256$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $65bd167596a7c256$var$isAncestorRemoved(target.parentNode, mirror);
}
function $65bd167596a7c256$var$isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $65bd167596a7c256$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function contains(node) {
        if (!(0 in arguments)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $65bd167596a7c256$var$isIframeINode(node) {
    if ('__sn' in node) return node.__sn.type === $65bd167596a7c256$var$NodeType$1.Element && node.__sn.tagName === 'iframe';
    return false;
}
function $65bd167596a7c256$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
function $65bd167596a7c256$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $65bd167596a7c256$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $65bd167596a7c256$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $65bd167596a7c256$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $65bd167596a7c256$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
function $65bd167596a7c256$var$isINode(n) {
    return '__sn' in n;
}
class $65bd167596a7c256$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addList = new $65bd167596a7c256$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $65bd167596a7c256$var$IGNORED_NODE;
                while(nextId === $65bd167596a7c256$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                var _a, _b, _c, _d, _e;
                const shadowHost = n.getRootNode ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host : null;
                let rootShadowHost = shadowHost;
                while((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)rootShadowHost = ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) || null;
                const notInDoc = !this.doc.contains(n) && (!rootShadowHost || !this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) return;
                const parentId = $65bd167596a7c256$var$isShadowRoot(n.parentNode) ? this.mirror.getId(shadowHost) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                let sn = $65bd167596a7c256$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    map: this.mirror.map,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    maskInputSelector: this.maskInputSelector,
                    unmaskInputSelector: this.unmaskInputSelector,
                    skipChild: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskAllText: this.maskAllText,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($65bd167596a7c256$var$isIframeINode(currentN)) this.iframeManager.addIframe(currentN);
                        if ($65bd167596a7c256$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    }
                });
                if (sn) adds.push({
                    parentId: parentId,
                    nextId: nextId,
                    node: sn
                });
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($65bd167596a7c256$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$65bd167596a7c256$var$isAncestorInSet(this.droppedSet, n) && !$65bd167596a7c256$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($65bd167596a7c256$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) for(let index = addList.length - 1; index >= 0; index--){
                    const _node = addList.get(index);
                    if (_node) {
                        const parentId = this.mirror.getId(_node.value.parentNode);
                        const nextId = getNextId(_node.value);
                        if (parentId !== -1 && nextId !== -1) {
                            node = _node;
                            break;
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>({
                        id: this.mirror.getId(attribute.node),
                        attributes: attribute.attributes
                    })).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($65bd167596a7c256$var$isIgnored(m.target)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$65bd167596a7c256$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) && value !== m.oldValue) this.texts.push({
                            value: $65bd167596a7c256$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let value = target.getAttribute(m.attributeName);
                        if (m.attributeName === 'value') value = $65bd167596a7c256$var$maskInputValue({
                            input: target,
                            maskInputSelector: this.maskInputSelector,
                            unmaskInputSelector: this.unmaskInputSelector,
                            maskInputOptions: this.maskInputOptions,
                            tagName: target.tagName,
                            type: target.getAttribute('type'),
                            value: value,
                            maskInputFn: this.maskInputFn
                        });
                        if ($65bd167596a7c256$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {}
                            };
                            this.attributes.push(item);
                        }
                        if (m.attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (m.attributeName === 'style') {
                            const old = this.doc.createElement('span');
                            if (m.oldValue) old.setAttribute('style', m.oldValue);
                            if (item.attributes.style === undefined || item.attributes.style === null) item.attributes.style = {};
                            try {
                                const styleObj = item.attributes.style;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') styleObj[pname] = newValue;
                                        else styleObj[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') styleObj[pname] = false;
                            } catch (error) {
                                console.warn('[rrweb] Error when parsing update to style attribute:', error);
                            }
                        } else {
                            const element = m.target;
                            item.attributes[m.attributeName] = $65bd167596a7c256$var$transformAttribute(this.doc, element, element.tagName, m.attributeName, value, this.maskAllText, this.unmaskTextSelector, this.maskTextFn);
                        }
                        break;
                    }
                case 'childList':
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $65bd167596a7c256$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($65bd167596a7c256$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || $65bd167596a7c256$var$isIgnored(n)) return;
                        if (this.addedSet.has(n)) {
                            $65bd167596a7c256$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($65bd167596a7c256$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$65bd167596a7c256$var$moveKey(nodeId, parentId)]) $65bd167596a7c256$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $65bd167596a7c256$var$isShadowRoot(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (target && $65bd167596a7c256$var$isBlocked(target, this.blockClass, this.blockSelector, this.unblockSelector)) return;
            if ($65bd167596a7c256$var$isINode(n)) {
                if ($65bd167596a7c256$var$isIgnored(n)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && $65bd167596a7c256$var$isINode(target)) targetId = target.__sn.id;
                if (targetId) this.movedMap[$65bd167596a7c256$var$moveKey(n.__sn.id, targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$65bd167596a7c256$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector)) n.childNodes.forEach((childN)=>this.genAdds(childN));
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'maskInputSelector',
            'unmaskInputSelector',
            'inlineStylesheet',
            'maskAllText',
            'maskInputOptions',
            'maskTextFn',
            'maskInputFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'doc',
            'mirror',
            'iframeManager',
            'shadowDomManager',
            'canvasManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $65bd167596a7c256$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$65bd167596a7c256$var$deepDelete(addsSet, childN));
}
function $65bd167596a7c256$var$isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $65bd167596a7c256$var$isParentRemoved(removes, parentNode, mirror);
}
function $65bd167596a7c256$var$isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $65bd167596a7c256$var$isAncestorInSet(set, parentNode);
}
const $65bd167596a7c256$var$callbackWrapper = (cb)=>{
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            try {
                error.__rrweb__ = true;
            } catch (_a) {}
            throw error;
        }
    };
    return rrwebWrapped;
};
const $65bd167596a7c256$var$mutationBuffers = [];
function $65bd167596a7c256$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (_a) {}
    return event && event.target;
}
function $65bd167596a7c256$var$initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new $65bd167596a7c256$var$MutationBuffer();
    $65bd167596a7c256$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($65bd167596a7c256$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $65bd167596a7c256$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $65bd167596a7c256$var$throttle$1((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        $65bd167596a7c256$var$callbackWrapper(mousemoveCb)(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    const updatePosition = $65bd167596a7c256$var$throttle$1((evt)=>{
        const target = $65bd167596a7c256$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $65bd167596a7c256$var$isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = Date.now();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $65bd167596a7c256$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $65bd167596a7c256$var$IncrementalSource.MouseMove : $65bd167596a7c256$var$IncrementalSource.TouchMove);
    }, threshold, {
        trailing: false
    });
    const handlers = [
        $65bd167596a7c256$var$on('mousemove', $65bd167596a7c256$var$callbackWrapper(updatePosition), doc),
        $65bd167596a7c256$var$on('touchmove', $65bd167596a7c256$var$callbackWrapper(updatePosition), doc),
        $65bd167596a7c256$var$on('drag', $65bd167596a7c256$var$callbackWrapper(updatePosition), doc)
    ];
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $65bd167596a7c256$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $65bd167596a7c256$var$getEventTarget(event);
            if ($65bd167596a7c256$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const e = $65bd167596a7c256$var$isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $65bd167596a7c256$var$callbackWrapper(mouseInteractionCb)({
                type: $65bd167596a7c256$var$MouseInteractions[eventKey],
                id: id,
                x: clientX,
                y: clientY
            });
        };
    };
    Object.keys($65bd167596a7c256$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        const eventName = eventKey.toLowerCase();
        const handler = $65bd167596a7c256$var$callbackWrapper(getHandler(eventKey));
        handlers.push($65bd167596a7c256$var$on(eventName, handler, doc));
    });
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $65bd167596a7c256$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $65bd167596a7c256$var$throttle$1((evt)=>{
        const target = $65bd167596a7c256$var$getEventTarget(evt);
        if (!target || $65bd167596a7c256$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const id = mirror.getId(target);
        if (target === doc) {
            const scrollEl = doc.scrollingElement || doc.documentElement;
            $65bd167596a7c256$var$callbackWrapper(scrollCb)({
                id: id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop
            });
        } else $65bd167596a7c256$var$callbackWrapper(scrollCb)({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }, sampling.scroll || 100);
    return $65bd167596a7c256$var$on('scroll', $65bd167596a7c256$var$callbackWrapper(updatePosition), doc);
}
function $65bd167596a7c256$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $65bd167596a7c256$var$throttle$1(()=>{
        const height = $65bd167596a7c256$var$getWindowHeight();
        const width = $65bd167596a7c256$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            $65bd167596a7c256$var$callbackWrapper(viewportResizeCb)({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return $65bd167596a7c256$var$on('resize', $65bd167596a7c256$var$callbackWrapper(updateDimension), window);
}
function $65bd167596a7c256$var$wrapEventWithUserTriggeredFlag(v, enable) {
    const value = Object.assign({}, v);
    if (!enable) delete value.userTriggered;
    return value;
}
const $65bd167596a7c256$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $65bd167596a7c256$var$lastInputValueMap = new WeakMap();
function $65bd167596a7c256$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput }) {
    function eventHandler(event) {
        let target = $65bd167596a7c256$var$getEventTarget(event);
        const tagName = target && target.tagName;
        const userTriggered = event.isTrusted;
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $65bd167596a7c256$var$INPUT_TAGS.indexOf(tagName) < 0 || $65bd167596a7c256$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const el = target;
        const type = $65bd167596a7c256$var$getInputType(el);
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        let text = $65bd167596a7c256$var$getInputValue(el, tagName, type);
        let isChecked = false;
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        if ($65bd167596a7c256$var$hasInputMaskOptions({
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            tagName: tagName,
            type: type
        })) text = $65bd167596a7c256$var$maskInputValue({
            input: el,
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, $65bd167596a7c256$var$callbackWrapper($65bd167596a7c256$var$wrapEventWithUserTriggeredFlag)({
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        }, userTriggeredOnInput));
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $65bd167596a7c256$var$maskInputValue({
                    input: el,
                    maskInputOptions: maskInputOptions,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    tagName: tagName,
                    type: type,
                    value: $65bd167596a7c256$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, $65bd167596a7c256$var$callbackWrapper($65bd167596a7c256$var$wrapEventWithUserTriggeredFlag)({
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                }, userTriggeredOnInput));
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $65bd167596a7c256$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $65bd167596a7c256$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            inputCb(Object.assign(Object.assign({}, v), {
                id: id
            }));
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$65bd167596a7c256$var$on(eventName, $65bd167596a7c256$var$callbackWrapper(eventHandler), doc));
    const propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            HTMLInputElement.prototype,
            'value'
        ],
        [
            HTMLInputElement.prototype,
            'checked'
        ],
        [
            HTMLSelectElement.prototype,
            'value'
        ],
        [
            HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$65bd167596a7c256$var$hookSetter(p[0], p[1], {
            set () {
                $65bd167596a7c256$var$callbackWrapper(eventHandler)({
                    target: this
                });
            }
        })));
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $65bd167596a7c256$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($65bd167596a7c256$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $65bd167596a7c256$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $65bd167596a7c256$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $65bd167596a7c256$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $65bd167596a7c256$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $65bd167596a7c256$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $65bd167596a7c256$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const supportedNestedCSSRuleTypes = {};
    if ($65bd167596a7c256$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($65bd167596a7c256$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($65bd167596a7c256$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($65bd167596a7c256$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $65bd167596a7c256$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$65bd167596a7c256$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $65bd167596a7c256$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    removes: [
                        {
                            index: [
                                ...$65bd167596a7c256$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $65bd167596a7c256$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $65bd167596a7c256$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property, value, priority] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $65bd167596a7c256$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $65bd167596a7c256$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                remove: {
                    property: property
                },
                index: $65bd167596a7c256$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $65bd167596a7c256$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling }) {
    const handler = (type)=>$65bd167596a7c256$var$throttle$1($65bd167596a7c256$var$callbackWrapper((event)=>{
            const target = $65bd167596a7c256$var$getEventTarget(event);
            if (!target || $65bd167596a7c256$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const { currentTime: currentTime, volume: volume, muted: muted } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted
            });
        }), sampling.media || 500);
    const handlers = [
        $65bd167596a7c256$var$on('play', handler(0)),
        $65bd167596a7c256$var$on('pause', handler(1)),
        $65bd167596a7c256$var$on('seeked', handler(2)),
        $65bd167596a7c256$var$on('volumechange', handler(3))
    ];
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $65bd167596a7c256$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $65bd167596a7c256$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            setTimeout(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $65bd167596a7c256$var$mergeHooks(o, hooks) {
    const { mutationCb: mutationCb, mousemoveCb: mousemoveCb, mouseInteractionCb: mouseInteractionCb, scrollCb: scrollCb, viewportResizeCb: viewportResizeCb, inputCb: inputCb, mediaInteractionCb: mediaInteractionCb, styleSheetRuleCb: styleSheetRuleCb, styleDeclarationCb: styleDeclarationCb, canvasMutationCb: canvasMutationCb, fontCb: fontCb } = o;
    o.mutationCb = (...p)=>{
        if (hooks.mutation) hooks.mutation(...p);
        mutationCb(...p);
    };
    o.mousemoveCb = (...p)=>{
        if (hooks.mousemove) hooks.mousemove(...p);
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) hooks.mouseInteraction(...p);
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p)=>{
        if (hooks.scroll) hooks.scroll(...p);
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) hooks.viewportResize(...p);
        viewportResizeCb(...p);
    };
    o.inputCb = (...p)=>{
        if (hooks.input) hooks.input(...p);
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) hooks.mediaInteaction(...p);
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) hooks.styleSheetRule(...p);
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) hooks.styleDeclaration(...p);
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) hooks.canvasMutation(...p);
        canvasMutationCb(...p);
    };
    o.fontCb = (...p)=>{
        if (hooks.font) hooks.font(...p);
        fontCb(...p);
    };
}
function $65bd167596a7c256$var$initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    $65bd167596a7c256$var$mergeHooks(o, hooks);
    const mutationObserver = $65bd167596a7c256$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $65bd167596a7c256$var$initMoveObserver(o);
    const mouseInteractionHandler = $65bd167596a7c256$var$initMouseInteractionObserver(o);
    const scrollHandler = $65bd167596a7c256$var$initScrollObserver(o);
    const viewportResizeHandler = $65bd167596a7c256$var$initViewportResizeObserver(o);
    const inputHandler = $65bd167596a7c256$var$initInputObserver(o);
    const mediaInteractionHandler = $65bd167596a7c256$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $65bd167596a7c256$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const styleDeclarationObserver = $65bd167596a7c256$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $65bd167596a7c256$var$initFontObserver(o) : ()=>{};
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $65bd167596a7c256$var$callbackWrapper(()=>{
        $65bd167596a7c256$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        try {
            styleSheetObserver();
            styleDeclarationObserver();
        } catch (e) {}
        fontObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $65bd167596a7c256$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $65bd167596a7c256$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $65bd167596a7c256$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
    }
}
class $65bd167596a7c256$var$ShadowDomManager {
    constructor(options){
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        const manager = this;
        this.restorePatches.push($65bd167596a7c256$var$patch(HTMLElement.prototype, 'attachShadow', function(original) {
            return function() {
                const shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    addShadowRoot(shadowRoot, doc) {
        $65bd167596a7c256$var$initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot);
        $65bd167596a7c256$var$initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
    }
    observeAttachShadow(iframeElement) {
        if (iframeElement.contentWindow) {
            const manager = this;
            this.restorePatches.push($65bd167596a7c256$var$patch(iframeElement.contentWindow.HTMLElement.prototype, 'attachShadow', function(original) {
                return function() {
                    const shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    }
    reset() {
        this.restorePatches.forEach((restorePatch)=>restorePatch());
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $65bd167596a7c256$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $65bd167596a7c256$var$initCanvas2DMutationObserver(cb, win, blockClass, unblockSelector, blockSelector, mirror) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') continue;
        const restoreHandler = $65bd167596a7c256$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$65bd167596a7c256$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) setTimeout(()=>{
                    const recordArgs = [
                        ...args
                    ];
                    if (prop === 'drawImage') {
                        if (recordArgs[0] && recordArgs[0] instanceof HTMLCanvasElement) {
                            const canvas = recordArgs[0];
                            const ctx = canvas.getContext('2d');
                            let imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                            let pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                            recordArgs[0] = JSON.stringify(pix);
                        }
                    }
                    cb(this.canvas, {
                        type: $65bd167596a7c256$var$CanvasContext['2D'],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $65bd167596a7c256$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $65bd167596a7c256$var$CanvasContext['2D'],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $65bd167596a7c256$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    try {
        const restoreHandler = $65bd167596a7c256$var$patch(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType, ...args) {
                if (!$65bd167596a7c256$var$isBlocked(this, blockClass, blockSelector, unblockSelector)) {
                    if (!('__context' in this)) this.__context = contextType;
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $65bd167596a7c256$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $65bd167596a7c256$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $65bd167596a7c256$var$i = 0; $65bd167596a7c256$var$i < $65bd167596a7c256$var$chars.length; $65bd167596a7c256$var$i++)$65bd167596a7c256$var$lookup[$65bd167596a7c256$var$chars.charCodeAt($65bd167596a7c256$var$i)] = $65bd167596a7c256$var$i;
var $65bd167596a7c256$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $65bd167596a7c256$var$chars[bytes[i] >> 2];
        base64 += $65bd167596a7c256$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $65bd167596a7c256$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $65bd167596a7c256$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $65bd167596a7c256$var$webGLVarMap = new Map();
function $65bd167596a7c256$var$variableListFor(ctx, ctor) {
    let contextMap = $65bd167596a7c256$var$webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $65bd167596a7c256$var$webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $65bd167596a7c256$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($65bd167596a7c256$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object')) return;
    const name = value.constructor.name;
    const list = $65bd167596a7c256$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $65bd167596a7c256$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$65bd167596a7c256$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $65bd167596a7c256$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $65bd167596a7c256$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $65bd167596a7c256$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($65bd167596a7c256$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = $65bd167596a7c256$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $65bd167596a7c256$var$serializeArgs = (args, win, ctx)=>{
    return [
        ...args
    ].map((arg)=>$65bd167596a7c256$var$serializeArg(arg, win, ctx));
};
const $65bd167596a7c256$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $65bd167596a7c256$var$patchGLPrototype(prototype, type, cb, blockClass, unblockSelector, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props)try {
        if (typeof prototype[prop] !== 'function') continue;
        const restoreHandler = $65bd167596a7c256$var$patch(prototype, prop, function(original) {
            return function(...args) {
                const result = original.apply(this, args);
                $65bd167596a7c256$var$saveWebGLVar(result, win, prototype);
                if (!$65bd167596a7c256$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                    const id = mirror.getId(this.canvas);
                    const recordArgs = $65bd167596a7c256$var$serializeArgs([
                        ...args
                    ], win, prototype);
                    const mutation = {
                        type: type,
                        property: prop,
                        args: recordArgs
                    };
                    cb(this.canvas, mutation);
                }
                return result;
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $65bd167596a7c256$var$hookSetter(prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: type,
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return handlers;
}
function $65bd167596a7c256$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$65bd167596a7c256$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $65bd167596a7c256$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') handlers.push(...$65bd167596a7c256$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $65bd167596a7c256$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
class $65bd167596a7c256$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true) this.initCanvasMutationObserver(options.win, options.blockClass, options.blockSelector, options.unblockSelector);
    }
    initCanvasMutationObserver(win, blockClass, unblockSelector, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $65bd167596a7c256$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector);
        const canvas2DReset = $65bd167596a7c256$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        const canvasWebGL1and2Reset = $65bd167596a7c256$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const rest = $65bd167596a7c256$var$__rest(value, [
                "type"
            ]);
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
function $65bd167596a7c256$var$wrapEvent(e) {
    return Object.assign(Object.assign({}, e), {
        timestamp: Date.now()
    });
}
let $65bd167596a7c256$var$wrappedEmit;
let $65bd167596a7c256$var$takeFullSnapshot;
const $65bd167596a7c256$var$mirror = $65bd167596a7c256$var$createMirror();
function $65bd167596a7c256$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskTextClass: maskTextClass = 'rr-mask', maskTextSelector: maskTextSelector = null, maskInputSelector: maskInputSelector = null, unmaskTextSelector: unmaskTextSelector = null, unmaskInputSelector: unmaskInputSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllText: maskAllText = false, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn: maskInputFn, maskTextFn: maskTextFn, hooks: hooks, packFn: packFn, sampling: sampling = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, onMutation: onMutation } = options;
    if (!emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $65bd167596a7c256$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn) e = packFn(e);
        return e;
    };
    $65bd167596a7c256$var$wrappedEmit = (e, isCheckout)=>{
        var _a;
        if (((_a = $65bd167596a7c256$var$mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== $65bd167596a7c256$var$EventType.FullSnapshot && !(e.type === $65bd167596a7c256$var$EventType.IncrementalSnapshot && e.data.source === $65bd167596a7c256$var$IncrementalSource.Mutation)) $65bd167596a7c256$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        emit(eventProcessor(e), isCheckout);
        if (e.type === $65bd167596a7c256$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $65bd167596a7c256$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $65bd167596a7c256$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $65bd167596a7c256$var$takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
            type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
            data: Object.assign({
                source: $65bd167596a7c256$var$IncrementalSource.Mutation
            }, m)
        }));
    };
    const wrappedScrollEmit = (p)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
            type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
            data: Object.assign({
                source: $65bd167596a7c256$var$IncrementalSource.Scroll
            }, p)
        }));
    const wrappedCanvasMutationEmit = (p)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
            type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
            data: Object.assign({
                source: $65bd167596a7c256$var$IncrementalSource.CanvasMutation
            }, p)
        }));
    const iframeManager = new $65bd167596a7c256$var$IframeManager({
        mutationCb: wrappedMutationEmit
    });
    const canvasManager = new $65bd167596a7c256$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        mirror: $65bd167596a7c256$var$mirror
    });
    const shadowDomManager = new $65bd167596a7c256$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            canvasManager: canvasManager
        },
        mirror: $65bd167596a7c256$var$mirror
    });
    $65bd167596a7c256$var$takeFullSnapshot = (isCheckout = false)=>{
        var _a, _b, _c, _d;
        $65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
            type: $65bd167596a7c256$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $65bd167596a7c256$var$getWindowWidth(),
                height: $65bd167596a7c256$var$getWindowHeight()
            }
        }), isCheckout);
        $65bd167596a7c256$var$mutationBuffers.forEach((buf)=>buf.lock());
        const [node, idNodeMap] = $65bd167596a7c256$var$snapshot(document, {
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($65bd167596a7c256$var$isIframeINode(n)) iframeManager.addIframe(n);
                if ($65bd167596a7c256$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $65bd167596a7c256$var$mirror.map = idNodeMap;
        $65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
            type: $65bd167596a7c256$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: {
                    left: window.pageXOffset !== undefined ? window.pageXOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) || ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || (document === null || document === void 0 ? void 0 : document.body.scrollLeft) || 0,
                    top: window.pageYOffset !== undefined ? window.pageYOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) || ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) || (document === null || document === void 0 ? void 0 : document.body.scrollTop) || 0
                }
            }
        }));
        $65bd167596a7c256$var$mutationBuffers.forEach((buf)=>buf.unlock());
    };
    try {
        const handlers = [];
        handlers.push($65bd167596a7c256$var$on('DOMContentLoaded', ()=>{
            $65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                type: $65bd167596a7c256$var$EventType.DomContentLoaded,
                data: {}
            }));
        }));
        const observe = (doc)=>{
            var _a;
            return $65bd167596a7c256$var$callbackWrapper($65bd167596a7c256$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $65bd167596a7c256$var$IncrementalSource.MouseInteraction
                        }, d)
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $65bd167596a7c256$var$IncrementalSource.ViewportResize
                        }, d)
                    })),
                inputCb: (v)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $65bd167596a7c256$var$IncrementalSource.Input
                        }, v)
                    })),
                mediaInteractionCb: (p)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $65bd167596a7c256$var$IncrementalSource.MediaInteraction
                        }, p)
                    })),
                styleSheetRuleCb: (r)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $65bd167596a7c256$var$IncrementalSource.StyleSheetRule
                        }, r)
                    })),
                styleDeclarationCb: (r)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $65bd167596a7c256$var$IncrementalSource.StyleDeclaration
                        }, r)
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                        type: $65bd167596a7c256$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $65bd167596a7c256$var$IncrementalSource.Font
                        }, p)
                    })),
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAllText: maskAllText,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                mirror: $65bd167596a7c256$var$mirror,
                iframeManager: iframeManager,
                shadowDomManager: shadowDomManager,
                canvasManager: canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p)=>p.observer)) === null || _a === void 0 ? void 0 : _a.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                                type: $65bd167596a7c256$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }))
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            $65bd167596a7c256$var$takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else handlers.push($65bd167596a7c256$var$on('load', ()=>{
            $65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
                type: $65bd167596a7c256$var$EventType.Load,
                data: {}
            }));
            init();
        }, window));
        return ()=>{
            handlers.forEach((h)=>h());
        };
    } catch (error) {
        console.warn(error);
    }
}
$65bd167596a7c256$var$record.addCustomEvent = (tag, payload)=>{
    if (!$65bd167596a7c256$var$wrappedEmit) throw new Error('please add custom event after start recording');
    $65bd167596a7c256$var$wrappedEmit($65bd167596a7c256$var$wrapEvent({
        type: $65bd167596a7c256$var$EventType.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$65bd167596a7c256$var$record.freezePage = ()=>{
    $65bd167596a7c256$var$mutationBuffers.forEach((buf)=>buf.freeze());
};
$65bd167596a7c256$var$record.takeFullSnapshot = (isCheckout)=>{
    if (!$65bd167596a7c256$var$takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $65bd167596a7c256$var$takeFullSnapshot(isCheckout);
};
$65bd167596a7c256$var$record.mirror = $65bd167596a7c256$var$mirror;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $65bd167596a7c256$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $65bd167596a7c256$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $65bd167596a7c256$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        replay.throttledAddEvent({
            type: $65bd167596a7c256$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $e98b9d0181527907$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $65bd167596a7c256$var$INTERACTIVE_SELECTOR = 'button,a';
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $65bd167596a7c256$var$getClickTargetNode(event) {
    const target = $65bd167596a7c256$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    const closestInteractive = target.closest($65bd167596a7c256$var$INTERACTIVE_SELECTOR);
    return closestInteractive || target;
}
/** Get the event target node. */ function $65bd167596a7c256$var$getTargetNode(event) {
    if ($65bd167596a7c256$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $65bd167596a7c256$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $65bd167596a7c256$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $65bd167596a7c256$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$65bd167596a7c256$var$handlers) {
        $65bd167596a7c256$var$handlers = [];
        $65bd167596a7c256$var$monkeyPatchWindowOpen();
    }
    $65bd167596a7c256$var$handlers.push(cb);
    return ()=>{
        const pos = $65bd167596a7c256$var$handlers ? $65bd167596a7c256$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $65bd167596a7c256$var$handlers.splice(pos, 1);
    };
}
function $65bd167596a7c256$var$monkeyPatchWindowOpen() {
    (0, $9rzL4.fill)($65bd167596a7c256$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($65bd167596a7c256$var$handlers) try {
                $65bd167596a7c256$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($65bd167596a7c256$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $65bd167596a7c256$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $65bd167596a7c256$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $65bd167596a7c256$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const mutationHandler = ()=>{
            this._lastMutation = $65bd167596a7c256$var$nowInSeconds();
        };
        const scrollHandler = ()=>{
            this._lastScroll = $65bd167596a7c256$var$nowInSeconds();
        };
        const cleanupWindowOpen = $65bd167596a7c256$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $65bd167596a7c256$var$nowInSeconds();
        });
        const clickHandler = (event)=>{
            if (!event.target) return;
            const node = $65bd167596a7c256$var$getClickTargetNode(event);
            if (node) this._handleMultiClick(node);
        };
        const obs = new MutationObserver(mutationHandler);
        obs.observe($65bd167596a7c256$var$WINDOW.document.documentElement, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        $65bd167596a7c256$var$WINDOW.addEventListener('scroll', scrollHandler, {
            passive: true
        });
        $65bd167596a7c256$var$WINDOW.addEventListener('click', clickHandler, {
            passive: true
        });
        this._teardown = ()=>{
            $65bd167596a7c256$var$WINDOW.removeEventListener('scroll', scrollHandler);
            $65bd167596a7c256$var$WINDOW.removeEventListener('click', clickHandler);
            cleanupWindowOpen();
            obs.disconnect();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** Handle a click */ handleClick(breadcrumb, node) {
        if ($65bd167596a7c256$var$ignoreElement(node, this._ignoreSelector) || !$65bd167596a7c256$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $65bd167596a7c256$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $65bd167596a7c256$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $65bd167596a7c256$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $65bd167596a7c256$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $65bd167596a7c256$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $65bd167596a7c256$var$ignoreElement(node, ignoreSelector) {
    if (!$65bd167596a7c256$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $65bd167596a7c256$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $65bd167596a7c256$var$nowInSeconds() {
    return Date.now() / 1000;
}
/**
 * Create a breadcrumb for a replay.
 */ function $65bd167596a7c256$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $65bd167596a7c256$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($65bd167596a7c256$var$NodeType || ($65bd167596a7c256$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $65bd167596a7c256$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $65bd167596a7c256$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($65bd167596a7c256$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $65bd167596a7c256$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $65bd167596a7c256$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick && handlerData.event;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $65bd167596a7c256$var$handleClick(replay.clickDetector, result, $65bd167596a7c256$var$getClickTargetNode(handlerData.event));
        $65bd167596a7c256$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $65bd167596a7c256$var$getBaseDomBreadcrumb(target, message) {
    // `__sn` property is the serialized node created by rrweb
    const serializedNode = target && $65bd167596a7c256$var$isRrwebNode(target) && target.__sn.type === $65bd167596a7c256$var$NodeType.Element ? target.__sn : null;
    return {
        message: message,
        data: serializedNode ? {
            nodeId: serializedNode.id,
            node: {
                id: serializedNode.id,
                tagName: serializedNode.tagName,
                textContent: target ? Array.from(target.childNodes).map((node)=>'__sn' in node && node.__sn.type === $65bd167596a7c256$var$NodeType.Text && node.__sn.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join('') : '',
                attributes: $65bd167596a7c256$var$getAttributesToRecord(serializedNode.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $65bd167596a7c256$var$handleDom(handlerData) {
    const { target: target, message: message } = $65bd167596a7c256$var$getDomTarget(handlerData);
    return $65bd167596a7c256$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$65bd167596a7c256$var$getBaseDomBreadcrumb(target, message)
    });
}
function $65bd167596a7c256$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $65bd167596a7c256$var$getClickTargetNode(handlerData.event) : $65bd167596a7c256$var$getTargetNode(handlerData.event);
        message = (0, $iR5Fj.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $65bd167596a7c256$var$isRrwebNode(node) {
    return '__sn' in node;
}
/** Handle keyboard events & create breadcrumbs. */ function $65bd167596a7c256$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $65bd167596a7c256$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $65bd167596a7c256$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $65bd167596a7c256$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $65bd167596a7c256$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $iR5Fj.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $65bd167596a7c256$var$getBaseDomBreadcrumb(target, message);
    return $65bd167596a7c256$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $65bd167596a7c256$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
const $65bd167596a7c256$var$NAVIGATION_ENTRY_KEYS = [
    'name',
    'type',
    'startTime',
    'transferSize',
    'duration'
];
function $65bd167596a7c256$var$isNavigationEntryEqual(a) {
    return function(b) {
        return $65bd167596a7c256$var$NAVIGATION_ENTRY_KEYS.every((key)=>a[key] === b[key]);
    };
}
/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */ // TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $65bd167596a7c256$var$dedupePerformanceEntries(currentList, newList) {
    // Partition `currentList` into 3 different lists based on entryType
    const [existingNavigationEntries, existingLcpEntries, existingEntries] = currentList.reduce((acc, entry)=>{
        if (entry.entryType === 'navigation') acc[0].push(entry);
        else if (entry.entryType === 'largest-contentful-paint') acc[1].push(entry);
        else acc[2].push(entry);
        return acc;
    }, [
        [],
        [],
        []
    ]);
    const newEntries = [];
    const newNavigationEntries = [];
    let newLcpEntry = existingLcpEntries.length ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
     : undefined;
    newList.forEach((entry)=>{
        if (entry.entryType === 'largest-contentful-paint') {
            // We want the latest LCP event only
            if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) newLcpEntry = entry;
            return;
        }
        if (entry.entryType === 'navigation') {
            const navigationEntry = entry;
            // Check if the navigation entry is contained in currentList or newList
            if (// Ignore any navigation entries with duration 0, as they are likely duplicates
            entry.duration > 0 && // Ensure new entry does not already exist in existing entries
            !existingNavigationEntries.find($65bd167596a7c256$var$isNavigationEntryEqual(navigationEntry)) && // Ensure new entry does not already exist in new list of navigation entries
            !newNavigationEntries.find($65bd167596a7c256$var$isNavigationEntryEqual(navigationEntry))) newNavigationEntries.push(navigationEntry);
            // Otherwise this navigation entry is considered a duplicate and is thrown away
            return;
        }
        newEntries.push(entry);
    });
    // Re-combine and sort by startTime
    return [
        ...newLcpEntry ? [
            newLcpEntry
        ] : [],
        ...existingNavigationEntries,
        ...existingEntries,
        ...newEntries,
        ...newNavigationEntries
    ].sort((a, b)=>a.startTime - b.startTime);
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */ function $65bd167596a7c256$var$setupPerformanceObserver(replay) {
    const performanceObserverHandler = (list)=>{
        // For whatever reason the observer was returning duplicate navigation
        // entries (the other entry types were not duplicated).
        const newPerformanceEntries = $65bd167596a7c256$var$dedupePerformanceEntries(replay.performanceEvents, list.getEntries());
        replay.performanceEvents = newPerformanceEntries;
    };
    const performanceObserver = new PerformanceObserver(performanceObserverHandler);
    [
        'element',
        'event',
        'first-input',
        'largest-contentful-paint',
        'layout-shift',
        'longtask',
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        try {
            performanceObserver.observe({
                type: type,
                buffered: true
            });
        } catch (e) {
        // This can throw if an entry type is not supported in the browser.
        // Ignore these errors.
        }
    });
    return performanceObserver;
}
const $65bd167596a7c256$var$r = `/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function t(t){let e=t.length;for(;--e>=0;)t[e]=0}const e=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),a=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),i=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),n=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=new Array(576);t(s);const r=new Array(60);t(r);const o=new Array(512);t(o);const l=new Array(256);t(l);const h=new Array(29);t(h);const d=new Array(30);function _(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}let f,c,u;function w(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}t(d);const m=t=>t<256?o[t]:o[256+(t>>>7)],b=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},g=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,b(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},p=(t,e,a)=>{g(t,a[2*e],a[2*e+1])},k=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},v=(t,e,a)=>{const i=new Array(16);let n,s,r=0;for(n=1;n<=15;n++)r=r+a[n-1]<<1,i[n]=r;for(s=0;s<=e;s++){let e=t[2*s+1];0!==e&&(t[2*s]=k(i[e]++,e))}},y=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.sym_next=t.matches=0},x=t=>{t.bi_valid>8?b(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},z=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},A=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&z(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!z(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i},E=(t,i,n)=>{let s,r,o,_,f=0;if(0!==t.sym_next)do{s=255&t.pending_buf[t.sym_buf+f++],s+=(255&t.pending_buf[t.sym_buf+f++])<<8,r=t.pending_buf[t.sym_buf+f++],0===s?p(t,r,i):(o=l[r],p(t,o+256+1,i),_=e[o],0!==_&&(r-=h[o],g(t,r,_)),s--,o=m(s),p(t,o,n),_=a[o],0!==_&&(s-=d[o],g(t,s,_)))}while(f<t.sym_next);p(t,256,i)},R=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,s=e.stat_desc.elems;let r,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<s;r++)0!==a[2*r]?(t.heap[++t.heap_len]=h=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)l=t.heap[++t.heap_len]=h<2?++h:0,a[2*l]=1,t.depth[l]=0,t.opt_len--,n&&(t.static_len-=i[2*l+1]);for(e.max_code=h,r=t.heap_len>>1;r>=1;r--)A(t,a,r);l=s;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],A(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=o,a[2*l]=a[2*r]+a[2*o],t.depth[l]=(t.depth[r]>=t.depth[o]?t.depth[r]:t.depth[o])+1,a[2*r+1]=a[2*o+1]=l,t.heap[1]=l++,A(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,s=e.stat_desc.has_stree,r=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)d=t.heap[h],f=a[2*a[2*d+1]+1]+1,f>l&&(f=l,w++),a[2*d+1]=f,d>i||(t.bl_count[f]++,c=0,d>=o&&(c=r[d-o]),u=a[2*d],t.opt_len+=u*(f+c),s&&(t.static_len+=u*(n[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)_=t.heap[--h],_>i||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--)}})(t,e),v(a,h,t.bl_count)},Z=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++o<l&&n===r||(o<h?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4))},U=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++o<l&&n===r)){if(o<h)do{p(t,n,t.bl_tree)}while(0!=--o);else 0!==n?(n!==s&&(p(t,n,t.bl_tree),o--),p(t,16,t.bl_tree),g(t,o-3,2)):o<=10?(p(t,17,t.bl_tree),g(t,o-3,3)):(p(t,18,t.bl_tree),g(t,o-11,7));o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4)}};let S=!1;const D=(t,e,a,i)=>{g(t,0+(i?1:0),3),x(t),b(t,a),b(t,~a),a&&t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a};var T=(t,e,a,i)=>{let o,l,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),R(t,t.l_desc),R(t,t.d_desc),h=(t=>{let e;for(Z(t,t.dyn_ltree,t.l_desc.max_code),Z(t,t.dyn_dtree,t.d_desc.max_code),R(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*n[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),o=t.opt_len+3+7>>>3,l=t.static_len+3+7>>>3,l<=o&&(o=l)):o=l=a+5,a+4<=o&&-1!==e?D(t,e,a,i):4===t.strategy||l===o?(g(t,2+(i?1:0),3),E(t,s,r)):(g(t,4+(i?1:0),3),((t,e,a,i)=>{let s;for(g(t,e-257,5),g(t,a-1,5),g(t,i-4,4),s=0;s<i;s++)g(t,t.bl_tree[2*n[s]+1],3);U(t,t.dyn_ltree,e-1),U(t,t.dyn_dtree,a-1)})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),E(t,t.dyn_ltree,t.dyn_dtree)),y(t),i&&x(t)},O={_tr_init:t=>{S||((()=>{let t,n,w,m,b;const g=new Array(16);for(w=0,m=0;m<28;m++)for(h[m]=w,t=0;t<1<<e[m];t++)l[w++]=m;for(l[w-1]=m,b=0,m=0;m<16;m++)for(d[m]=b,t=0;t<1<<a[m];t++)o[b++]=m;for(b>>=7;m<30;m++)for(d[m]=b<<7,t=0;t<1<<a[m]-7;t++)o[256+b++]=m;for(n=0;n<=15;n++)g[n]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,g[8]++;for(;t<=255;)s[2*t+1]=9,t++,g[9]++;for(;t<=279;)s[2*t+1]=7,t++,g[7]++;for(;t<=287;)s[2*t+1]=8,t++,g[8]++;for(v(s,287,g),t=0;t<30;t++)r[2*t+1]=5,r[2*t]=k(t,5);f=new _(s,e,257,286,15),c=new _(r,a,0,30,15),u=new _(new Array(0),i,0,19,7)})(),S=!0),t.l_desc=new w(t.dyn_ltree,f),t.d_desc=new w(t.dyn_dtree,c),t.bl_desc=new w(t.bl_tree,u),t.bi_buf=0,t.bi_valid=0,y(t)},_tr_stored_block:D,_tr_flush_block:T,_tr_tally:(t,e,a)=>(t.pending_buf[t.sym_buf+t.sym_next++]=e,t.pending_buf[t.sym_buf+t.sym_next++]=e>>8,t.pending_buf[t.sym_buf+t.sym_next++]=a,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(l[a]+256+1)]++,t.dyn_dtree[2*m(e)]++),t.sym_next===t.sym_end),_tr_align:t=>{g(t,2,3),p(t,256,s),(t=>{16===t.bi_valid?(b(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)})(t)}};var F=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0}while(--r);n%=65521,s%=65521}return n|s<<16|0};const L=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e})());var N=(t,e,a,i)=>{const n=L,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t},I={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},B={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:C,_tr_stored_block:H,_tr_flush_block:M,_tr_tally:j,_tr_align:K}=O,{Z_NO_FLUSH:P,Z_PARTIAL_FLUSH:Y,Z_FULL_FLUSH:G,Z_FINISH:X,Z_BLOCK:W,Z_OK:q,Z_STREAM_END:J,Z_STREAM_ERROR:Q,Z_DATA_ERROR:V,Z_BUF_ERROR:$,Z_DEFAULT_COMPRESSION:tt,Z_FILTERED:et,Z_HUFFMAN_ONLY:at,Z_RLE:it,Z_FIXED:nt,Z_DEFAULT_STRATEGY:st,Z_UNKNOWN:rt,Z_DEFLATED:ot}=B,lt=(t,e)=>(t.msg=I[e],e),ht=t=>2*t-(t>4?9:0),dt=t=>{let e=t.length;for(;--e>=0;)t[e]=0},_t=t=>{let e,a,i,n=t.w_size;e=t.hash_size,i=e;do{a=t.head[--i],t.head[i]=a>=n?a-n:0}while(--e);e=n,i=e;do{a=t.prev[--i],t.prev[i]=a>=n?a-n:0}while(--e)};let ft=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const ct=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},ut=(t,e)=>{M(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,ct(t.strm)},wt=(t,e)=>{t.pending_buf[t.pending++]=e},mt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},bt=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=F(t.adler,e,n,a):2===t.state.wrap&&(t.adler=N(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},gt=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=258-(f-s),s=f-258,i>r){if(t.match_start=e,r=i,i>=o)break;c=h[s+r-1],u=h[s+r]}}}while((e=_[e&d])>l&&0!=--n);return r<=t.lookahead?r:t.lookahead},pt=t=>{const e=t.w_size;let a,i,n;do{if(i=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)&&(t.window.set(t.window.subarray(e,e+e-i),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,t.insert>t.strstart&&(t.insert=t.strstart),_t(t),i+=e),0===t.strm.avail_in)break;if(a=bt(t.strm,t.window,t.strstart+t.lookahead,i),t.lookahead+=a,t.lookahead+t.insert>=3)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=ft(t,t.ins_h,t.window[n+1]);t.insert&&(t.ins_h=ft(t,t.ins_h,t.window[n+3-1]),t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},kt=(t,e)=>{let a,i,n,s=t.pending_buf_size-5>t.w_size?t.w_size:t.pending_buf_size-5,r=0,o=t.strm.avail_in;do{if(a=65535,n=t.bi_valid+42>>3,t.strm.avail_out<n)break;if(n=t.strm.avail_out-n,i=t.strstart-t.block_start,a>i+t.strm.avail_in&&(a=i+t.strm.avail_in),a>n&&(a=n),a<s&&(0===a&&e!==X||e===P||a!==i+t.strm.avail_in))break;r=e===X&&a===i+t.strm.avail_in?1:0,H(t,0,0,r),t.pending_buf[t.pending-4]=a,t.pending_buf[t.pending-3]=a>>8,t.pending_buf[t.pending-2]=~a,t.pending_buf[t.pending-1]=~a>>8,ct(t.strm),i&&(i>a&&(i=a),t.strm.output.set(t.window.subarray(t.block_start,t.block_start+i),t.strm.next_out),t.strm.next_out+=i,t.strm.avail_out-=i,t.strm.total_out+=i,t.block_start+=i,a-=i),a&&(bt(t.strm,t.strm.output,t.strm.next_out,a),t.strm.next_out+=a,t.strm.avail_out-=a,t.strm.total_out+=a)}while(0===r);return o-=t.strm.avail_in,o&&(o>=t.w_size?(t.matches=2,t.window.set(t.strm.input.subarray(t.strm.next_in-t.w_size,t.strm.next_in),0),t.strstart=t.w_size,t.insert=t.strstart):(t.window_size-t.strstart<=o&&(t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,t.insert>t.strstart&&(t.insert=t.strstart)),t.window.set(t.strm.input.subarray(t.strm.next_in-o,t.strm.next_in),t.strstart),t.strstart+=o,t.insert+=o>t.w_size-t.insert?t.w_size-t.insert:o),t.block_start=t.strstart),t.high_water<t.strstart&&(t.high_water=t.strstart),r?4:e!==P&&e!==X&&0===t.strm.avail_in&&t.strstart===t.block_start?2:(n=t.window_size-t.strstart,t.strm.avail_in>n&&t.block_start>=t.w_size&&(t.block_start-=t.w_size,t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,n+=t.w_size,t.insert>t.strstart&&(t.insert=t.strstart)),n>t.strm.avail_in&&(n=t.strm.avail_in),n&&(bt(t.strm,t.window,t.strstart,n),t.strstart+=n,t.insert+=n>t.w_size-t.insert?t.w_size-t.insert:n),t.high_water<t.strstart&&(t.high_water=t.strstart),n=t.bi_valid+42>>3,n=t.pending_buf_size-n>65535?65535:t.pending_buf_size-n,s=n>t.w_size?t.w_size:n,i=t.strstart-t.block_start,(i>=s||(i||e===X)&&e!==P&&0===t.strm.avail_in&&i<=n)&&(a=i>n?n:i,r=e===X&&0===t.strm.avail_in&&a===i?1:0,H(t,t.block_start,a,r),t.block_start+=a,ct(t.strm)),r?3:1)},vt=(t,e)=>{let a,i;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a)),t.match_length>=3)if(i=j(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=ft(t,t.ins_h,t.window[t.strstart+1]);else i=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2},yt=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a),t.match_length<=5&&(t.strategy===et||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=j(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=j(t,0,t.window[t.strstart-1]),i&&ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=j(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2};function xt(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n}const zt=[new xt(0,0,0,0,kt),new xt(4,4,8,4,vt),new xt(4,5,16,8,vt),new xt(4,6,32,32,vt),new xt(4,4,16,16,yt),new xt(8,16,32,32,yt),new xt(8,16,128,128,yt),new xt(8,32,128,256,yt),new xt(32,128,258,1024,yt),new xt(32,258,258,4096,yt)];function At(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ot,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),dt(this.dyn_ltree),dt(this.dyn_dtree),dt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),dt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),dt(this.depth),this.sym_buf=0,this.lit_bufsize=0,this.sym_next=0,this.sym_end=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}const Et=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||42!==e.status&&57!==e.status&&69!==e.status&&73!==e.status&&91!==e.status&&103!==e.status&&113!==e.status&&666!==e.status?1:0},Rt=t=>{if(Et(t))return lt(t,Q);t.total_in=t.total_out=0,t.data_type=rt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=2===e.wrap?57:e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=-2,C(e),q},Zt=t=>{const e=Rt(t);var a;return e===q&&((a=t.state).window_size=2*a.w_size,dt(a.head),a.max_lazy_match=zt[a.level].max_lazy,a.good_match=zt[a.level].good_length,a.nice_match=zt[a.level].nice_length,a.max_chain_length=zt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},Ut=(t,e,a,i,n,s)=>{if(!t)return Q;let r=1;if(e===tt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==ot||i<8||i>15||e<0||e>9||s<0||s>nt||8===i&&1!==r)return lt(t,Q);8===i&&(i=9);const o=new At;return t.state=o,o.strm=t,o.status=42,o.wrap=r,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.sym_buf=o.lit_bufsize,o.sym_end=3*(o.lit_bufsize-1),o.level=e,o.strategy=s,o.method=a,Zt(t)};var St={deflateInit:(t,e)=>Ut(t,e,ot,15,8,st),deflateInit2:Ut,deflateReset:Zt,deflateResetKeep:Rt,deflateSetHeader:(t,e)=>Et(t)||2!==t.state.wrap?Q:(t.state.gzhead=e,q),deflate:(t,e)=>{if(Et(t)||e>W||e<0)return t?lt(t,Q):Q;const a=t.state;if(!t.output||0!==t.avail_in&&!t.input||666===a.status&&e!==X)return lt(t,0===t.avail_out?$:Q);const i=a.last_flush;if(a.last_flush=e,0!==a.pending){if(ct(t),0===t.avail_out)return a.last_flush=-1,q}else if(0===t.avail_in&&ht(e)<=ht(i)&&e!==X)return lt(t,$);if(666===a.status&&0!==t.avail_in)return lt(t,$);if(42===a.status&&0===a.wrap&&(a.status=113),42===a.status){let e=ot+(a.w_bits-8<<4)<<8,i=-1;if(i=a.strategy>=at||a.level<2?0:a.level<6?1:6===a.level?2:3,e|=i<<6,0!==a.strstart&&(e|=32),e+=31-e%31,mt(a,e),0!==a.strstart&&(mt(a,t.adler>>>16),mt(a,65535&t.adler)),t.adler=1,a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(57===a.status)if(t.adler=0,wt(a,31),wt(a,139),wt(a,8),a.gzhead)wt(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(a.gzhead.extra?4:0)+(a.gzhead.name?8:0)+(a.gzhead.comment?16:0)),wt(a,255&a.gzhead.time),wt(a,a.gzhead.time>>8&255),wt(a,a.gzhead.time>>16&255),wt(a,a.gzhead.time>>24&255),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,255&a.gzhead.os),a.gzhead.extra&&a.gzhead.extra.length&&(wt(a,255&a.gzhead.extra.length),wt(a,a.gzhead.extra.length>>8&255)),a.gzhead.hcrc&&(t.adler=N(t.adler,a.pending_buf,a.pending,0)),a.gzindex=0,a.status=69;else if(wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,3),a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q;if(69===a.status){if(a.gzhead.extra){let e=a.pending,i=(65535&a.gzhead.extra.length)-a.gzindex;for(;a.pending+i>a.pending_buf_size;){let n=a.pending_buf_size-a.pending;if(a.pending_buf.set(a.gzhead.extra.subarray(a.gzindex,a.gzindex+n),a.pending),a.pending=a.pending_buf_size,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex+=n,ct(t),0!==a.pending)return a.last_flush=-1,q;e=0,i-=n}let n=new Uint8Array(a.gzhead.extra);a.pending_buf.set(n.subarray(a.gzindex,a.gzindex+i),a.pending),a.pending+=i,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex=0}a.status=73}if(73===a.status){if(a.gzhead.name){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.name.length?255&a.gzhead.name.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),a.gzindex=0}a.status=91}if(91===a.status){if(a.gzhead.comment){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.comment.length?255&a.gzhead.comment.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i))}a.status=103}if(103===a.status){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size&&(ct(t),0!==a.pending))return a.last_flush=-1,q;wt(a,255&t.adler),wt(a,t.adler>>8&255),t.adler=0}if(a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(0!==t.avail_in||0!==a.lookahead||e!==P&&666!==a.status){let i=0===a.level?kt(a,e):a.strategy===at?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(pt(t),0===t.lookahead)){if(e===P)return 1;break}if(t.match_length=0,a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):a.strategy===it?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=258){if(pt(t),t.lookahead<=258&&e===P)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+258;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=258-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=j(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):zt[a.level].func(a,e);if(3!==i&&4!==i||(a.status=666),1===i||3===i)return 0===t.avail_out&&(a.last_flush=-1),q;if(2===i&&(e===Y?K(a):e!==W&&(H(a,0,0,!1),e===G&&(dt(a.head),0===a.lookahead&&(a.strstart=0,a.block_start=0,a.insert=0))),ct(t),0===t.avail_out))return a.last_flush=-1,q}return e!==X?q:a.wrap<=0?J:(2===a.wrap?(wt(a,255&t.adler),wt(a,t.adler>>8&255),wt(a,t.adler>>16&255),wt(a,t.adler>>24&255),wt(a,255&t.total_in),wt(a,t.total_in>>8&255),wt(a,t.total_in>>16&255),wt(a,t.total_in>>24&255)):(mt(a,t.adler>>>16),mt(a,65535&t.adler)),ct(t),a.wrap>0&&(a.wrap=-a.wrap),0!==a.pending?q:J)},deflateEnd:t=>{if(Et(t))return Q;const e=t.state.status;return t.state=null,113===e?lt(t,V):q},deflateSetDictionary:(t,e)=>{let a=e.length;if(Et(t))return Q;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return Q;if(1===n&&(t.adler=F(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(dt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size}const s=t.avail_in,r=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,pt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=ft(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++}while(--e);i.strstart=t,i.lookahead=2,pt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=o,t.avail_in=s,i.wrap=n,q},deflateInfo:"pako deflate (from Nodeca project)"};const Dt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Tt=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Dt(a,e)&&(t[e]=a[e])}}return t},Ot=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length}return a};let Ft=!0;try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){Ft=!1}const Lt=new Uint8Array(256);for(let t=0;t<256;t++)Lt[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Lt[254]=Lt[254]=1;var Nt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,o=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),s=0,n=0;s<o;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},It=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return(new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Lt[e];if(r>4)s[n++]=65533,i+=r-1;else{for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e)}}return((t,e)=>{if(e<65534&&t.subarray&&Ft)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Bt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Lt[t[a]]>e?a:e};var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0};const Ht=Object.prototype.toString,{Z_NO_FLUSH:Mt,Z_SYNC_FLUSH:jt,Z_FULL_FLUSH:Kt,Z_FINISH:Pt,Z_OK:Yt,Z_STREAM_END:Gt,Z_DEFAULT_COMPRESSION:Xt,Z_DEFAULT_STRATEGY:Wt,Z_DEFLATED:qt}=B;function Jt(t){this.options=Tt({level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=St.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Yt)throw new Error(I[a]);if(e.header&&St.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Nt(e.dictionary):"[object ArrayBuffer]"===Ht.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=St.deflateSetDictionary(this.strm,t),a!==Yt)throw new Error(I[a]);this._dict_set=!0}}function Qt(t,e){const a=new Jt(e);if(a.push(t,!0),a.err)throw a.msg||I[a.err];return a.result}Jt.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return!1;for(s=e===~~e?e:!0===e?Pt:Mt,"string"==typeof t?a.input=Nt(t):"[object ArrayBuffer]"===Ht.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===jt||s===Kt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else{if(n=St.deflate(a,s),n===Gt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=St.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Yt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===Yt&&(this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var Vt={Deflate:Jt,deflate:Qt,deflateRaw:function(t,e){return(e=e||{}).raw=!0,Qt(t,e)},gzip:function(t,e){return(e=e||{}).gzip=!0,Qt(t,e)},constants:B};var $t=function(t,e){let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,m=(1<<E.lenbits)-1,b=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=u[f&m];e:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,0===p)A[n++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=u[(65535&g)+(f&(1<<p)-1)];continue e}if(32&p){E.mode=16191;break t}t.msg="invalid literal/length code",E.mode=16209;break t}k=65535&g,p&=15,p&&(c<p&&(f+=z[a++]<<c,c+=8),k+=f&(1<<p)-1,f>>>=p,c-=p),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=w[f&b];a:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,!(16&p)){if(0==(64&p)){g=w[(65535&g)+(f&(1<<p)-1)];continue a}t.msg="invalid distance code",E.mode=16209;break t}if(v=65535&g,p&=15,c<p&&(f+=z[a++]<<c,c+=8,c<p&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<p)-1,v>o){t.msg="invalid distance too far back",E.mode=16209;break t}if(f>>>=p,c-=p,p=n-s,v>p){if(p=v-p,p>h&&E.sane){t.msg="invalid distance too far back",E.mode=16209;break t}if(y=0,x=_,0===d){if(y+=l-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}else if(d<p){if(y+=l+d-p,p-=d,p<k){k-=p;do{A[n++]=_[y++]}while(--p);if(y=0,d<k){p=d,k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}}else if(y+=d-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]))}else{y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]))}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c};const te=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),ee=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ae=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ie=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var ne=(t,e,a,i,n,s,r,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,m=0,b=0,g=0,p=0,k=0,v=0,y=0,x=0,z=0,A=null;const E=new Uint16Array(16),R=new Uint16Array(16);let Z,U,S,D=null;for(w=0;w<=15;w++)E[w]=0;for(m=0;m<i;m++)E[e[a+m]]++;for(p=l,g=15;g>=1&&0===E[g];g--);if(p>g&&(p=g),0===g)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(b=1;b<g&&0===E[b];b++);for(p<b&&(p=b),y=1,w=1;w<=15;w++)if(y<<=1,y-=E[w],y<0)return-1;if(y>0&&(0===t||1!==g))return-1;for(R[1]=0,w=1;w<15;w++)R[w+1]=R[w]+E[w];for(m=0;m<i;m++)0!==e[a+m]&&(r[R[e[a+m]]++]=m);if(0===t?(A=D=r,u=20):1===t?(A=te,D=ee,u=257):(A=ae,D=ie,u=0),z=0,m=0,w=b,c=s,k=p,v=0,_=-1,x=1<<p,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){Z=w-v,r[m]+1<u?(U=0,S=r[m]):r[m]>=u?(U=D[r[m]-u],S=A[r[m]-u]):(U=96,S=0),h=1<<w-v,d=1<<k,b=d;do{d-=h,n[c+(z>>v)+d]=Z<<24|U<<16|S|0}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,m++,0==--E[w]){if(w===g)break;w=e[a+r[m]]}if(w>p&&(z&f)!==_){for(0===v&&(v=p),c+=b,k=w-v,y=1<<k;k+v<g&&(y-=E[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=p<<24|k<<16|c-s|0}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),o.bits=p,0};const{Z_FINISH:se,Z_BLOCK:re,Z_TREES:oe,Z_OK:le,Z_STREAM_END:he,Z_NEED_DICT:de,Z_STREAM_ERROR:_e,Z_DATA_ERROR:fe,Z_MEM_ERROR:ce,Z_BUF_ERROR:ue,Z_DEFLATED:we}=B,me=16209,be=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function ge(){this.strm=null,this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}const pe=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||e.mode<16180||e.mode>16211?1:0},ke=t=>{if(pe(t))return _e;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=16180,e.last=0,e.havedict=0,e.flags=-1,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,le},ve=t=>{if(pe(t))return _e;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,ke(t)},ye=(t,e)=>{let a;if(pe(t))return _e;const i=t.state;return e<0?(a=0,e=-e):(a=5+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?_e:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,ve(t))},xe=(t,e)=>{if(!t)return _e;const a=new ge;t.state=a,a.strm=t,a.window=null,a.mode=16180;const i=ye(t,e);return i!==le&&(t.state=null),i};let ze,Ae,Ee=!0;const Re=t=>{if(Ee){ze=new Int32Array(512),Ae=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(ne(1,t.lens,0,288,ze,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;ne(2,t.lens,0,32,Ae,0,t.work,{bits:5}),Ee=!1}t.lencode=ze,t.lenbits=9,t.distcode=Ae,t.distbits=5},Ze=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Ue={inflateReset:ve,inflateReset2:ye,inflateResetKeep:ke,inflateInit:t=>xe(t,15),inflateInit2:xe,inflate:(t,e)=>{let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(pe(t)||!t.output||!t.input&&0!==t.avail_in)return _e;a=t.state,16191===a.mode&&(a.mode=16192),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=le;t:for(;;)switch(a.mode){case 16180:if(0===a.wrap){a.mode=16192;break}for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(2&a.wrap&&35615===h){0===a.wbits&&(a.wbits=15),a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0),h=0,d=0,a.mode=16181;break}if(a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=me;break}if((15&h)!==we){t.msg="unknown compression method",a.mode=me;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits&&(a.wbits=y),y>15||y>a.wbits){t.msg="invalid window size",a.mode=me;break}a.dmax=1<<a.wbits,a.flags=0,t.adler=a.check=1,a.mode=512&h?16189:16191,h=0,d=0;break;case 16181:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.flags=h,(255&a.flags)!==we){t.msg="unknown compression method",a.mode=me;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=me;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16182;case 16182:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.time=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=N(a.check,A,4,0)),h=0,d=0,a.mode=16183;case 16183:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16184;case 16184:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0}else a.head&&(a.head.extra=null);a.mode=16185;case 16185:if(1024&a.flags&&(c=a.length,c>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=16186;case 16186:if(2048&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=16187;case 16187:if(4096&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=16188;case 16188:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=me;break}h=0,d=0}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=16191;break;case 16189:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}t.adler=a.check=be(h),h=0,d=0,a.mode=16190;case 16190:if(0===a.havedict)return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,de;t.adler=a.check=1,a.mode=16191;case 16191:if(e===re||e===oe)break t;case 16192:if(a.last){h>>>=7&d,d-=7&d,a.mode=16206;break}for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=16193;break;case 1:if(Re(a),a.mode=16199,e===oe){h>>>=2,d-=2;break t}break;case 2:a.mode=16196;break;case 3:t.msg="invalid block type",a.mode=me}h>>>=2,d-=2;break;case 16193:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=me;break}if(a.length=65535&h,h=0,d=0,a.mode=16194,e===oe)break t;case 16194:a.mode=16195;case 16195:if(c=a.length,c){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;n.set(i.subarray(s,s+c),r),o-=c,s+=c,l-=c,r+=c,a.length-=c;break}a.mode=16191;break;case 16196:for(;d<14;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=me;break}a.have=0,a.mode=16197;case 16197:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=ne(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=me;break}a.have=0,a.mode=16198;case 16198:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(g<16)h>>>=m,d-=m,a.lens[a.have++]=g;else{if(16===g){for(R=m+2;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(h>>>=m,d-=m,0===a.have){t.msg="invalid bit length repeat",a.mode=me;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2}else if(17===g){for(R=m+3;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=3+(7&h),h>>>=3,d-=3}else{for(R=m+7;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=11+(127&h),h>>>=7,d-=7}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=me;break}for(;c--;)a.lens[a.have++]=y}}if(a.mode===me)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=me;break}if(a.lenbits=9,E={bits:a.lenbits},x=ne(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=me;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=ne(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=me;break}if(a.mode=16199,e===oe)break t;case 16199:a.mode=16200;case 16200:if(o>=6&&l>=258){t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,$t(t,f),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,16191===a.mode&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(b&&0==(240&b)){for(p=m,k=b,v=g;z=a.lencode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,a.length=g,0===b){a.mode=16205;break}if(32&b){a.back=-1,a.mode=16191;break}if(64&b){t.msg="invalid literal/length code",a.mode=me;break}a.extra=15&b,a.mode=16201;case 16201:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}a.was=a.length,a.mode=16202;case 16202:for(;z=a.distcode[h&(1<<a.distbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(0==(240&b)){for(p=m,k=b,v=g;z=a.distcode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,64&b){t.msg="invalid distance code",a.mode=me;break}a.offset=g,a.extra=15&b,a.mode=16203;case 16203:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=me;break}a.mode=16204;case 16204:if(0===l)break t;if(c=f-l,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=me;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window}else w=n,u=r-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{n[r++]=w[u++]}while(--c);0===a.length&&(a.mode=16200);break;case 16205:if(0===l)break t;n[r++]=a.length,l--,a.mode=16200;break;case 16206:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=i[s++]<<d,d+=8}if(f-=l,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,r-f):F(a.check,n,f,r-f)),f=l,4&a.wrap&&(a.flags?h:be(h))!==a.check){t.msg="incorrect data check",a.mode=me;break}h=0,d=0}a.mode=16207;case 16207:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=me;break}h=0,d=0}a.mode=16208;case 16208:x=he;break t;case me:x=fe;break t;case 16210:return ce;default:return _e}return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<me&&(a.mode<16206||e!==se))&&Ze(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,t.next_out-f):F(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(16191===a.mode?128:0)+(16199===a.mode||16194===a.mode?256:0),(0===_&&0===f||e===se)&&x===le&&(x=ue),x},inflateEnd:t=>{if(pe(t))return _e;let e=t.state;return e.window&&(e.window=null),t.state=null,le},inflateGetHeader:(t,e)=>{if(pe(t))return _e;const a=t.state;return 0==(2&a.wrap)?_e:(a.head=e,e.done=!1,le)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return pe(t)?_e:(i=t.state,0!==i.wrap&&16190!==i.mode?_e:16190===i.mode&&(n=1,n=F(n,e,a,0),n!==i.check)?fe:(s=Ze(t,e,a,a),s?(i.mode=16210,ce):(i.havedict=1,le)))},inflateInfo:"pako inflate (from Nodeca project)"};var Se=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1};const De=Object.prototype.toString,{Z_NO_FLUSH:Te,Z_FINISH:Oe,Z_OK:Fe,Z_STREAM_END:Le,Z_NEED_DICT:Ne,Z_STREAM_ERROR:Ie,Z_DATA_ERROR:Be,Z_MEM_ERROR:Ce}=B;function He(t){this.options=Tt({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Ue.inflateInit2(this.strm,e.windowBits);if(a!==Fe)throw new Error(I[a]);if(this.header=new Se,Ue.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Nt(e.dictionary):"[object ArrayBuffer]"===De.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Ue.inflateSetDictionary(this.strm,e.dictionary),a!==Fe)))throw new Error(I[a])}He.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,o;if(this.ended)return!1;for(r=e===~~e?e:!0===e?Oe:Te,"[object ArrayBuffer]"===De.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Ue.inflate(a,r),s===Ne&&n&&(s=Ue.inflateSetDictionary(a,n),s===Fe?s=Ue.inflate(a,r):s===Be&&(s=Ne));a.avail_in>0&&s===Le&&a.state.wrap>0&&0!==t[a.next_in];)Ue.inflateReset(a),s=Ue.inflate(a,r);switch(s){case Ie:case Be:case Ne:case Ce:return this.onEnd(s),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||s===Le))if("string"===this.options.to){let t=Bt(a.output,a.next_out),e=a.next_out-t,n=It(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n)}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==Fe||0!==o){if(s===Le)return s=Ue.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return!0},He.prototype.onData=function(t){this.chunks.push(t)},He.prototype.onEnd=function(t){t===Fe&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};const{Deflate:Me,deflate:je,deflateRaw:Ke,gzip:Pe}=Vt;var Ye=Me,Ge=je,Xe=B;const We=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const e=this._hasEvents?",":"";this.deflate.push(e+t,Xe.Z_SYNC_FLUSH),this._hasEvents=!0}finish(){if(this.deflate.push("]",Xe.Z_FINISH),this.deflate.err)throw this.deflate.err;const t=this.deflate.result;return this._init(),t}_init(){this._hasEvents=!1,this.deflate=new Ye,this.deflate.push("[",Xe.Z_NO_FLUSH)}},qe={clear:()=>{We.clear()},addEvent:t=>We.addEvent(t),finish:()=>We.finish(),compress:t=>function(t){return Ge(t)}(t)};addEventListener("message",(function(t){const e=t.data.method,a=t.data.id,i=t.data.arg;if(e in qe&&"function"==typeof qe[e])try{const t=qe[e](i);postMessage({id:a,method:e,success:!0,response:t})}catch(t){postMessage({id:a,method:e,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $65bd167596a7c256$var$e() {
    const e = new Blob([
        $65bd167596a7c256$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $65bd167596a7c256$var$logInfo(message, shouldAddBreadcrumb) {
    if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) return;
    (0, $qyIZA.logger).info(message);
    if (shouldAddBreadcrumb) {
        const hub = (0, $dCCRF.getCurrentHub)();
        hub.addBreadcrumb({
            category: 'console',
            data: {
                logger: 'replay'
            },
            level: 'info',
            message: message
        }, {
            level: 'info'
        });
    }
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $65bd167596a7c256$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$65bd167596a7c256$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $65bd167596a7c256$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ constructor(){
        this.events = [];
        this._totalSize = 0;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $65bd167596a7c256$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $65bd167596a7c256$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $65bd167596a7c256$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $65bd167596a7c256$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $65bd167596a7c256$var$logInfo('[Replay] Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay]', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $65bd167596a7c256$var$EventBufferCompressionWorker {
    constructor(worker){
        this._worker = new $65bd167596a7c256$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $65bd167596a7c256$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $65bd167596a7c256$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $65bd167596a7c256$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear');
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $65bd167596a7c256$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $65bd167596a7c256$var$EventBufferArray();
        this._compression = new $65bd167596a7c256$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $65bd167596a7c256$var$logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('[Replay] Failed to add events when switching buffers.', error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $65bd167596a7c256$var$createEventBuffer({ useCompression: useCompression }) {
    // eslint-disable-next-line no-restricted-globals
    if (useCompression && window.Worker) try {
        const workerUrl = $65bd167596a7c256$var$e();
        $65bd167596a7c256$var$logInfo('[Replay] Using compression worker');
        const worker = new Worker(workerUrl);
        return new $65bd167596a7c256$var$EventBufferProxy(worker);
    } catch (error) {
        $65bd167596a7c256$var$logInfo('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
    $65bd167596a7c256$var$logInfo('[Replay] Using simple buffer');
    return new $65bd167596a7c256$var$EventBufferArray();
}
/** If sessionStorage is available. */ function $65bd167596a7c256$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $65bd167596a7c256$var$WINDOW && !!$65bd167596a7c256$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $65bd167596a7c256$var$clearSession(replay) {
    $65bd167596a7c256$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $65bd167596a7c256$var$deleteSession() {
    if (!$65bd167596a7c256$var$hasSessionStorage()) return;
    try {
        $65bd167596a7c256$var$WINDOW.sessionStorage.removeItem($65bd167596a7c256$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $65bd167596a7c256$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $65bd167596a7c256$var$isSessionExpired(session, timeouts, targetTime = +new Date()) {
    return(// First, check that maximum session length has not been exceeded
    $65bd167596a7c256$var$isExpired(session.started, timeouts.maxSessionLife, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $65bd167596a7c256$var$isExpired(session.lastActivity, timeouts.sessionIdleExpire, targetTime));
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $65bd167596a7c256$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function $65bd167596a7c256$var$saveSession(session) {
    if (!$65bd167596a7c256$var$hasSessionStorage()) return;
    try {
        $65bd167596a7c256$var$WINDOW.sessionStorage.setItem($65bd167596a7c256$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function $65bd167596a7c256$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $kRbV8.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const shouldRefresh = typeof session.shouldRefresh === 'boolean' ? session.shouldRefresh : true;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        shouldRefresh: shouldRefresh
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $65bd167596a7c256$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $65bd167596a7c256$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $65bd167596a7c256$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }) {
    const sampled = $65bd167596a7c256$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $65bd167596a7c256$var$makeSession({
        sampled: sampled
    });
    if (stickySession) $65bd167596a7c256$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $65bd167596a7c256$var$fetchSession(traceInternals) {
    if (!$65bd167596a7c256$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $65bd167596a7c256$var$WINDOW.sessionStorage.getItem($65bd167596a7c256$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $65bd167596a7c256$var$logInfo('[Replay] Loading existing session', traceInternals);
        return $65bd167596a7c256$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Get or create a session
 */ function $65bd167596a7c256$var$getSession({ timeouts: timeouts, currentSession: currentSession, stickySession: stickySession, sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, traceInternals: traceInternals }) {
    // If session exists and is passed, use it instead of always hitting session storage
    const session = currentSession || stickySession && $65bd167596a7c256$var$fetchSession(traceInternals);
    if (session) {
        // If there is a session, check if it is valid (e.g. "last activity" time
        // should be within the "session idle time", and "session started" time is
        // within "max session time").
        const isExpired = $65bd167596a7c256$var$isSessionExpired(session, timeouts);
        if (!isExpired || allowBuffering && session.shouldRefresh) return {
            type: 'saved',
            session: session
        };
        else if (!session.shouldRefresh) {
            // This is the case if we have an error session that is completed
            // (=triggered an error). Session will continue as session-based replay,
            // and when this session is expired, it will not be renewed until user
            // reloads.
            const discardedSession = $65bd167596a7c256$var$makeSession({
                sampled: false
            });
            $65bd167596a7c256$var$logInfo('[Replay] Session should not be refreshed', traceInternals);
            return {
                type: 'new',
                session: discardedSession
            };
        } else $65bd167596a7c256$var$logInfo('[Replay] Session has expired', traceInternals);
    // Otherwise continue to create a new session
    }
    const newSession = $65bd167596a7c256$var$createSession({
        stickySession: stickySession,
        sessionSampleRate: sessionSampleRate,
        allowBuffering: allowBuffering
    });
    $65bd167596a7c256$var$logInfo('[Replay] Created new session', traceInternals);
    return {
        type: 'new',
        session: newSession
    };
}
function $65bd167596a7c256$var$isCustomEvent(event) {
    return event.type === $65bd167596a7c256$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ async function $65bd167596a7c256$var$addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) // This implies that `_isEnabled` is false
    return null;
    if (replay.isPaused()) // Do not add to event buffer when recording is paused
    return null;
    const timestampInMs = $65bd167596a7c256$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return null;
    try {
        if (isCheckout) replay.eventBuffer.clear();
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $65bd167596a7c256$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $65bd167596a7c256$var$EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error(error);
        await replay.stop(reason);
        const client = (0, $dCCRF.getCurrentHub)().getClient();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
function $65bd167596a7c256$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $65bd167596a7c256$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $65bd167596a7c256$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $65bd167596a7c256$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $65bd167596a7c256$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $65bd167596a7c256$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $65bd167596a7c256$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$65bd167596a7c256$var$isErrorEvent(event) && !$65bd167596a7c256$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($65bd167596a7c256$var$isTransactionEvent(event)) {
            $65bd167596a7c256$var$handleTransactionEvent(replay, event);
            return;
        }
        $65bd167596a7c256$var$handleErrorEvent(replay, event);
    };
}
function $65bd167596a7c256$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $65bd167596a7c256$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode === 'buffer' && event.tags && event.tags.replayId) setTimeout(()=>{
        // Capture current event buffer as new replay
        replay.sendBufferedReplayOrFlush();
    });
}
function $65bd167596a7c256$var$isBaseTransportSend() {
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $65bd167596a7c256$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-ignore this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    // Check if any exception originates from rrweb
    return event.exception.values.some((exception)=>{
        if (!exception.stacktrace || !exception.stacktrace.frames || !exception.stacktrace.frames.length) return false;
        return exception.stacktrace.frames.some((frame)=>frame.filename && frame.filename.includes('/rrweb/src/'));
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $65bd167596a7c256$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $65bd167596a7c256$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $65bd167596a7c256$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */ function $65bd167596a7c256$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $65bd167596a7c256$var$handleAfterSendEvent(replay) : undefined;
    return (event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($65bd167596a7c256$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors & transactions, nothing else
        if (!$65bd167596a7c256$var$isErrorEvent(event) && !$65bd167596a7c256$var$isTransactionEvent(event)) return event;
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($65bd167596a7c256$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).log('[Replay] Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $65bd167596a7c256$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    };
}
/**
 * Create a "span" for each performance entry.
 */ function $65bd167596a7c256$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $65bd167596a7c256$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $65bd167596a7c256$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */ function $65bd167596a7c256$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $65bd167596a7c256$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $65bd167596a7c256$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $65bd167596a7c256$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) return false;
    return $65bd167596a7c256$var$_isSentryRequest(url);
}
/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */ function $65bd167596a7c256$var$_isSentryRequest(url) {
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    const dsn = client && client.getDsn();
    return dsn ? url.includes(dsn.host) : false;
}
/** Add a performance entry breadcrumb */ function $65bd167596a7c256$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($65bd167596a7c256$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $65bd167596a7c256$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $65bd167596a7c256$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: 'resource.fetch',
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */ function $65bd167596a7c256$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $65bd167596a7c256$var$handleFetch(handlerData);
        $65bd167596a7c256$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $65bd167596a7c256$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $43c97ac4136e5a2d$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: 'resource.xhr',
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */ function $65bd167596a7c256$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $65bd167596a7c256$var$handleXhr(handlerData);
        $65bd167596a7c256$var$addNetworkBreadcrumb(replay, result);
    };
}
const $65bd167596a7c256$var$OBJ = 10;
const $65bd167596a7c256$var$OBJ_KEY = 11;
const $65bd167596a7c256$var$OBJ_KEY_STR = 12;
const $65bd167596a7c256$var$OBJ_VAL = 13;
const $65bd167596a7c256$var$OBJ_VAL_STR = 14;
const $65bd167596a7c256$var$OBJ_VAL_COMPLETED = 15;
const $65bd167596a7c256$var$ARR = 20;
const $65bd167596a7c256$var$ARR_VAL = 21;
const $65bd167596a7c256$var$ARR_VAL_STR = 22;
const $65bd167596a7c256$var$ARR_VAL_COMPLETED = 23;
const $65bd167596a7c256$var$ALLOWED_PRIMITIVES = [
    'true',
    'false',
    'null'
];
/**
 * Complete an incomplete JSON string.
 * This will ensure that the last element always has a `"~~"` to indicate it was truncated.
 * For example, `[1,2,` will be completed to `[1,2,"~~"]`
 * and `{"aa":"b` will be completed to `{"aa":"b~~"}`
 */ function $65bd167596a7c256$var$completeJson(incompleteJson, stack) {
    if (!stack.length) return incompleteJson;
    let json = incompleteJson;
    // Most checks are only needed for the last step in the stack
    const lastPos = stack.length - 1;
    const lastStep = stack[lastPos];
    json = $65bd167596a7c256$var$_fixLastStep(json, lastStep);
    // Complete remaining steps - just add closing brackets
    for(let i = lastPos; i >= 0; i--){
        const step = stack[i];
        switch(step){
            case $65bd167596a7c256$var$OBJ:
                json = `${json}}`;
                break;
            case $65bd167596a7c256$var$ARR:
                json = `${json}]`;
                break;
        }
    }
    return json;
}
function $65bd167596a7c256$var$_fixLastStep(json, lastStep) {
    switch(lastStep){
        // Object cases
        case $65bd167596a7c256$var$OBJ:
            return `${json}"~~":"~~"`;
        case $65bd167596a7c256$var$OBJ_KEY:
            return `${json}:"~~"`;
        case $65bd167596a7c256$var$OBJ_KEY_STR:
            return `${json}~~":"~~"`;
        case $65bd167596a7c256$var$OBJ_VAL:
            return $65bd167596a7c256$var$_maybeFixIncompleteObjValue(json);
        case $65bd167596a7c256$var$OBJ_VAL_STR:
            return `${json}~~"`;
        case $65bd167596a7c256$var$OBJ_VAL_COMPLETED:
            return `${json},"~~":"~~"`;
        // Array cases
        case $65bd167596a7c256$var$ARR:
            return `${json}"~~"`;
        case $65bd167596a7c256$var$ARR_VAL:
            return $65bd167596a7c256$var$_maybeFixIncompleteArrValue(json);
        case $65bd167596a7c256$var$ARR_VAL_STR:
            return `${json}~~"`;
        case $65bd167596a7c256$var$ARR_VAL_COMPLETED:
            return `${json},"~~"`;
    }
    return json;
}
function $65bd167596a7c256$var$_maybeFixIncompleteArrValue(json) {
    const pos = $65bd167596a7c256$var$_findLastArrayDelimiter(json);
    if (pos > -1) {
        const part = json.slice(pos + 1);
        if ($65bd167596a7c256$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~"`;
        // Everything else is replaced with `"~~"`
        return `${json.slice(0, pos + 1)}"~~"`;
    }
    // fallback, this shouldn't happen, to be save
    return json;
}
function $65bd167596a7c256$var$_findLastArrayDelimiter(json) {
    for(let i = json.length - 1; i >= 0; i--){
        const char = json[i];
        if (char === ',' || char === '[') return i;
    }
    return -1;
}
function $65bd167596a7c256$var$_maybeFixIncompleteObjValue(json) {
    const startPos = json.lastIndexOf(':');
    const part = json.slice(startPos + 1);
    if ($65bd167596a7c256$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~":"~~"`;
    // Everything else is replaced with `"~~"`
    // This also means we do not have incomplete numbers, e.g `[1` is replaced with `["~~"]`
    return `${json.slice(0, startPos + 1)}"~~"`;
}
/**
 * Evaluate an (incomplete) JSON string.
 */ function $65bd167596a7c256$var$evaluateJson(json) {
    const stack = [];
    for(let pos = 0; pos < json.length; pos++)$65bd167596a7c256$var$_evaluateJsonPos(stack, json, pos);
    return stack;
}
function $65bd167596a7c256$var$_evaluateJsonPos(stack, json, pos) {
    const curStep = stack[stack.length - 1];
    const char = json[pos];
    const whitespaceRegex = /\s/;
    if (whitespaceRegex.test(char)) return;
    if (char === '"' && !$65bd167596a7c256$var$_isEscaped(json, pos)) {
        $65bd167596a7c256$var$_handleQuote(stack, curStep);
        return;
    }
    switch(char){
        case '{':
            $65bd167596a7c256$var$_handleObj(stack, curStep);
            break;
        case '[':
            $65bd167596a7c256$var$_handleArr(stack, curStep);
            break;
        case ':':
            $65bd167596a7c256$var$_handleColon(stack, curStep);
            break;
        case ',':
            $65bd167596a7c256$var$_handleComma(stack, curStep);
            break;
        case '}':
            $65bd167596a7c256$var$_handleObjClose(stack, curStep);
            break;
        case ']':
            $65bd167596a7c256$var$_handleArrClose(stack, curStep);
            break;
    }
}
function $65bd167596a7c256$var$_handleQuote(stack, curStep) {
    // End of obj value
    if (curStep === $65bd167596a7c256$var$OBJ_VAL_STR) {
        stack.pop();
        stack.push($65bd167596a7c256$var$OBJ_VAL_COMPLETED);
        return;
    }
    // End of arr value
    if (curStep === $65bd167596a7c256$var$ARR_VAL_STR) {
        stack.pop();
        stack.push($65bd167596a7c256$var$ARR_VAL_COMPLETED);
        return;
    }
    // Start of obj value
    if (curStep === $65bd167596a7c256$var$OBJ_VAL) {
        stack.push($65bd167596a7c256$var$OBJ_VAL_STR);
        return;
    }
    // Start of arr value
    if (curStep === $65bd167596a7c256$var$ARR_VAL) {
        stack.push($65bd167596a7c256$var$ARR_VAL_STR);
        return;
    }
    // Start of obj key
    if (curStep === $65bd167596a7c256$var$OBJ) {
        stack.push($65bd167596a7c256$var$OBJ_KEY_STR);
        return;
    }
    // End of obj key
    if (curStep === $65bd167596a7c256$var$OBJ_KEY_STR) {
        stack.pop();
        stack.push($65bd167596a7c256$var$OBJ_KEY);
        return;
    }
}
function $65bd167596a7c256$var$_handleObj(stack, curStep) {
    // Initial object
    if (!curStep) {
        stack.push($65bd167596a7c256$var$OBJ);
        return;
    }
    // New object as obj value
    if (curStep === $65bd167596a7c256$var$OBJ_VAL) {
        stack.push($65bd167596a7c256$var$OBJ);
        return;
    }
    // New object as array element
    if (curStep === $65bd167596a7c256$var$ARR_VAL) stack.push($65bd167596a7c256$var$OBJ);
    // New object as first array element
    if (curStep === $65bd167596a7c256$var$ARR) {
        stack.push($65bd167596a7c256$var$OBJ);
        return;
    }
}
function $65bd167596a7c256$var$_handleArr(stack, curStep) {
    // Initial array
    if (!curStep) {
        stack.push($65bd167596a7c256$var$ARR);
        stack.push($65bd167596a7c256$var$ARR_VAL);
        return;
    }
    // New array as obj value
    if (curStep === $65bd167596a7c256$var$OBJ_VAL) {
        stack.push($65bd167596a7c256$var$ARR);
        stack.push($65bd167596a7c256$var$ARR_VAL);
        return;
    }
    // New array as array element
    if (curStep === $65bd167596a7c256$var$ARR_VAL) {
        stack.push($65bd167596a7c256$var$ARR);
        stack.push($65bd167596a7c256$var$ARR_VAL);
    }
    // New array as first array element
    if (curStep === $65bd167596a7c256$var$ARR) {
        stack.push($65bd167596a7c256$var$ARR);
        stack.push($65bd167596a7c256$var$ARR_VAL);
        return;
    }
}
function $65bd167596a7c256$var$_handleColon(stack, curStep) {
    if (curStep === $65bd167596a7c256$var$OBJ_KEY) {
        stack.pop();
        stack.push($65bd167596a7c256$var$OBJ_VAL);
    }
}
function $65bd167596a7c256$var$_handleComma(stack, curStep) {
    // Comma after obj value
    if (curStep === $65bd167596a7c256$var$OBJ_VAL) {
        stack.pop();
        return;
    }
    if (curStep === $65bd167596a7c256$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED & OBJ_VAL
        stack.pop();
        stack.pop();
        return;
    }
    // Comma after arr value
    if (curStep === $65bd167596a7c256$var$ARR_VAL) // do nothing - basically we'd pop ARR_VAL but add it right back
    return;
    if (curStep === $65bd167596a7c256$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED
        stack.pop();
        // basically we'd pop ARR_VAL but add it right back
        return;
    }
}
function $65bd167596a7c256$var$_handleObjClose(stack, curStep) {
    // Empty object {}
    if (curStep === $65bd167596a7c256$var$OBJ) stack.pop();
    // Object with element
    if (curStep === $65bd167596a7c256$var$OBJ_VAL) {
        // Pop OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
    }
    // Obj with element
    if (curStep === $65bd167596a7c256$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED, OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $65bd167596a7c256$var$OBJ_VAL) stack.push($65bd167596a7c256$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $65bd167596a7c256$var$ARR_VAL) stack.push($65bd167596a7c256$var$ARR_VAL_COMPLETED);
}
function $65bd167596a7c256$var$_handleArrClose(stack, curStep) {
    // Empty array []
    if (curStep === $65bd167596a7c256$var$ARR) stack.pop();
    // Array with element
    if (curStep === $65bd167596a7c256$var$ARR_VAL) {
        // Pop ARR_VAL, ARR
        stack.pop();
        stack.pop();
    }
    // Array with element
    if (curStep === $65bd167596a7c256$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED, ARR_VAL, ARR
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $65bd167596a7c256$var$OBJ_VAL) stack.push($65bd167596a7c256$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $65bd167596a7c256$var$ARR_VAL) stack.push($65bd167596a7c256$var$ARR_VAL_COMPLETED);
}
function $65bd167596a7c256$var$_isEscaped(str, pos) {
    const previousChar = str[pos - 1];
    return previousChar === '\\' && !$65bd167596a7c256$var$_isEscaped(str, pos - 1);
}
/* eslint-disable max-lines */ /**
 * Takes an incomplete JSON string, and returns a hopefully valid JSON string.
 * Note that this _can_ fail, so you should check the return value is valid JSON.
 */ function $65bd167596a7c256$var$fixJson(incompleteJson) {
    const stack = $65bd167596a7c256$var$evaluateJson(incompleteJson);
    return $65bd167596a7c256$var$completeJson(incompleteJson, stack);
}
/** Get the size of a body. */ function $65bd167596a7c256$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $65bd167596a7c256$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $65bd167596a7c256$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $65bd167596a7c256$var$getBodyString(body) {
    if (typeof body === 'string') return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (body instanceof FormData) return $65bd167596a7c256$var$_serializeFormData(body);
    return undefined;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $65bd167596a7c256$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $9rzL4.dropUndefinedKeys)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $65bd167596a7c256$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $65bd167596a7c256$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $65bd167596a7c256$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $65bd167596a7c256$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $65bd167596a7c256$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-ignore passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $65bd167596a7c256$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body,
        warnings: []
    };
    const exceedsSizeLimit = body.length > $65bd167596a7c256$var$NETWORK_BODY_MAX_SIZE;
    if ($65bd167596a7c256$var$_strIsProbablyJson(body)) try {
        const json = exceedsSizeLimit ? $65bd167596a7c256$var$fixJson(body.slice(0, $65bd167596a7c256$var$NETWORK_BODY_MAX_SIZE)) : body;
        const normalizedBody = JSON.parse(json);
        return {
            body: normalizedBody,
            warnings: exceedsSizeLimit ? [
                'JSON_TRUNCATED'
            ] : []
        };
    } catch (e3) {
        return {
            body: exceedsSizeLimit ? `${body.slice(0, $65bd167596a7c256$var$NETWORK_BODY_MAX_SIZE)}\u{2026}` : body,
            warnings: exceedsSizeLimit ? [
                'INVALID_JSON',
                'TEXT_TRUNCATED'
            ] : [
                'INVALID_JSON'
            ]
        };
    }
    return {
        body: exceedsSizeLimit ? `${body.slice(0, $65bd167596a7c256$var$NETWORK_BODY_MAX_SIZE)}\u{2026}` : body,
        warnings: exceedsSizeLimit ? [
            'TEXT_TRUNCATED'
        ] : []
    };
}
function $65bd167596a7c256$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $65bd167596a7c256$var$urlMatches(url, urls) {
    const fullUrl = $65bd167596a7c256$var$getFullUrl(url);
    return (0, $hnodz.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function $65bd167596a7c256$var$getFullUrl(url, baseURI = $65bd167596a7c256$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($65bd167596a7c256$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $65bd167596a7c256$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $65bd167596a7c256$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $65bd167596a7c256$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $65bd167596a7c256$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $65bd167596a7c256$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = $65bd167596a7c256$var$_getFetchRequestArgBody(input);
    const reqSize = $65bd167596a7c256$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $65bd167596a7c256$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $65bd167596a7c256$var$_prepareFetchData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $65bd167596a7c256$var$urlMatches(url, options.networkDetailAllowUrls) && !$65bd167596a7c256$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $65bd167596a7c256$var$_getRequestInfo(options, hint.input, requestBodySize) : $65bd167596a7c256$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $65bd167596a7c256$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $65bd167596a7c256$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = $65bd167596a7c256$var$getRequestHeaders(input, networkRequestHeaders);
    if (!networkCaptureBodies) return $65bd167596a7c256$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $65bd167596a7c256$var$_getFetchRequestArgBody(input);
    const bodyStr = $65bd167596a7c256$var$getBodyString(requestBody);
    return $65bd167596a7c256$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
}
async function $65bd167596a7c256$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $65bd167596a7c256$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = $65bd167596a7c256$var$getAllHeaders(response.headers, networkResponseHeaders);
    if (!networkCaptureBodies && responseBodySize !== undefined) return $65bd167596a7c256$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    // Only clone the response if we need to
    try {
        // We have to clone this, as the body can only be read once
        const res = response.clone();
        const bodyText = await $65bd167596a7c256$var$_parseFetchBody(res);
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $65bd167596a7c256$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $65bd167596a7c256$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $65bd167596a7c256$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $65bd167596a7c256$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (e) {
        // fallback
        return $65bd167596a7c256$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $65bd167596a7c256$var$_parseFetchBody(response) {
    try {
        return await response.text();
    } catch (e2) {
        return undefined;
    }
}
function $65bd167596a7c256$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $65bd167596a7c256$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $65bd167596a7c256$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $65bd167596a7c256$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $65bd167596a7c256$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $65bd167596a7c256$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $65bd167596a7c256$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $65bd167596a7c256$var$getAllowedHeaders(headers, allowedHeaders);
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $65bd167596a7c256$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $65bd167596a7c256$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $65bd167596a7c256$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $65bd167596a7c256$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $65bd167596a7c256$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    const reqSize = $65bd167596a7c256$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader('content-length') ? $65bd167596a7c256$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $65bd167596a7c256$var$getBodySize(xhr.response, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $65bd167596a7c256$var$_prepareXhrData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!$65bd167596a7c256$var$urlMatches(url, options.networkDetailAllowUrls) || $65bd167596a7c256$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $65bd167596a7c256$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $65bd167596a7c256$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $43c97ac4136e5a2d$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $65bd167596a7c256$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $65bd167596a7c256$var$getAllowedHeaders($65bd167596a7c256$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const request = $65bd167596a7c256$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, options.networkCaptureBodies ? $65bd167596a7c256$var$getBodyString(input) : undefined);
    const response = $65bd167596a7c256$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, options.networkCaptureBodies ? hint.xhr.responseText : undefined);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $65bd167596a7c256$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $65bd167596a7c256$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$65bd167596a7c256$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('fetch', $65bd167596a7c256$var$handleFetchSpanListener(replay));
            (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('xhr', $65bd167596a7c256$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $65bd167596a7c256$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($65bd167596a7c256$var$_isXhrBreadcrumb(breadcrumb) && $65bd167596a7c256$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $65bd167596a7c256$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            $65bd167596a7c256$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($65bd167596a7c256$var$_isFetchBreadcrumb(breadcrumb) && $65bd167596a7c256$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $65bd167596a7c256$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            $65bd167596a7c256$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('Error when enriching network breadcrumb');
    }
}
function $65bd167596a7c256$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $65bd167596a7c256$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $65bd167596a7c256$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $65bd167596a7c256$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $65bd167596a7c256$var$_LAST_BREADCRUMB = null;
function $65bd167596a7c256$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $65bd167596a7c256$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $65bd167596a7c256$var$handleScope(scope);
        if (!result) return;
        $65bd167596a7c256$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $65bd167596a7c256$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($65bd167596a7c256$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $65bd167596a7c256$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$65bd167596a7c256$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        'fetch',
        'xhr',
        'sentry.event',
        'sentry.transaction'
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith('ui.')) return null;
    if (newBreadcrumb.category === 'console') return $65bd167596a7c256$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $65bd167596a7c256$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $65bd167596a7c256$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $65bd167596a7c256$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $65bd167596a7c256$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $65bd167596a7c256$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $e98b9d0181527907$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $65bd167596a7c256$var$CONSOLE_ARG_MAX_SIZE) {
                const fixedJson = $65bd167596a7c256$var$fixJson(stringified.slice(0, $65bd167596a7c256$var$CONSOLE_ARG_MAX_SIZE));
                const json = JSON.parse(fixedJson);
                // We only set this after JSON.parse() was successfull, so we know we didn't run into `catch`
                isTruncated = true;
                return json;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $65bd167596a7c256$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $65bd167596a7c256$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $dCCRF.getCurrentHub)().getScope();
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    if (scope) scope.addScopeListener($65bd167596a7c256$var$handleScopeListener(replay));
    (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('dom', $65bd167596a7c256$var$handleDomListener(replay));
    (0, $43c97ac4136e5a2d$export$285b9172a3741fb7)('history', $65bd167596a7c256$var$handleHistorySpanListener(replay));
    $65bd167596a7c256$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    (0, $7bmu9.addGlobalEventProcessor)($65bd167596a7c256$var$handleGlobalEventListener(replay, !$65bd167596a7c256$var$hasHooks(client)));
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($65bd167596a7c256$var$hasHooks(client)) {
        client.on('afterSendEvent', $65bd167596a7c256$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') dsc.replay_id = replayId;
        });
        client.on('startTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on('finishTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $65bd167596a7c256$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $65bd167596a7c256$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($65bd167596a7c256$var$createPerformanceSpans(replay, [
            // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $65bd167596a7c256$var$createMemoryEntry($65bd167596a7c256$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $65bd167596a7c256$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
// Map entryType -> function to normalize data for event
// @ts-ignore TODO: entry type does not fit the create* functions entry type
const $65bd167596a7c256$var$ENTRY_TYPES = {
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    resource: $65bd167596a7c256$var$createResourceEntry,
    paint: $65bd167596a7c256$var$createPaintEntry,
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    navigation: $65bd167596a7c256$var$createNavigationEntry,
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    ['largest-contentful-paint']: $65bd167596a7c256$var$createLargestContentfulPaint
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $65bd167596a7c256$var$createPerformanceEntries(entries) {
    return entries.map($65bd167596a7c256$var$createPerformanceEntry).filter(Boolean);
}
function $65bd167596a7c256$var$createPerformanceEntry(entry) {
    if ($65bd167596a7c256$var$ENTRY_TYPES[entry.entryType] === undefined) return null;
    return $65bd167596a7c256$var$ENTRY_TYPES[entry.entryType](entry);
}
function $65bd167596a7c256$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $j2xvW.browserPerformanceTimeOrigin) || $65bd167596a7c256$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $65bd167596a7c256$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $65bd167596a7c256$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $65bd167596a7c256$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $65bd167596a7c256$var$getAbsoluteTime(startTime),
        end: $65bd167596a7c256$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $65bd167596a7c256$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $65bd167596a7c256$var$getAbsoluteTime(startTime),
        end: $65bd167596a7c256$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $65bd167596a7c256$var$createLargestContentfulPaint(entry) {
    const { entryType: entryType, startTime: startTime, size: size } = entry;
    let startTimeOrNavigationActivation = 0;
    if ($65bd167596a7c256$var$WINDOW.performance) {
        const navEntry = $65bd167596a7c256$var$WINDOW.performance.getEntriesByType('navigation')[0];
        // See https://github.com/GoogleChrome/web-vitals/blob/9f11c4c6578fb4c5ee6fa4e32b9d1d756475f135/src/lib/getActivationStart.ts#L21
        startTimeOrNavigationActivation = navEntry && navEntry.activationStart || 0;
    }
    // value is in ms
    const value = Math.max(startTime - startTimeOrNavigationActivation, 0);
    // LCP doesn't have a "duration", it just happens at a single point in time.
    // But the UI expects both, so use end (in seconds) for both timestamps.
    const end = $65bd167596a7c256$var$getAbsoluteTime(startTimeOrNavigationActivation) + value / 1000;
    return {
        type: entryType,
        name: entryType,
        start: end,
        end: end,
        data: {
            value: value,
            size: size,
            // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            nodeId: $65bd167596a7c256$var$record.mirror.getId(entry.element)
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $65bd167596a7c256$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $65bd167596a7c256$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).warn('[Replay] Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // We need to clear existing events on a checkout, otherwise they are
            // incremental event updates and should be appended
            $65bd167596a7c256$var$addEvent(replay, event, isCheckout);
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $65bd167596a7c256$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $65bd167596a7c256$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $65bd167596a7c256$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $65bd167596a7c256$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $65bd167596a7c256$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $65bd167596a7c256$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return Promise.resolve(null);
    return $65bd167596a7c256$var$addEvent(replay, $65bd167596a7c256$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $65bd167596a7c256$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $18e31cfb89f28a11$export$f93f7f385160c44e)((0, $18e31cfb89f28a11$export$92b6093782fe661b)(replayEvent, (0, $18e31cfb89f28a11$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $65bd167596a7c256$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $65bd167596a7c256$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const preparedEvent = await (0, $29e2395a75236266$export$2d67fb380bd11267)(client.getOptions(), event, {
        event_id: event_id,
        integrations: integrations
    }, scope);
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $65bd167596a7c256$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $65bd167596a7c256$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const hub = (0, $dCCRF.getCurrentHub)();
    const client = hub.getClient();
    const scope = hub.getScope();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $65bd167596a7c256$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $65bd167596a7c256$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        $65bd167596a7c256$var$logInfo('An event processor returned `null`, will not send event.');
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $65bd167596a7c256$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($65bd167596a7c256$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-ignore This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $65bd167596a7c256$var$TransportStatusCodeError(response.statusCode);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $65bd167596a7c256$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $65bd167596a7c256$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $65bd167596a7c256$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $65bd167596a7c256$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $65bd167596a7c256$var$TransportStatusCodeError) throw err;
        // Capture error for every failed replay
        (0, $7Ff5S.setContext)('Replays', {
            _retryCount: retryConfig.count
        });
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) (0, $7Ff5S.captureException)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $65bd167596a7c256$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$65bd167596a7c256$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-ignore This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $65bd167596a7c256$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $65bd167596a7c256$var$THROTTLED = '__THROTTLED';
const $65bd167596a7c256$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $65bd167596a7c256$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $65bd167596a7c256$var$SKIPPED : $65bd167596a7c256$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $65bd167596a7c256$var$ReplayContainer {
    /**
   * List of PerformanceEntry from PerformanceObserver
   */ /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $65bd167596a7c256$var$ReplayContainer.prototype.__init.call(this);
        $65bd167596a7c256$var$ReplayContainer.prototype.__init2.call(this);
        $65bd167596a7c256$var$ReplayContainer.prototype.__init3.call(this);
        $65bd167596a7c256$var$ReplayContainer.prototype.__init4.call(this);
        $65bd167596a7c256$var$ReplayContainer.prototype.__init5.call(this);
        $65bd167596a7c256$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEvents = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $65bd167596a7c256$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $65bd167596a7c256$var$SESSION_IDLE_EXPIRE_DURATION,
            maxSessionLife: $65bd167596a7c256$var$MAX_SESSION_LIFE
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $65bd167596a7c256$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $65bd167596a7c256$var$throttle((event, isCheckout)=>$65bd167596a7c256$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($65bd167596a7c256$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $65bd167596a7c256$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $65bd167596a7c256$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling() {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        const isSessionSampled = this._loadAndCheckSession();
        if (!isSessionSampled) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled && this.session.sampled !== 'session') // If not sampled as session-based, then recording mode will be `buffer`
        // Note that we don't explicitly check if `sampled === 'buffer'` because we
        // could have sessions from Session storage that are still `error` from
        // prior SDK version.
        this.recordingMode = 'buffer';
        $65bd167596a7c256$var$logInfo(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') throw new Error('Replay recording is already in progress');
        if (this._isEnabled && this.recordingMode === 'buffer') throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
        $65bd167596a7c256$var$logInfo('[Replay] Starting replay in session mode', this._options._experiments.traceInternals);
        const previousSessionId = this.session && this.session.id;
        const { session: session } = $65bd167596a7c256$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false,
            traceInternals: this._options._experiments.traceInternals
        });
        session.previousSessionId = previousSessionId;
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error('Replay recording is already in progress');
        $65bd167596a7c256$var$logInfo('[Replay] Starting replay in buffer mode', this._options._experiments.traceInternals);
        const previousSessionId = this.session && this.session.id;
        const { session: session } = $65bd167596a7c256$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            sessionSampleRate: 0,
            allowBuffering: true,
            traceInternals: this._options._experiments.traceInternals
        });
        session.previousSessionId = previousSessionId;
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            this._stopRecording = $65bd167596a7c256$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' && {
                    checkoutEveryNms: $65bd167596a7c256$var$BUFFER_CHECKOUT_TIME
                },
                emit: $65bd167596a7c256$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop(reason) {
        if (!this._isEnabled) return;
        try {
            $65bd167596a7c256$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`, this._options._experiments.traceInternals);
            // We can't move `_isEnabled` after awaiting a flush, otherwise we can
            // enter into an infinite loop when `stop()` is called while flushing.
            this._isEnabled = false;
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (this.recordingMode === 'session') await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $65bd167596a7c256$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $65bd167596a7c256$var$logInfo('[Replay] Pausing replay', this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._loadAndCheckSession()) return;
        this._isPaused = false;
        this.startRecording();
        $65bd167596a7c256$var$logInfo('[Replay] Resuming replay', this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $65bd167596a7c256$var$logInfo('[Replay] Converting buffer to session', this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this.session.shouldRefresh = false;
            // It's possible that the session lifespan is > max session lifespan
            // because we have been buffering beyond max session lifespan (we ignore
            // expiration given that `shouldRefresh` is true). Since we flip
            // `shouldRefresh`, the session could be considered expired due to
            // lifespan, which is not what we want. Update session start date to be
            // the current timestamp, so that session is not considered to be
            // expired. This means that max replay duration can be MAX_SESSION_LIFE +
            // (length of buffer), which we are ok with.
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._loadAndCheckSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        const oldSessionId = this.getSessionId();
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $65bd167596a7c256$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._loadAndCheckSession()) return;
        // Session was expired if session ids do not match
        const expired = oldSessionId !== this.getSessionId();
        if (!expired) return true;
        // Session is expired, trigger a full snapshot (which will create a new session)
        this._triggerFullSnapshot();
        return false;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$65bd167596a7c256$var$WINDOW.location.pathname}${$65bd167596a7c256$var$WINDOW.location.hash}${$65bd167596a7c256$var$WINDOW.location.search}`;
        const url = `${$65bd167596a7c256$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEvents = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $65bd167596a7c256$var$THROTTLED) {
            const breadcrumb = $65bd167596a7c256$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                $65bd167596a7c256$var$addEvent(this, {
                    type: $65bd167596a7c256$var$EventType.Custom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastTransaction = this.lastTransaction || (0, $dCCRF.getCurrentHub)().getScope().getTransaction();
        if (!lastTransaction || ![
            'route',
            'custom'
        ].includes(lastTransaction.metadata.source)) return undefined;
        return lastTransaction.name;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $65bd167596a7c256$var$createEventBuffer({
            useCompression: this._options.useCompression
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay]', error);
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) (0, $7Ff5S.captureException)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   * Returns false if session is not recorded.
   */ _loadAndCheckSession() {
        const { type: type, session: session } = $65bd167596a7c256$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: this._options.errorSampleRate > 0 || this.recordingMode === 'buffer',
            traceInternals: this._options._experiments.traceInternals
        });
        // If session was newly created (i.e. was not loaded from storage), then
        // enable flag to create the root replay
        if (type === 'new') this.setInitialState();
        const currentSessionId = this.getSessionId();
        if (session.id !== currentSessionId) session.previousSessionId = currentSessionId;
        this.session = session;
        if (!this.session.sampled) {
            this.stop('session not refreshed');
            return false;
        }
        return true;
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $65bd167596a7c256$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $65bd167596a7c256$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $65bd167596a7c256$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $65bd167596a7c256$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $65bd167596a7c256$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        // PerformanceObserver //
        if (!('PerformanceObserver' in $65bd167596a7c256$var$WINDOW)) return;
        this._performanceObserver = $65bd167596a7c256$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $65bd167596a7c256$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $65bd167596a7c256$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $65bd167596a7c256$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $65bd167596a7c256$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceObserver) {
                this._performanceObserver.disconnect();
                this._performanceObserver = undefined;
            }
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($65bd167596a7c256$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $65bd167596a7c256$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $65bd167596a7c256$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $65bd167596a7c256$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $65bd167596a7c256$var$isSessionExpired(this.session, this.timeouts);
        if (breadcrumb && !expired) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $65bd167596a7c256$var$logInfo('[Replay] Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Trigger rrweb to take a full snapshot which will cause this plugin to
   * create a new Replay event.
   */ _triggerFullSnapshot(checkout = true) {
        try {
            $65bd167596a7c256$var$logInfo('[Replay] Taking full rrweb snapshot');
            $65bd167596a7c256$var$record.takeFullSnapshot(checkout);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            this.throttledAddEvent({
                type: $65bd167596a7c256$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEvents`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        // Copy and reset entries before processing
        const entries = [
            ...this.performanceEvents
        ];
        this.performanceEvents = [];
        return Promise.all($65bd167596a7c256$var$createPerformanceSpans(this, $65bd167596a7c256$var$createPerformanceEntries(entries)));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        if (!this.session || !this.eventBuffer) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay] No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $65bd167596a7c256$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            // NOTE: Copy values from instance members, as it's possible they could
            // change before the flush finishes.
            const replayId = this.session.id;
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            await $65bd167596a7c256$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: Date.now()
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            this.stop('sendReplay');
            const client = (0, $dCCRF.getCurrentHub)().getClient();
            if (client) client.recordDroppedEvent('send_error', 'replay');
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay] Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error('[Replay] No session found to flush.');
                return;
            }
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // If session is too short, or too long (allow some wiggle room over maxSessionLife), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this.timeouts.maxSessionLife + 5000;
            if (tooShort || tooLong) {
                $65bd167596a7c256$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`);
                if (tooShort) this._debouncedFlush();
                return;
            }
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $qyIZA.logger).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $65bd167596a7c256$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $65bd167596a7c256$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                this.stop('mutationLimit');
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $65bd167596a7c256$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== 'undefined') {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === 'string') allSelectors.push(`.${deprecatedClassOption}`);
        // eslint-disable-next-line no-console
        console.warn('[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.');
    }
    return allSelectors.join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $65bd167596a7c256$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $65bd167596a7c256$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $65bd167596a7c256$var$getOption(unmask, [
        '.sentry-unmask',
        '[data-sentry-unmask]'
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        maskInputSelector: maskSelector,
        unmaskInputSelector: unmaskSelector,
        blockSelector: $65bd167596a7c256$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $65bd167596a7c256$var$getOption(unblock, [
            '.sentry-unblock',
            '[data-sentry-unblock]'
        ]),
        ignoreSelector: $65bd167596a7c256$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Returns true if we are in the browser.
 */ function $65bd167596a7c256$var$isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $eJSQB.isNodeEnv)() || $65bd167596a7c256$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $65bd167596a7c256$var$isElectronNodeRenderer() {
    return false;
}
const $65bd167596a7c256$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $65bd167596a7c256$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $65bd167596a7c256$var$_initialized = false;
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 */ class $65bd167596a7c256$export$a35c789ed37ee0f7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $65bd167596a7c256$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $65bd167596a7c256$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $65bd167596a7c256$var$MIN_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        this.name = $65bd167596a7c256$export$a35c789ed37ee0f7.id;
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            ...$65bd167596a7c256$var$getPrivacyOptions({
                mask: mask,
                unmask: unmask,
                block: block,
                unblock: unblock,
                ignore: ignore,
                blockClass: blockClass,
                blockSelector: blockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                ignoreClass: ignoreClass
            }),
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $65bd167596a7c256$var$MIN_REPLAY_DURATION_LIMIT),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $65bd167596a7c256$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $65bd167596a7c256$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $65bd167596a7c256$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$65bd167596a7c256$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && $65bd167596a7c256$var$isBrowser()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $65bd167596a7c256$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $65bd167596a7c256$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!$65bd167596a7c256$var$isBrowser()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop();
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $65bd167596a7c256$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $65bd167596a7c256$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
}
$65bd167596a7c256$export$a35c789ed37ee0f7.__initStatic();
/** Parse Replay-related options from SDK options */ function $65bd167596a7c256$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $dCCRF.getCurrentHub)().getClient();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $9rzL4.dropUndefinedKeys)(initialOptions)
    };
    if (!opt) {
        // eslint-disable-next-line no-console
        console.warn('SDK client is not available.');
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) // eslint-disable-next-line no-console
    console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    if (typeof opt.replaysSessionSampleRate === 'number') finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === 'number') finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $65bd167596a7c256$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$65bd167596a7c256$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}


$bcf1d3eaaf7e3f77$export$2cd8252107eb640b({
    dsn: 'https://61bcb8a99f3544a382f911e2d3d0ab13@o1223220.ingest.sentry.io/4504196427874304',
    environment: "prod-usa",
    release: "fa7640124d21ecb0fca543bb30235b99f34db83c",
    ignoreErrors: [
        "TypeError: Cannot read properties of undefined (reading 'x')"
    ],
    enabled: true,
    integrations: [
        new $e83cae840e4c5fa0$export$46d3bbd0375f5fa4(),
        new $65bd167596a7c256$export$a35c789ed37ee0f7()
    ],
    sampleRate: Number("0.05") || 0.01,
    tracesSampleRate: Number("0.01") || 0.001,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.001
});


//# sourceMappingURL=a-shoot.6236129e.js.map
